"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[6047],{

/***/ 9175:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"notifications":"M8IYRB"});

/***/ }),

/***/ 22406:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.error.to-string.js
var es_error_to_string = __webpack_require__(86011);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.date.to-string.js
var es_date_to_string = __webpack_require__(45942);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(61737);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.date.now.js
var es_date_now = __webpack_require__(25503);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(55499);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
;// CONCATENATED MODULE: ./src/styles/critical.css
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/client.js
var client = __webpack_require__(78520);
// EXTERNAL MODULE: ../../node_modules/.pnpm/smoothscroll-polyfill@0.4.4/node_modules/smoothscroll-polyfill/dist/smoothscroll.js
var smoothscroll = __webpack_require__(79619);
var smoothscroll_default = /*#__PURE__*/__webpack_require__.n(smoothscroll);
// EXTERNAL MODULE: ./local_modules/config/index.ts
var config = __webpack_require__(1655);
// EXTERNAL MODULE: ./local_modules/intl/IntlProvider.tsx + 8 modules
var IntlProvider = __webpack_require__(28637);
// EXTERNAL MODULE: ./local_modules/device/Provider/index.ts
var Provider = __webpack_require__(58202);
// EXTERNAL MODULE: ./local_modules/logger/index.ts
var logger = __webpack_require__(58738);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-helmet-async@2.0.4_react-dom@18.2.0_react@18.2.0/node_modules/react-helmet-async/lib/index.esm.js
var index_esm = __webpack_require__(75479);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@growthbook+growthbook-react@0.21.0_react@18.2.0/node_modules/@growthbook/growthbook-react/dist/esm/index.js + 5 modules
var esm = __webpack_require__(34020);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@loadable+component@5.16.3_react@18.2.0/node_modules/@loadable/component/dist/loadable.esm.mjs + 5 modules
var loadable_esm = __webpack_require__(98716);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useApolloClients.tsx
var useApolloClients = __webpack_require__(83115);
// EXTERNAL MODULE: ./local_modules/apollo-client/client.ts + 71 modules
var apollo_client_client = __webpack_require__(16512);
// EXTERNAL MODULE: ./local_modules/svg-provider/SvgProvider.tsx
var SvgProvider = __webpack_require__(99668);
// EXTERNAL MODULE: ./local_modules/svg-provider/BrowserRuntime.ts + 4 modules
var BrowserRuntime = __webpack_require__(87867);
// EXTERNAL MODULE: ./local_modules/router/util/searchParams.ts
var searchParams = __webpack_require__(87956);
// EXTERNAL MODULE: ./local_modules/router/Router.tsx + 3 modules
var Router = __webpack_require__(48826);
// EXTERNAL MODULE: ./local_modules/analytics/mixpanel/index.ts
var mixpanel = __webpack_require__(94064);
// EXTERNAL MODULE: ../../node_modules/.pnpm/focus-visible@5.2.0/node_modules/focus-visible/dist/focus-visible.js
var focus_visible = __webpack_require__(63611);
// EXTERNAL MODULE: ./local_modules/throttle-debounce/throttle.ts
var throttle = __webpack_require__(57719);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/modules/user/abFt/index.tsx + 3 modules
var abFt = __webpack_require__(11220);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user_user = __webpack_require__(17382);
// EXTERNAL MODULE: ./src/modules/user/shownPopups/index.tsx + 2 modules
var shownPopups = __webpack_require__(86506);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(91339);
// EXTERNAL MODULE: ./src/modules/subscription/subscribe/index.tsx
var subscribe = __webpack_require__(7138);
// EXTERNAL MODULE: ./src/modules/priceSelection/index.tsx
var priceSelection = __webpack_require__(19792);
// EXTERNAL MODULE: ./src/containers/Routes/Routes.tsx
var Routes = __webpack_require__(18882);
// EXTERNAL MODULE: ./src/containers/ModalsRegistry/ModalsRegistry.tsx
var ModalsRegistry = __webpack_require__(64340);
// EXTERNAL MODULE: ./src/containers/App/components/Notifications/Notifications.tsx
var Notifications = __webpack_require__(72829);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(59690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(17376);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(8946);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(34618);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.dot-all.js
var es_regexp_dot_all = __webpack_require__(73525);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.sticky.js
var es_regexp_sticky = __webpack_require__(864);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(46781);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/local-storage/index.ts + 2 modules
var local_storage = __webpack_require__(55222);
// EXTERNAL MODULE: ./local_modules/notifications/manager.ts
var manager = __webpack_require__(72065);
// EXTERNAL MODULE: ./src/modules/products/useProductGiftPromo.ts + 1 modules
var useProductGiftPromo = __webpack_require__(78053);
;// CONCATENATED MODULE: ./src/compositions/staticNotifications/GiftWithSpendThresholdStaticNotification/images/free-luxe-travel-bag-mobile.png
const free_luxe_travel_bag_mobile_namespaceObject = __webpack_require__.p + "images/free-luxe-travel-bag-mobile_5b5790.png";
;// CONCATENATED MODULE: ./src/compositions/staticNotifications/GiftWithSpendThresholdStaticNotification/images/free-luxe-travel-bag-desktop.png
const free_luxe_travel_bag_desktop_namespaceObject = __webpack_require__.p + "images/free-luxe-travel-bag-desktop_9b905d.png";
;// CONCATENATED MODULE: ./src/compositions/staticNotifications/GiftWithSpendThresholdStaticNotification/GiftWithSpendThresholdStaticNotification.tsx




















var applicablePagePaths = [
    links/* default */.ZP.giftSets.colognes,
    links/* default */.ZP.giftSets.perfumes,
    links/* default */.ZP.shop.accessories,
    links/* default */.ZP.shop.bathBody,
    links/* default */.ZP.shop.candlesHomeScents,
    links/* default */.ZP.shop.colognes,
    links/* default */.ZP.shop.perfumes,
    links/* default */.ZP.shop.scentbirdCases,
    links/* default */.ZP.shop.theEdit,
    links/* default */.ZP.subscription.colognes,
    links/* default */.ZP.subscription.main,
    links/* default */.ZP.subscription.perfumes
].map(function(link) {
    return link.replace("(.*)", "").replace(":slug", "");
}).join("|");
var applicablePagePathRegExp = new RegExp("^(".concat(applicablePagePaths, ")"));
var handleNotificationClose = function() {
    local_storage/* default */.Z.setItem(constants/* default */.Z.localStorageNames.giftWithSpendThresholdShown, true);
};
var GiftWithSpendThresholdStaticNotification = function() {
    var notificationIdRef = (0,react.useRef)(null);
    var path = (0,contexts/* usePathname */.jD)();
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var _useProductGiftPromo = (0,useProductGiftPromo/* default */.Z)(), subTotal = _useProductGiftPromo.subTotal, isFetching = _useProductGiftPromo.isFetching;
    var isApplicablePath = (0,react.useMemo)(function() {
        return applicablePagePathRegExp.test(path);
    }, [
        path
    ]);
    (0,react.useEffect)(function() {
        var notificationWasShown = local_storage/* default */.Z.getItem(constants/* default */.Z.localStorageNames.giftWithSpendThresholdShown);
        if (notificationWasShown || isFetching || !isFetching && !subTotal) {
            return;
        }
        if (!isApplicablePath) {
            if (notificationIdRef.current) {
                (0,manager/* closeNotification */.vU)(notificationIdRef.current);
                notificationIdRef.current = null;
            }
            return;
        }
        if (notificationIdRef.current) {
            return;
        }
        notificationIdRef.current = (0,manager/* openNotification */.Ym)("giftWithSpendThreshold", {
            image: isMobile ? free_luxe_travel_bag_mobile_namespaceObject : free_luxe_travel_bag_desktop_namespaceObject,
            name: "Scentbird luxe travel bag",
            staticMode: true,
            threshold: subTotal.amountCents,
            onClose: handleNotificationClose
        });
    }, [
        isApplicablePath,
        subTotal,
        isFetching,
        isMobile
    ]);
    return null;
};
/* harmony default export */ const GiftWithSpendThresholdStaticNotification_GiftWithSpendThresholdStaticNotification = (GiftWithSpendThresholdStaticNotification);

;// CONCATENATED MODULE: ./src/containers/App/components/StaticNotifications/StaticNotifications.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}






var StaticNotifications = function() {
    var _useSearchParams = _sliced_to_array((0,contexts/* useSearchParams */.lr)(), 1), autoTestSkip = _useSearchParams[0].autoTestSkip;
    var isGwpSpendThresholdEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.gwpSpendThreshold);
    if (autoTestSkip) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isGwpSpendThresholdEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftWithSpendThresholdStaticNotification_GiftWithSpendThresholdStaticNotification, {})
    });
};
/* harmony default export */ const StaticNotifications_StaticNotifications = (StaticNotifications);

// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useQuery.ts
var useQuery = __webpack_require__(61420);
// EXTERNAL MODULE: ./src/compositions/GlobalLoader/GlobalLoader.tsx + 1 modules
var GlobalLoader = __webpack_require__(40037);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.set.js
var es_set = __webpack_require__(41964);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(5119);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(94218);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(40045);
;// CONCATENATED MODULE: ./src/containers/App/components/InitialData/util/initialData.graphql.ts
function initialData_graphql_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return initialData_graphql_array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || initialData_graphql_unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function initialData_graphql_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return initialData_graphql_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return initialData_graphql_array_like_to_array(o, minLen);
}





var InitialDataDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "InitialData"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "lightweight"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Boolean"
                        }
                    },
                    defaultValue: {
                        kind: "BooleanValue",
                        value: false
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "abFt"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Boolean"
                        }
                    },
                    defaultValue: {
                        kind: "BooleanValue",
                        value: true
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "currentUser"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "data"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "personalInfo"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "email"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AuthData"
                                                },
                                                directives: [
                                                    {
                                                        kind: "Directive",
                                                        name: {
                                                            kind: "Name",
                                                            value: "skip"
                                                        },
                                                        "arguments": [
                                                            {
                                                                kind: "Argument",
                                                                name: {
                                                                    kind: "Name",
                                                                    value: "if"
                                                                },
                                                                value: {
                                                                    kind: "Variable",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "lightweight"
                                                                    }
                                                                }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "error"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "SecurityError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "securityErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "ServerError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "serverErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "AbFt"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                "arguments": [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "abFt"
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AnalyticsMetadata"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "AnalyticsMetadata"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mixpanelClientId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "daysFromFirstSubscription"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstSubscriptionDate"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "lifetimeStatus"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "lifeTimeRevenue"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasScentProfile"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "productsInQueueQty"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "subscriptionStatus"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "subscriptionPlan"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isGiftSubscription"
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "Address"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Address"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "primary"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "lastName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "country"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "city"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "region"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postalCode"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "street1"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "street2"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "phone"
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "User"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserData"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "personalInfo"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "analyticsMetadata"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AnalyticsMetadata"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "registrationDate"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "email"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "gender"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "firstName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "lastName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "birthday"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "tokenApi"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "tokenLtn"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "addressInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "shipping"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "Address"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "billing"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "Address"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "dateTime"
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReferralInvites"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserData"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "referralInvites"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "statistics"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "available"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "sent"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "redeemed"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "Subscription"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ScentbirdSubscription"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "status"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "value"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "statusText"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "subscribed"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "plan"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "billingPeriod"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "shippingPeriod"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "productCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "productsPerPeriod"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "description"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "price"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "productPrice"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "credits"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "total"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "paid"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "free"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "freeForReferral"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "freeForReferee"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "customerSupport"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "gift"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "nextShippingDate"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "from"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "to"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "subscriptionDate"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "nextBillingDate"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "activeHold"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "monthsDuration"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "range"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "from"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "to"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "coupon"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "code"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "stateOptions"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "canBuyQueue"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "canCancel"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "canChangeFrequency"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "canDowngrade"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "canResubscribe"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "canSkip"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "canUpgrade"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "isResubscribed"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "remainingShipments"
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AddonSubscription"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CaseSubscription"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "kind"
                        }
                    },
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "isEnabled"
                        },
                        name: {
                            kind: "Name",
                            value: "enabled"
                        }
                    },
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "isSelected"
                        },
                        name: {
                            kind: "Name",
                            value: "selected"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "price"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "priceDetails"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "amountCents"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "currencyCode"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "state"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "upcharge"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "Subscriptions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserData"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "subscription"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "Subscription"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "caseSubscription"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AddonSubscription"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "candleSubscription"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AddonSubscription"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "driftSubscription"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AddonSubscription"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "canApplyTossInOffer"
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PopupShown"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "PopupShown"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "popupId"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "count"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "lastUpdated"
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AuthData"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserData"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "User"
                        }
                    },
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "ReferralInvites"
                        }
                    },
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "Subscriptions"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "shownPopups"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "PopupShown"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AbFt"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Query"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "abTests"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "data"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "abTests"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "value"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "mixpanelProperty"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "enabled"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "features"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "data"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "featureToggles"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "enabled"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
InitialDataDocument["definitions"] = _to_consumable_array(new Set(InitialDataDocument.definitions));
/* harmony default export */ const initialData_graphql = (InitialDataDocument);

;// CONCATENATED MODULE: ./src/containers/App/components/InitialData/InitialData.tsx





// ATTN Initial data it's a first request. We should wait for it to execute to get a session for the user
var InitialData = function(param) {
    var children = param.children, isLightweightSSR = param.isLightweightSSR;
    var _useQuery = (0,useQuery/* default */.Z)(initialData_graphql, {
        variables: {
            lightweight: false,
            abFt: false
        },
        fetchPolicy: "cache-first",
        errorPolicy: "all",
        ssr: !isLightweightSSR
    }), error = _useQuery.error, isFetching = _useQuery.isFetching;
    if (isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalLoader/* default */.Z, {});
    }
    if (error) {
        throw error;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
/* harmony default export */ const InitialData_InitialData = (InitialData);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@sentry+core@7.93.0/node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(79981);
// EXTERNAL MODULE: ./src/hooks/useOnce.ts
var useOnce = __webpack_require__(21058);
;// CONCATENATED MODULE: ./src/containers/App/components/AnalyticsSetup/util/useSentrySetup.ts




var useSentrySetup = function(param) {
    var user = param.user;
    var _ref = user || {}, userId = _ref.id, email = _ref.email, analyticsMetadata = _ref.analyticsMetadata;
    var mixpanelId = analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.mixpanelClientId;
    // setup user data to
    (0,useOnce/* default */.Z)(function() {
        logger/* default */.Z.debug(userId ? "User: ".concat(userId) : "No user found");
        if (true) {
            var _window_newrelic;
            if ((_window_newrelic = window.newrelic) === null || _window_newrelic === void 0 ? void 0 : _window_newrelic.interaction) {
                window.newrelic.interaction().setAttribute("userId", userId).setAttribute("email", email);
            }
            esm_exports/* configureScope */.e(function(scope) {
                if (userId) {
                    scope.setUser({
                        id: String(userId),
                        email: email,
                        mixpanelId: mixpanelId
                    });
                } else {
                    scope.setUser(null);
                }
            });
        }
    }, [
        userId,
        email,
        mixpanelId
    ]);
};
/* harmony default export */ const util_useSentrySetup = (useSentrySetup);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(57890);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(83464);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__(33273);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(6135);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(62100);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(69453);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__(96837);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__(60189);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.url-search-params.delete.js
var web_url_search_params_delete = __webpack_require__(48458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.url-search-params.has.js
var web_url_search_params_has = __webpack_require__(42342);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.url-search-params.size.js
var web_url_search_params_size = __webpack_require__(54967);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__(81738);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(26239);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__(91370);
// EXTERNAL MODULE: ./local_modules/cookie-storage/index.ts + 2 modules
var cookie_storage = __webpack_require__(83913);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.date.to-iso-string.js
var es_date_to_iso_string = __webpack_require__(60106);
// EXTERNAL MODULE: ./local_modules/analytics/context/index.ts
var context = __webpack_require__(5649);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
;// CONCATENATED MODULE: ./src/containers/App/components/AnalyticsSetup/util/graph/analyticsAdditionalData.graphql.ts
function analyticsAdditionalData_graphql_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function analyticsAdditionalData_graphql_array_without_holes(arr) {
    if (Array.isArray(arr)) return analyticsAdditionalData_graphql_array_like_to_array(arr);
}
function analyticsAdditionalData_graphql_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function analyticsAdditionalData_graphql_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function analyticsAdditionalData_graphql_to_consumable_array(arr) {
    return analyticsAdditionalData_graphql_array_without_holes(arr) || analyticsAdditionalData_graphql_iterable_to_array(arr) || analyticsAdditionalData_graphql_unsupported_iterable_to_array(arr) || analyticsAdditionalData_graphql_non_iterable_spread();
}
function analyticsAdditionalData_graphql_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return analyticsAdditionalData_graphql_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return analyticsAdditionalData_graphql_array_like_to_array(o, minLen);
}





var AnalyticsAdditionalDataFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AnalyticsAdditionalData"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Query"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "quizResult"
                        },
                        "arguments": [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "type"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "DISCOVERY"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "representation"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "scentProfileTitle"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fragranceFamily"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
var AnalyticsAdditionalDataDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "AnalyticsAdditionalData"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "AnalyticsAdditionalData"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "academyCourseList"
                        },
                        "arguments": [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: []
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "data"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "uid"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AnalyticsAdditionalData"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Query"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "quizResult"
                        },
                        "arguments": [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "type"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "DISCOVERY"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "representation"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "scentProfileTitle"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fragranceFamily"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
AnalyticsAdditionalDataDocument["definitions"] = analyticsAdditionalData_graphql_to_consumable_array(new Set(AnalyticsAdditionalDataDocument.definitions));
/* harmony default export */ const analyticsAdditionalData_graphql = (AnalyticsAdditionalDataDocument);

;// CONCATENATED MODULE: ./src/containers/App/components/AnalyticsSetup/util/useAdditionalData.ts






var useAdditionalData = function(isLoggedIn) {
    var data = (0,useQuery/* default */.Z)(analyticsAdditionalData_graphql, {
        skip: !isLoggedIn
    }).data;
    return (0,react.useMemo)(function() {
        var _data_quizResult, _data_academyCourseList_data_, _data_academyCourseList_data, _data_academyCourseList;
        var result = {
            scentProfile: undefined,
            fragranceFamily: undefined,
            hasScentbirdAcademy: undefined
        };
        if (data === null || data === void 0 ? void 0 : (_data_quizResult = data.quizResult) === null || _data_quizResult === void 0 ? void 0 : _data_quizResult.representation) {
            var _data_quizResult_representation_fragranceFamily;
            result.scentProfile = data.quizResult.representation.scentProfileTitle;
            result.fragranceFamily = (_data_quizResult_representation_fragranceFamily = data.quizResult.representation.fragranceFamily) === null || _data_quizResult_representation_fragranceFamily === void 0 ? void 0 : _data_quizResult_representation_fragranceFamily.map(function(param) {
                var name = param.name;
                return name;
            }).join(", ");
        }
        if ((data === null || data === void 0 ? void 0 : (_data_academyCourseList = data.academyCourseList) === null || _data_academyCourseList === void 0 ? void 0 : (_data_academyCourseList_data = _data_academyCourseList.data) === null || _data_academyCourseList_data === void 0 ? void 0 : (_data_academyCourseList_data_ = _data_academyCourseList_data[0]) === null || _data_academyCourseList_data_ === void 0 ? void 0 : _data_academyCourseList_data_.status) === "PURCHASED") {
            result.hasScentbirdAcademy = true;
        }
        return result;
    }, [
        data
    ]);
};
/* harmony default export */ const util_useAdditionalData = (useAdditionalData);

;// CONCATENATED MODULE: ./src/containers/App/components/AnalyticsSetup/util/useAnalyticsContextSetup.ts










// backend has different from default ISO milliseconds format: yyyy-MM-dd'T'HH:mm:ss.SSSSSSZ
// snowplow requires default: yyyy-MM-dd'T'HH:mm:ss.SSSZ
var fixTimeISOString = function(date) {
    return date ? new Date(date).toISOString() : undefined;
};
// this hook fills analytics context
var useAnalyticsContextSetup = function(param) {
    var user = param.user, subscription = param.subscription;
    var firstVisitDate = (0,react.useMemo)(function() {
        try {
            var firstVisitTimestamp = cookie_storage/* default */.ZP.getItem("firstVisitTimestamp");
            return new Date(firstVisitTimestamp * 1000).toISOString();
        } catch (err) {
            return new Date().toISOString();
        }
    }, []);
    var _ref = subscription || {}, hasCandleSubscription = _ref.hasCandleSubscription, hasCaseSubscription = _ref.hasCaseSubscription, hasDriftSubscription = _ref.hasDriftSubscription, subscriptionDate = _ref.subscriptionDate;
    var lastSubscriptionDate = fixTimeISOString(subscriptionDate);
    var analyticsMetadata = user === null || user === void 0 ? void 0 : user.analyticsMetadata;
    var registrationDate = fixTimeISOString(user === null || user === void 0 ? void 0 : user.registrationDate);
    var additionalData = util_useAdditionalData(Boolean(user === null || user === void 0 ? void 0 : user.id));
    var properties = (0,react.useMemo)(function() {
        if (false) {}
        var subscriptionPlan = analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.subscriptionPlan;
        var subscriptionStatus = (analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.subscriptionStatus) || "LEAD";
        var lifetimeStatus = (analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.lifetimeStatus) || "UNREGISTERED";
        var hasScentProfile = analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.hasScentProfile;
        var isGiftSubscription = analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.isGiftSubscription;
        var lifeTimeRevenue = analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.lifeTimeRevenue;
        var firstSubscriptionDate = fixTimeISOString(analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.firstSubscriptionDate);
        var productsInQueueQty = analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.productsInQueueQty;
        var props = {
            webAppVersion: "rebrand",
            firstVisitDate: firstVisitDate,
            firstVisitDateTime: firstVisitDate,
            registrationDate: registrationDate,
            subscriptionStatus: subscriptionStatus,
            subscriptionPlan: subscriptionPlan,
            lifetimeStatus: lifetimeStatus,
            lifeTimeRevenue: lifeTimeRevenue,
            hasScentProfile: hasScentProfile,
            isGiftSubscription: isGiftSubscription,
            firstSubscriptionDate: firstSubscriptionDate,
            lastSubscriptionDate: lastSubscriptionDate,
            subscriptionDateTime: lastSubscriptionDate,
            productsInQueueQty: productsInQueueQty,
            hasCaseSubscription: hasCaseSubscription,
            hasCandleSubscription: hasCandleSubscription,
            hasDriftSubscription: hasDriftSubscription,
            // TODO move to analyticsData - added on 2023-10-10 by maddoger
            hasScentbirdAcademy: additionalData.hasScentbirdAcademy,
            scentProfile: additionalData.scentProfile,
            fragranceFamily: additionalData.fragranceFamily
        };
        Object.keys(props).forEach(function(name) {
            if (props[name] === undefined || props[name] === null) {
                delete props[name];
            }
        });
        return props;
    }, [
        firstVisitDate,
        lastSubscriptionDate,
        analyticsMetadata,
        registrationDate,
        hasCaseSubscription,
        hasCandleSubscription,
        hasDriftSubscription,
        additionalData
    ]);
    (0,useOnce/* default */.Z)(function() {
        if (true) {
            (0,context/* updateAnalyticsContext */.yT)(properties);
        }
    }, [
        properties
    ]);
    return properties;
};
/* harmony default export */ const util_useAnalyticsContextSetup = (useAnalyticsContextSetup);

;// CONCATENATED MODULE: ./src/containers/App/components/AnalyticsSetup/util/useMixpanelSetup.ts






























// little helper to provide correct domain
var setCookie = function(name, value) {
    var session = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    cookie_storage/* default */.ZP.setItem(name, value, {
        domain: ".scentbird.com",
        maxAge: session ? null : 50 * 365 * 24 * 60 * 60
    });
};
// identifies a user
var setupUser = function(param) {
    var mixpanelClientId = param.mixpanelClientId, email = param.email;
    if (mixpanelClientId) {
        mixpanel/* default */.Z.identify(mixpanelClientId);
    }
    if (email) {
        mixpanel/* default */.Z.peopleSet({
            $email: email
        });
    }
    var distinctId = mixpanel/* default */.Z.getDistinctId();
    setCookie("scnt_mixpanel_clientid", distinctId);
    setCookie("_mxpnl_id", distinctId);
    setCookie("_mxpnl_ref", document.referrer);
    logger/* default */.Z.info("[Mixpanel] identify %j", {
        distinctId: distinctId,
        email: email
    });
};
var unregisterAbTestProps = function(abTests) {
    var _window_mixpanel_persistence, _window_mixpanel;
    if (!((_window_mixpanel = window.mixpanel) === null || _window_mixpanel === void 0 ? void 0 : (_window_mixpanel_persistence = _window_mixpanel.persistence) === null || _window_mixpanel_persistence === void 0 ? void 0 : _window_mixpanel_persistence.props)) {
        return;
    }
    var mixpanelPropertiesNames = Object.keys(window.mixpanel.persistence.props).filter(function(propName) {
        return propName.startsWith("ab ");
    });
    var activeAbNames = Object.keys(abTests);
    mixpanelPropertiesNames.forEach(function(propName) {
        if (!activeAbNames.includes(propName)) {
            mixpanel/* default */.Z.unregister(propName);
        }
    });
    logger/* default */.Z.info("[Mixpanel] Unregister ab tests");
};
var registerAbTestProps = function(abTests) {
    var props = Object.keys(abTests).reduce(function(acc, name) {
        var _abTests_name = abTests[name], value = _abTests_name.value, mixpanelProperty = _abTests_name.mixpanelProperty, enabled = _abTests_name.enabled;
        if (enabled) {
            acc[mixpanelProperty] = value;
        }
        return acc;
    }, {});
    mixpanel/* default */.Z.register(props);
    logger/* default */.Z.info("[Mixpanel] Register ab tests %j", props);
};
// device info
var setupDeviceProps = function(device) {
    var os = device.os, platform = device.platform, browser = device.browser, browserVersion = device.browserVersion, isBot = device.isBot, isMobile = device.isMobile, isTablet = device.isTablet;
    var mixpanelDevice = isTablet ? "tablet" : isMobile ? "mobile" : "desktop";
    var props = {
        _Device: mixpanelDevice,
        _OS: os,
        _Platform: platform,
        _Browser: browser,
        _BrowserVersion: browserVersion,
        _BOT: isBot
    };
    mixpanel/* default */.Z.register(props);
    logger/* default */.Z.info("[Mixpanel] Register device sp %j", props);
};
// basic user props from user object and subscription
var setupUserProps = function(superProperties) {
    mixpanel/* default */.Z.register(superProperties);
    logger/* default */.Z.info("[Mixpanel] Register user sp %j", superProperties);
};
// postClick init props
var setupPostClickSuperProps = function() {
    var abTrafficGroup = cookie_storage/* default */.ZP.getItem(constants/* default */.Z.cookieNames.postClickGroup);
    if (abTrafficGroup) {
        var props = {
            abTrafficGroup: abTrafficGroup
        };
        mixpanel/* default */.Z.register(props);
        logger/* default */.Z.info("[Mixpanel] Register postclick sp %j", props);
    } else {
        mixpanel/* default */.Z.unregister("abTrafficGroup");
    }
};
// helps to track and assign utm tags
var setupUtmSuperProps = function() {
    var params = new URLSearchParams(window.location.search);
    var campaignKeywords = "utm_source utm_medium utm_campaign utm_content utm_term".split(" ");
    var utmParams = {};
    var firstParams = {};
    campaignKeywords.forEach(function(keyword) {
        var value = params.get(keyword);
        if (!(value === null || value === void 0 ? void 0 : value.length)) {
            return;
        }
        utmParams["".concat(keyword, " [last touch]")] = value;
        firstParams["".concat(keyword, " [first touch]")] = value;
    });
    mixpanel/* default */.Z.register(utmParams);
    mixpanel/* default */.Z.peopleSet(utmParams);
    mixpanel/* default */.Z.peopleSetOnce(firstParams);
    logger/* default */.Z.info("[Mixpanel] Register last touch utm %j", utmParams);
    logger/* default */.Z.info("[Mixpanel] Register first touch utm %j", firstParams);
    // additional url params
    var queryCoupon = params.get("cpn");
    if (queryCoupon) {
        mixpanel/* default */.Z.register({
            "Query coupon": queryCoupon
        });
        logger/* default */.Z.info("[Mixpanel] set Query coupon %s", queryCoupon);
    }
};
var getSearchInfo = function(referrer) {
    var getSearchEngine = function(host) {
        if (/google./.test(host)) {
            return "google";
        }
        if (/bing.com/.test(host)) {
            return "bing";
        }
        if (/yahoo.com/.test(host)) {
            return "yahoo";
        }
        if (/duckduckgo.com/.test(host)) {
            return "duckduckgo";
        }
        return null;
    };
    try {
        if (!referrer) {
            return null;
        }
        var url = new URL(referrer);
        var searchEngine = getSearchEngine(url.host);
        var searchKeyword = null;
        if (searchEngine) {
            var param = searchEngine !== "yahoo" ? "q" : "p";
            var keyword = url.searchParams.get(param);
            if (keyword === null || keyword === void 0 ? void 0 : keyword.length) {
                searchKeyword = keyword;
            }
        }
        return {
            domain: url.host,
            searchEngine: searchEngine,
            searchKeyword: searchKeyword
        };
    } catch (error) {
        logger/* default */.Z.warn(error);
        return null;
    }
};
// sync mixpanel client-side properties with cookie for server-side events
// fallback if script inside partytown is blocked
var syncSuperPropertiesCookie = function() {
    var _window_mixpanel, _window;
    var referrer = document.referrer;
    var _ref = getSearchInfo(referrer) || {}, domain = _ref.domain, searchEngine = _ref.searchEngine, searchKeyword = _ref.searchKeyword;
    var cookieData = {
        $screen_width: window.screen.width,
        $screen_height: window.screen.height,
        $referrer: referrer,
        $referring_domain: domain,
        $search_engine: searchEngine,
        mp_keyword: searchKeyword,
        webAppVersion: "rebrand"
    };
    if (typeof ((_window = window) === null || _window === void 0 ? void 0 : (_window_mixpanel = _window.mixpanel) === null || _window_mixpanel === void 0 ? void 0 : _window_mixpanel.get_property) === "function") {
        // if mixpanel isn't available, set
        var propertiesToSync = [
            "$device_id",
            "$initial_referrer",
            "$initial_referring_domain",
            "_Device",
            "_Platform",
            "_OS",
            "_Browser",
            "_BrowserVersion",
            "productsInQueueQty",
            "abTrafficGroup",
            "ab postclick version"
        ];
        propertiesToSync.forEach(function(key) {
            cookieData[key] = window.mixpanel.get_property(key);
        });
        // keep the old name too
        cookieData["Products in Queue"] = cookieData["productsInQueueQty"];
    }
    Object.keys(cookieData).forEach(function(key) {
        if (cookieData[key] === undefined) {
            delete cookieData[key];
        }
    });
    setCookie(constants/* default */.Z.cookieNames.mixpanelSuperProperties, cookieData, true);
    logger/* default */.Z.info("[Mixpanel] Sync super properties cookie: %j", cookieData);
};
var useMixpanelSetup = function(props) {
    var _user_analyticsMetadata;
    var user = props.user;
    var device = (0,useDevice/* default */.Z)();
    var abTests = (0,abFt/* useAbFt */.S)().abTests;
    var superProperties = util_useAnalyticsContextSetup(props);
    var email = user === null || user === void 0 ? void 0 : user.email;
    var mixpanelClientId = user === null || user === void 0 ? void 0 : (_user_analyticsMetadata = user.analyticsMetadata) === null || _user_analyticsMetadata === void 0 ? void 0 : _user_analyticsMetadata.mixpanelClientId;
    // This hook creates cookie if mixpanel is blocked
    (0,react.useEffect)(function() {
        try {
            // setup if mixpanel is blocked
            syncSuperPropertiesCookie();
        } catch (error) {
            logger/* default */.Z.error(error);
        }
    }, []);
    // This hook should handle user reinitialisation
    (0,useOnce/* default */.Z)(function() {
        if (false) {}
        try {
            // ATTN it is inside onInit, because it requires mixpanel to be initialized
            mixpanel/* default */.Z.onInit(function() {
                setupUser({
                    mixpanelClientId: mixpanelClientId,
                    email: email
                });
                unregisterAbTestProps(abTests);
                registerAbTestProps(abTests);
                setupDeviceProps(device);
                setupUtmSuperProps();
                setupPostClickSuperProps();
            });
        } catch (error) {
            logger/* default */.Z.error(error);
        }
    }, [
        email,
        mixpanelClientId,
        abTests,
        device
    ]);
    // This hook syncs user and subscription properties. They can change during user's action,
    // that's why they are in a different hook
    (0,useOnce/* default */.Z)(function() {
        if (false) {}
        try {
            mixpanel/* default */.Z.onInit(function() {
                setupUserProps(superProperties);
                syncSuperPropertiesCookie();
            });
        } catch (error) {
            logger/* default */.Z.error(error);
        }
    }, [
        superProperties
    ]);
};
/* harmony default export */ const util_useMixpanelSetup = (useMixpanelSetup);

// EXTERNAL MODULE: ./local_modules/analytics/snowplow/index.ts
var snowplow = __webpack_require__(49594);
;// CONCATENATED MODULE: ./src/containers/App/components/AnalyticsSetup/util/useSnowplowSetup.ts
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var useSnowplowSetup = function(param) {
    var user = param.user, isFetching = param.isFetching;
    var pathname = (0,contexts/* usePathname */.jD)();
    var _useDevice = (0,useDevice/* default */.Z)(), isTablet = _useDevice.isTablet, isMobile = _useDevice.isMobile;
    var userId = (user === null || user === void 0 ? void 0 : user.id) || null;
    var paramsRef = (0,react.useRef)(null);
    // this workaround is required to avoid events duplication when params are changed
    paramsRef.current = (0,react.useMemo)(function() {
        if (isFetching) {
            return null;
        }
        var device = isTablet ? "tablet" : isMobile ? "mobile" : "desktop";
        var isLoggedIn = userId !== null;
        return {
            userId: userId,
            isLoggedIn: isLoggedIn,
            device: device
        };
    }, [
        isMobile,
        isTablet,
        isFetching,
        userId
    ]);
    (0,useOnce/* default */.Z)(function() {
        if (true) {
            snowplow/* default */.Z.setUserId(userId);
        }
    }, [
        userId
    ]);
    (0,react.useEffect)(function() {
        if (!paramsRef.current) {
            return;
        }
        var referrer = document.referrer ? document.referrer.replace(/https?:\/\/(www\.)?scentbird.com/, "") : "direct";
        snowplow/* default */.Z.trackPageView(pathname, _object_spread_props(_object_spread({}, paramsRef.current), {
            referrer: referrer,
            pageTitle: document.title,
            pageReferrer: document.referrer
        }));
    }, [
        pathname
    ]);
};
/* harmony default export */ const util_useSnowplowSetup = (useSnowplowSetup);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ./local_modules/analytics/dataLayer/index.ts
var dataLayer = __webpack_require__(85434);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83901);
;// CONCATENATED MODULE: ./src/containers/App/components/AnalyticsSetup/util/graph/pixelApply.graphql.ts
function pixelApply_graphql_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function pixelApply_graphql_array_without_holes(arr) {
    if (Array.isArray(arr)) return pixelApply_graphql_array_like_to_array(arr);
}
function pixelApply_graphql_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function pixelApply_graphql_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function pixelApply_graphql_to_consumable_array(arr) {
    return pixelApply_graphql_array_without_holes(arr) || pixelApply_graphql_iterable_to_array(arr) || pixelApply_graphql_unsupported_iterable_to_array(arr) || pixelApply_graphql_non_iterable_spread();
}
function pixelApply_graphql_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return pixelApply_graphql_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pixelApply_graphql_array_like_to_array(o, minLen);
}





var PixelApplyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "PixelApply"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "PixelDataInput"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pixelApply"
                        },
                        "arguments": [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "error"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "ServerError"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            alias: {
                                                                kind: "Name",
                                                                value: "serverErrorCode"
                                                            },
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorCode"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
PixelApplyDocument["definitions"] = pixelApply_graphql_to_consumable_array(new Set(PixelApplyDocument.definitions));
/* harmony default export */ const pixelApply_graphql = (PixelApplyDocument);

;// CONCATENATED MODULE: ./src/containers/App/components/AnalyticsSetup/util/useDataLayerSetup.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}







var useDataLayerSetup = function(param) {
    var user = param.user, isFetching = param.isFetching;
    var apolloClient = (0,useApolloClients/* useApolloClient */.x)();
    (0,react.useEffect)(function() {
        var applyPixel = function() {
            var _ref = _async_to_generator(function(input) {
                var result, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                apolloClient.mutate({
                                    mutation: pixelApply_graphql,
                                    fetchPolicy: "no-cache",
                                    variables: {
                                        input: input
                                    }
                                })
                            ];
                        case 1:
                            result = _state.sent();
                            if (result.errors) {
                                throw new errors/* GraphQLError */.__(result.errors);
                            }
                            return [
                                2,
                                result.data
                            ];
                        case 2:
                            error = _state.sent();
                            console.warn(error);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function applyPixel(input) {
                return _ref.apply(this, arguments);
            };
        }();
        // ATTN we use this helper in GTM
        window.marketingActions = {
            applyPixel: applyPixel
        };
    }, [
        apolloClient
    ]);
    var pathname = (0,contexts/* usePathname */.jD)();
    var paramsRef = (0,react.useRef)(null);
    // this workaround is required to avoid events duplication when params are changed
    paramsRef.current = (0,react.useMemo)(function() {
        if (isFetching) {
            return null;
        }
        var _ref = user || {}, id = _ref.id, email = _ref.email, gender = _ref.gender, analyticsMetadata = _ref.analyticsMetadata;
        var isLoggedIn = id !== null;
        var lifetimeStatus = (analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.lifetimeStatus) || "UNREGISTERED";
        var subscriptionStatus = (analyticsMetadata === null || analyticsMetadata === void 0 ? void 0 : analyticsMetadata.subscriptionStatus) || "LEAD";
        return {
            id: id,
            email: email,
            gender: gender,
            isLoggedIn: isLoggedIn,
            subscriptionStatus: subscriptionStatus,
            lifetimeStatus: lifetimeStatus
        };
    }, [
        isFetching,
        user
    ]);
    var _ref = user || {}, id = _ref.id, email = _ref.email;
    (0,react.useEffect)(function() {
        if (id && email) {
            dataLayer/* default */.Z.track("user found", {
                user: {
                    email: email,
                    id: id
                }
            });
        }
    }, [
        email,
        id
    ]);
    (0,react.useEffect)(function() {
        if (!paramsRef.current) {
            return;
        }
        dataLayer/* default */.Z.track("pageView", {
            user: paramsRef.current
        });
        var _getAnalyticsContext = (0,context/* getAnalyticsContext */.cV)(), pageName = _getAnalyticsContext.page;
        if (pageName) {
            dataLayer/* default */.Z.push({
                pageName: pageName
            });
        }
    }, [
        pathname
    ]);
};
/* harmony default export */ const util_useDataLayerSetup = (useDataLayerSetup);

;// CONCATENATED MODULE: ./src/containers/App/components/AnalyticsSetup/AnalyticsSetup.tsx




var AnalyticsSetup = function() {
    var _useUser = (0,user_user/* useUser */.a)(), user = _useUser.user, isUserFetching = _useUser.isFetching;
    var _useSubscription = (0,subscription_subscription/* useSubscription */.m)(), subscription = _useSubscription.subscription, isSubscriptionFetching = _useSubscription.isFetching;
    var hookProps = {
        user: user,
        subscription: subscription,
        isFetching: isUserFetching || isSubscriptionFetching
    };
    util_useSentrySetup(hookProps);
    util_useMixpanelSetup(hookProps);
    util_useSnowplowSetup(hookProps);
    util_useDataLayerSetup(hookProps);
    // ATTN we don't need it right now
    // useAttentiveSetup(hookProps)
    return null;
};
/* harmony default export */ const AnalyticsSetup_AnalyticsSetup = (/*#__PURE__*/react.memo(AnalyticsSetup));

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(54939);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(14939);
// EXTERNAL MODULE: ./src/components/dataDisplay/Meta/Meta.tsx
var Meta = __webpack_require__(75989);
// EXTERNAL MODULE: ./local_modules/links/getLinkWithParams.ts
var getLinkWithParams = __webpack_require__(54780);
;// CONCATENATED MODULE: ./src/containers/App/components/GlobalMeta/util/messages.ts
/* harmony default export */ const messages = ({
    initialSeo: {
        title: {
            en: "Scentbird Monthly Perfume Subscription Box: Designer Scents {price}"
        },
        description: {
            en: "\n      Discover the latest perfumes and colognes at Scentbird. Date perfumes before marrying them.\n      Explore over 700 designer fragrances. Get new designer scent every month for just {price}. Free shipping.\n    "
        }
    },
    cleanPerfumes: {
        title: {
            en: "Clean fragrances"
        }
    },
    newArrivalsPerfumes: {
        title: {
            en: "New in Fine Fragrances"
        },
        description: {
            en: "The newest perfumes and colognes to land at the Scentbird nest."
        }
    },
    giftSetsPerfumes: {
        title: {
            en: "Scentbird Gift sets"
        },
        description: {
            en: "Spoil 'em with ridiculously amazing scents"
        }
    },
    giftSetsColognes: {
        title: {
            en: "Scentbird Gift sets"
        },
        description: {
            en: "Spoil 'em with ridiculously amazing scents"
        }
    },
    giftSetsUnisex: {
        title: {
            en: "Scentbird Gift sets"
        },
        description: {
            en: "Spoil 'em with ridiculously amazing scents"
        }
    },
    terms: {
        title: {
            en: "Terms & Conditions"
        }
    },
    privacy: {
        title: {
            en: "Privacy policy"
        }
    },
    press: {
        title: {
            en: "Press resources"
        }
    },
    team: {
        title: {
            en: "Team of Perfume Subscription Service"
        }
    },
    cardUpdate: {
        title: {
            en: "Card update"
        }
    },
    shopSamplePerfumes: {
        title: {
            en: "Scentbird Shop Samples"
        },
        description: {
            en: "Spoil 'em with ridiculously amazing scents"
        }
    },
    shopSampleColognes: {
        title: {
            en: "Scentbird Shop Samples"
        },
        description: {
            en: "Spoil 'em with ridiculously amazing scents"
        }
    },
    giftSubscription: {
        title: {
            en: "The Perfect Gift: Perfume Subscription Starting at {minimalPrice}"
        },
        description: {
            en: "\n      Shop perfume gift at Scentbird.com.\n      View our unrivaled assortment from top brands and find a luxurious perfume gift set for every woman in your life.\n    "
        }
    },
    bestsellersPerfumes: {
        title: {
            en: "Best Sellers"
        },
        description: {
            en: "The Scentbird community has spoken, and these are the most-popular fragrance picks."
        }
    },
    subscriptionPerfumeOfTheMonthList: {
        title: {
            en: "Fragrance of the month archive"
        }
    },
    collectionsWomen: {
        title: {
            en: "Collections"
        }
    },
    scentbirdAcademy: {
        title: {
            en: "Scentbird Academy"
        },
        description: {
            en: "An immersive video course on how to use scent to enrich your life."
        }
    }
});

;// CONCATENATED MODULE: ./src/containers/App/components/GlobalMeta/util/useClientSeo.ts
function useClientSeo_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useClientSeo_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useClientSeo_define_property(target, key, source[key]);
        });
    }
    return target;
}
function useClientSeo_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function useClientSeo_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        useClientSeo_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var _obj;
var seoData = (_obj = {}, useClientSeo_define_property(_obj, links/* default */.ZP.clean.perfumes, messages.cleanPerfumes), useClientSeo_define_property(_obj, links/* default */.ZP.newArrivals.perfumes, messages.newArrivalsPerfumes), useClientSeo_define_property(_obj, links/* default */.ZP.giftSets.perfumes, messages.giftSetsPerfumes), useClientSeo_define_property(_obj, links/* default */.ZP.giftSets.colognes, messages.giftSetsColognes), useClientSeo_define_property(_obj, links/* default */.ZP.giftSets.unisex, messages.giftSetsUnisex), useClientSeo_define_property(_obj, links/* default */.ZP.terms, messages.terms), useClientSeo_define_property(_obj, links/* default */.ZP.privacy, messages.privacy), useClientSeo_define_property(_obj, links/* default */.ZP.press, messages.press), useClientSeo_define_property(_obj, links/* default */.ZP.team, messages.team), useClientSeo_define_property(_obj, links/* default */.ZP.cardUpdate, messages.cardUpdate), useClientSeo_define_property(_obj, links/* default */.ZP.shop.samples.perfumes, messages.shopSamplePerfumes), useClientSeo_define_property(_obj, links/* default */.ZP.shop.samples.colognes, messages.shopSampleColognes), useClientSeo_define_property(_obj, links/* default */.ZP.giftSubscription, messages.giftSubscription), useClientSeo_define_property(_obj, links/* default */.ZP.bestsellers.perfumes, messages.bestsellersPerfumes), useClientSeo_define_property(_obj, links/* default */.ZP.subscription.perfumeOfTheMonthList, messages.subscriptionPerfumeOfTheMonthList), useClientSeo_define_property(_obj, links/* default */.ZP.collectionsWomen, messages.collectionsWomen), useClientSeo_define_property(_obj, (0,getLinkWithParams/* default */.Z)(links/* default */.ZP.academy.course, {
    slug: "jo-malone"
}), messages.scentbirdAcademy), _obj);
var useClientSeo = function() {
    var pathname = (0,contexts/* usePathname */.jD)();
    var _useSubscribeOffer = (0,subscribe/* useSubscribeOffer */.Hu)(), tmp = _useSubscribeOffer.formattedPrice, price = tmp === void 0 ? "" : tmp;
    var pageSeoData = seoData[pathname];
    return (0,react.useMemo)(function() {
        return {
            title: (pageSeoData === null || pageSeoData === void 0 ? void 0 : pageSeoData.title) || useClientSeo_object_spread_props(useClientSeo_object_spread({}, messages.initialSeo.title), {
                values: {
                    price: price
                }
            }),
            description: (pageSeoData === null || pageSeoData === void 0 ? void 0 : pageSeoData.description) || useClientSeo_object_spread_props(useClientSeo_object_spread({}, messages.initialSeo.description), {
                values: {
                    price: price
                }
            }),
            keywords: (pageSeoData === null || pageSeoData === void 0 ? void 0 : pageSeoData.keywords) || "",
            image: "https://cdn.scentbird.com/og/cover.png"
        };
    }, [
        pageSeoData,
        price
    ]);
};
/* harmony default export */ const util_useClientSeo = (useClientSeo);

;// CONCATENATED MODULE: ./src/containers/App/components/GlobalMeta/util/graph/pageSeos.strapi.graphql.ts
function pageSeos_strapi_graphql_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function pageSeos_strapi_graphql_array_without_holes(arr) {
    if (Array.isArray(arr)) return pageSeos_strapi_graphql_array_like_to_array(arr);
}
function pageSeos_strapi_graphql_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function pageSeos_strapi_graphql_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function pageSeos_strapi_graphql_to_consumable_array(arr) {
    return pageSeos_strapi_graphql_array_without_holes(arr) || pageSeos_strapi_graphql_iterable_to_array(arr) || pageSeos_strapi_graphql_unsupported_iterable_to_array(arr) || pageSeos_strapi_graphql_non_iterable_spread();
}
function pageSeos_strapi_graphql_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return pageSeos_strapi_graphql_array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pageSeos_strapi_graphql_array_like_to_array(o, minLen);
}





var PageSeosDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "PageSeos"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filters"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "PageSeoFiltersInput"
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pageSeos"
                        },
                        "arguments": [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filters"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filters"
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "data"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "attributes"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "url"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "seo"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "canonicalURL"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "keywords"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "metaDescription"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "metaTitle"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "metaImage"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "data"
                                                                                    },
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "id"
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "attributes"
                                                                                                },
                                                                                                selectionSet: {
                                                                                                    kind: "SelectionSet",
                                                                                                    selections: [
                                                                                                        {
                                                                                                            kind: "Field",
                                                                                                            name: {
                                                                                                                kind: "Name",
                                                                                                                value: "url"
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
PageSeosDocument["definitions"] = pageSeos_strapi_graphql_to_consumable_array(new Set(PageSeosDocument.definitions));
/* harmony default export */ const pageSeos_strapi_graphql = (PageSeosDocument);

;// CONCATENATED MODULE: ./src/containers/App/components/GlobalMeta/util/useStrapiSeo.ts





var useStrapiSeo = function() {
    var _data_pageSeos_data__attributes, _data_pageSeos_data_, _data_pageSeos_data, _data_pageSeos;
    var pathname = (0,contexts/* usePathname */.jD)();
    var isSeoStrapiEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.seoStrapi);
    var data = (0,useQuery/* default */.Z)(pageSeos_strapi_graphql, {
        client: "strapi",
        fetchPolicy: "cache-first",
        variables: {
            filters: {
                url: {
                    eq: pathname
                }
            }
        },
        skip: !isSeoStrapiEnabled,
        context: {
            ssrCache: true
        }
    }).data;
    return data === null || data === void 0 ? void 0 : (_data_pageSeos = data.pageSeos) === null || _data_pageSeos === void 0 ? void 0 : (_data_pageSeos_data = _data_pageSeos.data) === null || _data_pageSeos_data === void 0 ? void 0 : (_data_pageSeos_data_ = _data_pageSeos_data[0]) === null || _data_pageSeos_data_ === void 0 ? void 0 : (_data_pageSeos_data__attributes = _data_pageSeos_data_.attributes) === null || _data_pageSeos_data__attributes === void 0 ? void 0 : _data_pageSeos_data__attributes.seo;
};
/* harmony default export */ const util_useStrapiSeo = (useStrapiSeo);

;// CONCATENATED MODULE: ./src/containers/App/components/GlobalMeta/GlobalMeta.tsx








var GlobalMeta = function() {
    var pathname = (0,contexts/* usePathname */.jD)();
    var strapiSeo = util_useStrapiSeo();
    var clientSeo = util_useClientSeo();
    var _useMemo = (0,react.useMemo)(function() {
        var _strapiSeo_metaImage_data, _strapiSeo_metaImage;
        return {
            title: (strapiSeo === null || strapiSeo === void 0 ? void 0 : strapiSeo.metaTitle) || clientSeo.title,
            description: (strapiSeo === null || strapiSeo === void 0 ? void 0 : strapiSeo.metaDescription) || clientSeo.description,
            keywords: (strapiSeo === null || strapiSeo === void 0 ? void 0 : strapiSeo.keywords) || clientSeo.keywords,
            canonicalURL: (strapiSeo === null || strapiSeo === void 0 ? void 0 : strapiSeo.canonicalURL) || pathname,
            image: (strapiSeo === null || strapiSeo === void 0 ? void 0 : (_strapiSeo_metaImage = strapiSeo.metaImage) === null || _strapiSeo_metaImage === void 0 ? void 0 : (_strapiSeo_metaImage_data = _strapiSeo_metaImage.data) === null || _strapiSeo_metaImage_data === void 0 ? void 0 : _strapiSeo_metaImage_data.attributes.url) || clientSeo.image
        };
    }, [
        strapiSeo,
        clientSeo,
        pathname
    ]), title = _useMemo.title, description = _useMemo.description, keywords = _useMemo.keywords, canonicalURL = _useMemo.canonicalURL, image = _useMemo.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default */.Z, {
        title: title,
        metaTitle: title,
        metaDescription: description,
        pathname: canonicalURL,
        image: image,
        withoutTitleTemplate: true,
        keywords: keywords
    });
};
/* harmony default export */ const GlobalMeta_GlobalMeta = (GlobalMeta);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/web.timers.js
var web_timers = __webpack_require__(73598);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(40963);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var modals_manager = __webpack_require__(31978);
;// CONCATENATED MODULE: ./src/containers/App/components/AppVersionChecker/messages.ts
/* harmony default export */ const AppVersionChecker_messages = ({
    title: {
        en: "Please reload your page"
    },
    text: {
        en: "We've made a few updates to the site! Make sure to save all of your unsaved information, then reload your page to see the changes."
    },
    primaryButtonTitle: {
        en: "Reload page"
    },
    secondaryButtonTitle: {
        en: "Later"
    }
});

;// CONCATENATED MODULE: ./src/containers/App/components/AppVersionChecker/AppVersionChecker.tsx
function AppVersionChecker_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function AppVersionChecker_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                AppVersionChecker_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                AppVersionChecker_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function AppVersionChecker_ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}








var primaryReloadTime = 12 * 60 * 60 * 1000 // 12 hours
;
var secondaryReloadTime = 30 * 60 * 1000 // 30 minutes
;
var openReloadPageModal = function() {
    // TODO add analytics - added on 2021-06-03 by maddoger
    // track('Reload page notification')
    var closeModal = (0,modals_manager/* openModal */.h7)("commonModal", {
        title: AppVersionChecker_messages.title,
        text: AppVersionChecker_messages.text,
        primaryButton: {
            title: AppVersionChecker_messages.primaryButtonTitle,
            onClick: function() {
                // track('Reload page click')
                document.location.reload();
            }
        },
        tertiaryButton: {
            title: AppVersionChecker_messages.secondaryButtonTitle,
            onClick: function() {
                closeModal();
                // open the modal again if a user skips page reloading
                setTimeout(function() {
                    openReloadPageModal();
                }, secondaryReloadTime);
            }
        },
        "data-testid": "reloadPageModal"
    });
};
var timeout;
var runTimer = function() {
    timeout = setTimeout(/*#__PURE__*/ AppVersionChecker_async_to_generator(function() {
        var appVersion, error;
        return AppVersionChecker_ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        window.fetch("/site-api/app-version").then(function(response) {
                            return response.json();
                        })
                    ];
                case 1:
                    appVersion = _state.sent().appVersion;
                    if (appVersion !== config/* default */.Z.appVersion) {
                        openReloadPageModal();
                    } else {
                        // run timer again if the versions are same (that means that the app wasn't updated)
                        runTimer();
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error(error);
                    runTimer();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), primaryReloadTime);
};
var AppVersionChecker = function() {
    (0,react.useEffect)(function() {
        runTimer();
        return function() {
            clearTimeout(timeout);
        };
    }, []);
    return null;
};
/* harmony default export */ const AppVersionChecker_AppVersionChecker = (AppVersionChecker);

// EXTERNAL MODULE: ./src/containers/App/components/GlobalLoaderProvider/GlobalLoaderProvider.tsx
var GlobalLoaderProvider = __webpack_require__(48145);
;// CONCATENATED MODULE: ./src/containers/App/App.tsx

















var App = function(param) {
    var isLightweightSSR = param.isLightweightSSR;
    var _useDevice = (0,useDevice/* default */.Z)(), isBot = _useDevice.isBot, isMobile = _useDevice.isMobile;
    (0,react.useEffect)(function() {
        document.documentElement.setAttribute("loaded", "true");
    }, []);
    // see scss function safeVh
    (0,react.useEffect)(function() {
        if (!isMobile) {
            return;
        }
        var handler = (0,throttle/* default */.Z)(function() {
            document.documentElement.style.setProperty("--vh", "".concat(window.innerHeight * 0.01, "px"));
        }, 150);
        handler();
        window.addEventListener("resize", handler);
        return function() {
            window.removeEventListener("resize", handler);
            document.documentElement.style.removeProperty("--vh");
        };
    }, [
        isMobile
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InitialData_InitialData, {
        isLightweightSSR: isLightweightSSR,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(abFt/* AbFtProvider */.X, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(user_user/* UserProvider */.d, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_subscription/* SubscriptionProvider */.q, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shownPopups/* ShownPopupsProvider */.vB, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(priceSelection/* PriceSelectionProvider */.CT, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(subscribe/* SubscribeOfferProvider */.ds, {
                                children: [
                                    !isBot && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Notifications/* default */.Z, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppVersionChecker_AppVersionChecker, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalMeta_GlobalMeta, {}),
                                    !isBot && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnalyticsSetup_AnalyticsSetup, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GlobalLoaderProvider/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalsRegistry/* default */.Z, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Routes/* default */.Z, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticNotifications_StaticNotifications, {})
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ const App_App = (App);

// EXTERNAL MODULE: ./src/compositions/modals/FraudModal/FraudModal.tsx + 1 modules
var FraudModal = __webpack_require__(58999);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/dataDisplay/Logo/Logo.tsx
var Logo = __webpack_require__(1041);
// EXTERNAL MODULE: ./src/containers/StatusCode/StatusCode.tsx
var StatusCode = __webpack_require__(86488);
// EXTERNAL MODULE: ./src/compositions/PageError/PageError.tsx + 1 modules
var PageError = __webpack_require__(90109);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.json.stringify.js
var es_json_stringify = __webpack_require__(76189);
// EXTERNAL MODULE: ./src/helpers/modifiers/safeJsonStringify.ts
var safeJsonStringify = __webpack_require__(88154);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(68471);
;// CONCATENATED MODULE: ./src/pages/Page500/components/ErrorTechnicalDetails/utils.ts





var getErrorInfo = function(error) {
    var message;
    if (error instanceof Error) {
        message = error.stack;
        if (error instanceof errors/* CausedError */.P6) {
            var cause = error.cause instanceof Error ? error.cause.stack : JSON.stringify(error, null, 2);
            message = "".concat(message, "\n\nCaused by:\n\n").concat(cause);
        }
    } else if (!message && error) {
        message = String(error);
    }
    return message;
};
var getSentryEventUrl = function(sentryEventId) {
    return Boolean(sentryEventId) ? "https://sentry.scentbird.com/organizations/scentbird/issues/?query=".concat(sentryEventId) : undefined;
};

;// CONCATENATED MODULE: ./src/pages/Page500/components/ErrorTechnicalDetails/ErrorTechnicalDetails.tsx









var isProd = config/* default */.Z.runEnv === "prod";
var ErrorTechnicalDetails = function(props) {
    var className = props.className, error = props.error, sentryEventId = props.sentryEventId, traceId = props.traceId;
    var errorInfo = (0,react.useMemo)(function() {
        return getErrorInfo(error);
    }, [
        error
    ]);
    if (isProd && (errorInfo || traceId || sentryEventId)) {
        var logs = [
            "console.log('Sentry ID:', ".concat(JSON.stringify(sentryEventId), ", ").concat(JSON.stringify(getSentryEventUrl(sentryEventId)), ")"),
            "console.log('x-trace-id:', ".concat(JSON.stringify(traceId), ")"),
            "console.error(".concat((0,safeJsonStringify/* default */.Z)(errorInfo), ")")
        ];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            dangerouslySetInnerHTML: {
                __html: logs.join(";")
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "hide-empty max-w-full rounded bg-white p-16 text-p4"),
        children: [
            Boolean(sentryEventId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "Sentry ID:"
                    }),
                    "\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: getSentryEventUrl(sentryEventId),
                        children: sentryEventId
                    })
                ]
            }),
            Boolean(traceId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "x-trace-id:"
                    }),
                    "\xa0",
                    traceId
                ]
            }),
            Boolean(errorInfo) && /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: "mt-32 text-p4",
                style: {
                    maxHeight: "300rem",
                    overflow: "auto"
                },
                children: errorInfo
            })
        ]
    });
};
/* harmony default export */ const ErrorTechnicalDetails_ErrorTechnicalDetails = (ErrorTechnicalDetails);

;// CONCATENATED MODULE: ./src/pages/Page500/messages.ts
/* harmony default export */ const Page500_messages = ({
    title: {
        en: "We're updating<br/>our site"
    },
    text: {
        en: "You've sniffed out something we're in the process of updating. Please try reloading it in a few minutes."
    }
});

;// CONCATENATED MODULE: ./src/pages/Page500/Page500.tsx









var Page500 = function(props) {
    var error = props.error, sentryEventId = props.sentryEventId, traceId = props.traceId;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)("flex min-h-full flex-col items-center bg-light-beige", isMobile ? "pt-24" : "pt-48"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusCode/* default */.Z, {
                value: 500
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                color: "black"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageError/* default */.Z, {
                className: "my-auto",
                title: Page500_messages.title,
                text: Page500_messages.text,
                children: Boolean(traceId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-32 text-gold-70",
                    children: [
                        "TraceID: ",
                        traceId
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorTechnicalDetails_ErrorTechnicalDetails, {
                className: "my-32",
                error: error,
                sentryEventId: sentryEventId,
                traceId: traceId
            })
        ]
    });
};
/* harmony default export */ const Page500_Page500 = (Page500);

;// CONCATENATED MODULE: ./src/containers/ErrorBoundary/ErrorBoundary.tsx
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function ErrorBoundary_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function ErrorBoundary_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ErrorBoundary_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ErrorBoundary_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ErrorBoundary_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ErrorBoundary_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}






var ErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ErrorBoundary, Component);
    var _super = _create_super(ErrorBoundary);
    function ErrorBoundary() {
        _class_call_check(this, ErrorBoundary);
        var _this;
        _this = _super.apply(this, arguments);
        ErrorBoundary_define_property(_assert_this_initialized(_this), "state", {
            error: null,
            sentryEventId: null,
            fraud: false
        });
        return _this;
    }
    _create_class(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                var _error_networkError;
                // @ts-ignore
                if ((error === null || error === void 0 ? void 0 : (_error_networkError = error.networkError) === null || _error_networkError === void 0 ? void 0 : _error_networkError.statusCode) === 451) {
                    this.setState({
                        fraud: true
                    });
                    return;
                }
                logger/* default */.Z.error(ErrorBoundary_object_spread_props(ErrorBoundary_object_spread({}, errorInfo), {
                    error: error
                }));
                var sentryEventId = esm_exports/* lastEventId */.eW();
                this.setState({
                    error: error,
                    sentryEventId: sentryEventId
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_state = this.state, error = _this_state.error, sentryEventId = _this_state.sentryEventId, fraud = _this_state.fraud;
                if (fraud) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex min-h-full flex-col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            id: "main",
                            className: "flex-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FraudModal["default"], {})
                        })
                    });
                }
                if (error) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page500_Page500, {
                        error: error,
                        sentryEventId: sentryEventId
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: this.props.children
                });
            }
        }
    ]);
    return ErrorBoundary;
}(react.Component);
/* harmony default export */ const ErrorBoundary_ErrorBoundary = (ErrorBoundary);

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__(41748);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(36654);
;// CONCATENATED MODULE: ./src/containers/App/components/InitialData/util/dumpData.ts











var dumpData = function(apolloClient) {
    try {
        // to log only frontend relative items
        var feAbTests = Object.values(constants/* default */.Z.abTests);
        var feFeatures = Object.values(constants/* default */.Z.features);
        var data = apolloClient.cache.readQuery({
            query: initialData_graphql
        });
        var activeAbTests = data.abTests.data.abTests.reduce(function(result, item) {
            var enabled = item.enabled, value = item.value, name = item.name;
            if ((enabled || value !== "a") && feAbTests.includes(name)) {
                result.push("".concat(name, "(").concat(value, ")"));
            }
            return result;
        }, []).sort();
        var activeFeatures = data.features.data.featureToggles.reduce(function(result, item) {
            var enabled = item.enabled, name = item.name;
            if (enabled && feFeatures.includes(name)) {
                result.push(name);
            }
            return result;
        }, []).sort();
        return {
            activeAbTests: activeAbTests,
            activeFeatures: activeFeatures,
            currentUser: data.currentUser
        };
    } catch (error) {
        return null;
    }
};
/* harmony default export */ const util_dumpData = (dumpData);

;// CONCATENATED MODULE: ./src/client/index.tsx
// eslint-disable-next-line import/order





























smoothscroll_default().polyfill();
var apolloClients = (0,apollo_client_client/* createClients */.x)();
var svgRuntime;
if (config/* default */.Z.runEnv !== "prod") {
    window.__APOLLO_CLIENTS__ = apolloClients;
}
window.dumpData = function() {
    return util_dumpData(apolloClients["default"]);
};
var cleanQueryParams = function() {
    // remove ltn param
    var url = (0,searchParams/* mergeSearchParams */.b4)(window.location.toString(), {
        ltn: undefined,
        magicToken: undefined
    });
    window.history.replaceState({}, document.title, url);
};
cleanQueryParams();
var gb = new esm/* GrowthBook */.Gr({
    apiHost: config/* default */.Z.growthBookApiHost,
    clientKey: config/* default */.Z.growthBookClientKey,
    enableDevMode: config/* default */.Z.runEnv !== "prod",
    subscribeToChanges: Boolean(1),
    features: window.__GROWTH_BOOK_DATA__.features,
    attributes: window.__GROWTH_BOOK_DATA__.attributes,
    trackingCallback: function(experiment, result) {
        var eventParams = {
            "Experiment name": experiment.key,
            "Variant name": result.variationId,
            $source: "growthbook"
        };
        mixpanel/* default */.Z.track("$experiment_started", eventParams);
    }
});
var Root = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(useApolloClients/* ApolloClientsProvider */.s, {
        clients: apolloClients,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntlProvider/* default */.Z, {
            locale: "en",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HelmetProvider */.B6, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider/* default */.Z, {
                    value: window.__DEVICE__,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgProvider/* default */.Z, {
                        value: svgRuntime,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* GrowthBookProvider */.Ny, {
                            growthbook: gb,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary_ErrorBoundary, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Router/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Helmet */.ql, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                                children: "Scentbird"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(App_App, {
                                            isLightweightSSR: window.lightweightSSR
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
var render = function() {
    return (0,loadable_esm/* loadableReady */.TA)().then(function() {
        var hydrate = function() {
            // create runtime only when document is loaded
            svgRuntime = new BrowserRuntime/* default */.Z();
            logger/* default */.Z.info("Client scripts loaded in ".concat(Date.now() - window.__START__, "ms"));
            (0,client/* hydrateRoot */.a)(document.getElementById("root"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Root, {}));
        };
        // ATTN it's required because all scripts have async property
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", hydrate);
        } else {
            hydrate();
        }
    });
};
// https://developers.google.com/web/updates/2016/04/intersectionobserver
var isIntersectionObserverExist = "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype;
if (isIntersectionObserverExist) {
    // Minimal polyfill for Edge 15's lack of `isIntersecting` - https://github.com/w3c/IntersectionObserver/issues/211
    if (!("isIntersecting" in window.IntersectionObserverEntry.prototype)) {
        Object.defineProperty(window.IntersectionObserverEntry.prototype, "isIntersecting", {
            get: function() {
                return this.intersectionRatio > 0;
            }
        });
    }
    render();
} else {
    // @ts-ignore
    Promise.all(/* require.ensure */[__webpack_require__.e(60), __webpack_require__.e(2117)]).then((function(require1) {
        require1("intersection-observer/polyfill");
        render();
    }).bind(null, __webpack_require__))['catch'](__webpack_require__.oe);
}


/***/ }),

/***/ 40037:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ GlobalLoader_GlobalLoader)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/layout/Overlay/Overlay.tsx + 1 modules
var Overlay = __webpack_require__(11697);
;// CONCATENATED MODULE: ./src/compositions/GlobalLoader/GlobalLoader.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const GlobalLoader_module = ({"overlay":"tjWpXM","container":"FismqF","loader":"GrMAlX","animated":"dKZt1b","bStartMask":"imqgBU","bStart":"LCy3IZ","bEndDown":"QDM1Ey","bEndUp":"vEXPid","sDown":"PcmepC","sUp":"VIN0MJ"});
;// CONCATENATED MODULE: ./src/compositions/GlobalLoader/GlobalLoader.tsx





var GlobalLoader = function(param) {
    var _param_withOverlay = param.withOverlay, withOverlay = _param_withOverlay === void 0 ? false : _param_withOverlay;
    var icon = /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: (0,clsx/* default */.Z)(GlobalLoader_module.loader, "m-auto"),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 3580 3628",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "GlobalLoader-Mask-bEnd",
                        style: {
                            maskType: "alpha"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            transform: "matrix(3.95 0 0 3.95 64.5 6.5)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                opacity: "1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "red",
                                    d: "M475.2 272.5c124.1-64.8 72-259.1-99.1-259.1h-85.8c8.4 3.1 27.3 11.2 46.4 23.8 19.8 13 42.1 32 63 54.8a72.3 72.3 0 0 1 55.7 71.4c0 31.6-17.8 77-84 77H250.2v72h132.2c76.3 0 101 53 101 89.8 0 41.4-23.2 88-88.7 93.3a195.3 195.3 0 0 1-91.7 76.1h82.6c195.6 0 254.7-229.6 89.7-299.1Z",
                                    fillOpacity: "1",
                                    fillRule: "nonzero"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "GlobalLoader-Mask-bStart",
                        style: {
                            maskType: "alpha"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            transform: "translate(719.082,1082) scale(3.95,3.95) translate(-165.97,-272.405)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                opacity: "1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#000000",
                                    d: "M254.146,240.432C254.146,240.432,254.146,125.285,254.146,125.285C237.376,116.671,219.439, 112.274,195.589,112.554C186.076,112.666,175.685,114.311,166.135,117.97C166.135,117.97,166.135,462.086,166.135, 462.086C183.789,467.769,202.16,469.317,222.638,466.925C233.042,465.709,244.133, 462.255,254.146,456.577C254.146,456.577,254.146,312.446,254.146,312.446C254.146,312.446,254.146,240.432,254.146,240.432Z",
                                    fillOpacity: "1",
                                    fillRule: "nonzero"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "GlobalLoader-Mask-sDown",
                        style: {
                            maskType: "alpha"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            transform: "matrix(3.95 0 0 3.95 64 6)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                opacity: "1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "red",
                                    d: "M379.1 330.4H272.2V352a125 125 0 0 1 9.4 7c49.5 40.3 15.6 117.4-56.9 125.9-63.8 7.5-110.4-19.7-165.4-80.2l-59 59.7C40 514 110.2 575 218.3 571.5c134-4.4 218.5-119 169.2-225.8-2.5-5.4-5.3-10.4-8.5-15.3Z",
                                    fillOpacity: "1",
                                    fillRule: "nonzero"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                        id: "GlobalLoader-Mask-sUp",
                        style: {
                            maskType: "alpha"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            transform: "matrix(3.95 0 0 3.95 63.9 6.2)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                opacity: "1",
                                transform: "translate(203.4 152.7)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "#131414",
                                    d: "M183.3-47.7C144-89.6 75-152.4-30.4-136.9-143.2-120.3-177.9-49.4-180.6-2.8c-2.7 47.2 9.5 92.8 78 132.2a384.8 384.8 0 0 0 47.3 23v-92A75.8 75.8 0 0 1-69 50.3C-110.2 10.8-82.8-57.3-8-58.1 52-58.8 80.4-32.3 127 8.4l56.2-56Z",
                                    fillOpacity: "1",
                                    fillRule: "evenodd"
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                opacity: "1",
                transform: "translate(604 650)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        mask: "url(#GlobalLoader-Mask-bEnd)",
                        opacity: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            opacity: "1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    transform: "translate(1190 1164)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                            opacity: "1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "red",
                                                d: "M1198.5-1198.5v2397h-2397v-2397h2397Z",
                                                fillOpacity: "0",
                                                fillRule: "nonzero"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                            opacity: "1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                className: (0,clsx/* default */.Z)(GlobalLoader_module.animated, GlobalLoader_module.bEndDown),
                                                fill: "none",
                                                d: "M-174-8c138 0 559.5-4 723.7 60.2C764 136 885.9 200.2 922.5 330 961 466 936 648.3 808.2 770.4 644.4 926.7 462 1001 42 1004",
                                                stroke: "#131414",
                                                strokeOpacity: "1",
                                                strokeWidth: "400",
                                                strokeMiterlimit: "4",
                                                strokeLinecap: "butt",
                                                strokeLinejoin: "miter",
                                                strokeDasharray: "2512",
                                                strokeDashoffset: "2512"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                    transform: "translate(1190 1124)",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                            opacity: "1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                fill: "red",
                                                d: "M1156-1156v2312h-2312v-2312h2312Z",
                                                fillOpacity: "0",
                                                fillRule: "nonzero"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                            opacity: "1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                className: (0,clsx/* default */.Z)(GlobalLoader_module.animated, GlobalLoader_module.bEndUp),
                                                fill: "none",
                                                d: "M-176-80s34 0 496-6c277-55 549-215 535.5-430.6C841.9-732.1 638.9-975-2-964",
                                                stroke: "#131414",
                                                strokeOpacity: "1",
                                                strokeWidth: "400",
                                                strokeMiterlimit: "4",
                                                strokeLinecap: "butt",
                                                strokeLinejoin: "miter",
                                                strokeDasharray: "2304",
                                                strokeDashoffset: "2304"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        opacity: "1",
                        transform: "translate(1190,1164) translate(-1190,-1164)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                            mask: "url(#GlobalLoader-Mask-bStart)",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                                className: (0,clsx/* default */.Z)(GlobalLoader_module.animated, GlobalLoader_module.bStartMask),
                                transform: "translate(698,1082) translate(500,82)",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                        opacity: "1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "#ff0000",
                                            d: "M1269.5,-1269.5L1269.5,1269.5L-1269.5,1269.5L-1269.5,-1269.5L1269.5,-1269.5Z",
                                            fillOpacity: "0",
                                            fillRule: "nonzero"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                        opacity: "1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            className: (0,clsx/* default */.Z)(GlobalLoader_module.animated, GlobalLoader_module.bStart),
                                            fill: "none",
                                            d: "M-310,-764C-310,-764,-306,776,-306,776",
                                            stroke: "#131414",
                                            strokeOpacity: "1",
                                            strokeWidth: "421",
                                            strokeMiterlimit: "4",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "miter",
                                            strokeDasharray: "0 1540",
                                            strokeDashoffset: "-693"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        mask: "url(#GlobalLoader-Mask-sDown)",
                        opacity: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            transform: "translate(1190 1164)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                    opacity: "1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fill: "red",
                                        d: "M1188-1188v2376h-2376v-2376h2376Z",
                                        fillOpacity: "0",
                                        fillRule: "nonzero"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                    opacity: "1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        className: (0,clsx/* default */.Z)(GlobalLoader_module.animated, GlobalLoader_module.sDown),
                                        fill: "none",
                                        d: "M-42 4c319 168.3 404.9 518 214.2 730.4C-27 956.2-520.5 1027.4-1016 534",
                                        stroke: "#131414",
                                        strokeOpacity: "1",
                                        strokeWidth: "419",
                                        strokeMiterlimit: "4",
                                        strokeLinecap: "butt",
                                        strokeLinejoin: "miter",
                                        strokeDasharray: "2221",
                                        strokeDashoffset: "2221"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                        mask: "url(#GlobalLoader-Mask-sUp)",
                        opacity: "1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            transform: "translate(1190 1164)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                    opacity: "1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        fill: "red",
                                        d: "M1166.5-1166.5v2333h-2333v-2333h2333Z",
                                        fillOpacity: "0",
                                        fillRule: "nonzero"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                    opacity: "1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        className: (0,clsx/* default */.Z)(GlobalLoader_module.animated, GlobalLoader_module.sUp),
                                        fill: "none",
                                        d: "M330-592C126-782-8-950-338-960c-358-10.8-522 256-514 444 6.1 144 98 378 386 378",
                                        stroke: "#131414",
                                        strokeOpacity: "1",
                                        strokeWidth: "419",
                                        strokeMiterlimit: "4",
                                        strokeLinecap: "butt",
                                        strokeLinejoin: "miter",
                                        strokeDasharray: "2150",
                                        strokeDashoffset: "0"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
    if (withOverlay) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* default */.Z, {
            className: (0,clsx/* default */.Z)(GlobalLoader_module.overlay, GlobalLoader_module.container, "flex"),
            children: icon
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx/* default */.Z)(GlobalLoader_module.container, "flex h-full w-full"),
        children: icon
    });
};
/* harmony default export */ const GlobalLoader_GlobalLoader = (GlobalLoader);


/***/ }),

/***/ 90109:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ PageError_PageError)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./src/components/layout/PageLayout/PageLayout.tsx
var PageLayout = __webpack_require__(89902);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(24113);
// EXTERNAL MODULE: ./src/components/feedback/ErrorBlock/ErrorBlock.tsx + 1 modules
var ErrorBlock = __webpack_require__(71109);
;// CONCATENATED MODULE: ./src/compositions/PageError/images/honey.png
const honey_namespaceObject = __webpack_require__.p + "images/honey_2c8ac9.png";
;// CONCATENATED MODULE: ./src/compositions/PageError/PageError.tsx







var PageError = function(props) {
    var children = props.children, className = props.className, title = props.title, text = props.text;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout/* default */.Z, {
        className: (0,clsx/* default */.Z)(className, isMobile ? "pt-40" : "pt-80"),
        withPaddingTop: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
            className: (0,clsx/* default */.Z)("grid grid-cols-[repeat(auto-fit,minmax(49%,1fr))] items-center", isMobile ? "gap-8" : "gap-16"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "w-full max-w-[500rem]",
                    src: honey_namespaceObject,
                    alt: "Honey photo"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBlock/* default */.Z, {
                            title: title,
                            text: text
                        }),
                        children
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ const PageError_PageError = (PageError);


/***/ }),

/***/ 69886:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89902);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24113);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10430);



var PageSkeleton = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                pw: 100,
                h: 100
            })
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PageSkeleton);


/***/ }),

/***/ 63834:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export bgColors */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39682);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24959);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85808);




var bgColors = {
    white: "fff",
    "light-beige": "f7efe9",
    "gray-10": "fafafa",
    "gray-20": "f0f0f0",
    "gray-30": "dadada"
};
var ProductImage = function(props) {
    var className = props.className, src = props.src, alt = props.alt, _props_bgColor = props.bgColor, bgColor = _props_bgColor === void 0 ? "white" : _props_bgColor, _props_fit = props.fit, fit = _props_fit === void 0 ? "contain" : _props_fit, lazy = props.lazy;
    if (!src) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: className,
            fit: fit,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                name: "other/product"
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: className,
        fit: fit,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            src: src,
            alt: alt,
            bgColor: bgColors[bgColor],
            lazy: lazy
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductImage);


/***/ }),

/***/ 88170:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47361);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31627);
/* harmony import */ var components_feedback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87586);





var CommonDrawerModal = function(props) {
    var children = props.children, title = props.title, text = props.text, overlayClosable = props.overlayClosable, closeModal = props.closeModal, dataTestId = props["data-testid"];
    var isMobile = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_feedback__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        className: isMobile ? "min-h-[170rem] bg-light-beige" : null,
        type: isMobile ? "bottom" : "default",
        closeModal: closeModal,
        overlayClosable: overlayClosable,
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                className: "pr-48",
                message: title,
                style: "sh5",
                html: true
            }),
            Boolean(text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                className: "mt-16",
                message: text,
                style: "p2",
                html: true
            }),
            children
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CommonDrawerModal);


/***/ }),

/***/ 46675:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var components_feedback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14830);


// ATTN this file is required only for typechecking
var CommonModal = components_feedback__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CommonModal);


/***/ }),

/***/ 53313:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  _8: () => (/* binding */ openChangePlanErrorModal),
  yQ: () => (/* binding */ openErrorModal),
  mr: () => (/* binding */ openFraudModal),
  Xv: () => (/* binding */ openNetworkErrorModal),
  pC: () => (/* binding */ openServerErrorModal)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@sentry+core@7.93.0/node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(79981);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(31978);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
;// CONCATENATED MODULE: ./src/compositions/modals/ErrorModal/messages.ts
/* harmony default export */ const ErrorModal_messages = ({
    userError: {
        title: {
            en: "Error"
        }
    },
    serverError: {
        title: {
            en: "Something went wrong"
        },
        text: {
            en: '\n      We\'re having technical issues at that moment.<br /><br />Please try again later or contact our customer support\n      at <a href="mailto:support@scentbird.com">support@scentbird.com</a>\n    '
        }
    },
    networkError: {
        title: {
            en: "Network error"
        },
        text: {
            en: '\n      Something is temporarily wrong with your network connection.<br /><br />Please make sure your are connected to the Internet\n      and then reload your browser or contact our customer support at\n      <a href="mailto:support@scentbird.com">support@scentbird.com</a>\n    '
        }
    },
    changePlanError: {
        titleDefault: {
            en: "Please contact our Customer Support team to change plan"
        },
        titleDowngrade: {
            en: "Please contact our Customer Support team to downgrade"
        },
        titleUpgrade: {
            en: "Please contact our Customer Support team to upgrade"
        },
        text: {
            en: ' In order to change your subscription, please contact our Customer Experience team at <a href="mailto:support@scentbird.com">support@scentbird.com</a>'
        }
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/ErrorModal/ErrorModal.tsx






var openErrorModal = function(props) {
    var message = props.message;
    var closeModal = (0,manager/* openModal */.h7)("commonModal", {
        title: ErrorModal_messages.userError.title,
        text: message,
        primaryButton: {
            title: messages/* default */.Z.ok,
            onClick: function() {
                closeModal();
            }
        },
        "data-testid": "errorModal"
    });
};
var openFraudModal = function() {
    return (0,manager/* openModal */.h7)("fraudModal");
};
var openNetworkErrorModal = function() {
    var closeModal = (0,manager/* openModal */.h7)("commonModal", {
        title: ErrorModal_messages.networkError.title,
        text: ErrorModal_messages.networkError.text,
        primaryButton: {
            title: messages/* default */.Z.ok,
            onClick: function() {
                closeModal();
            }
        },
        "data-testid": "errorModal"
    });
};
var openServerErrorModal = function() {
    var lastEventId = esm_exports/* lastEventId */.eW();
    var closeModal = (0,manager/* openModal */.h7)("commonModal", {
        title: ErrorModal_messages.serverError.title,
        text: ErrorModal_messages.serverError.text,
        children: Boolean(lastEventId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "text-p4 text-gray-50",
            children: [
                "Sentry ID: ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://sentry.scentbird.com/organizations/scentbird/issues/?query=".concat(lastEventId),
                    children: lastEventId
                })
            ]
        }),
        primaryButton: {
            title: messages/* default */.Z.ok,
            onClick: function() {
                closeModal();
            }
        },
        "data-testid": "errorModal"
    });
};
var openChangePlanErrorModal = function(action) {
    var title;
    if (action === "downgrade") {
        title = ErrorModal_messages.changePlanError.titleDowngrade;
    } else if (action === "upgrade") {
        title = ErrorModal_messages.changePlanError.titleUpgrade;
    } else {
        title = ErrorModal_messages.changePlanError.titleDefault;
    }
    var closeModal = (0,manager/* openModal */.h7)("commonModal", {
        title: title,
        text: ErrorModal_messages.changePlanError.text,
        primaryButton: {
            title: messages/* default */.Z.gotIt,
            onClick: function() {
                closeModal();
            }
        },
        "data-testid": "errorModal"
    });
};


/***/ }),

/***/ 58999:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ FraudModal_FraudModal)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/components/feedback/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(14830);
;// CONCATENATED MODULE: ./src/compositions/modals/FraudModal/messages.ts
/* harmony default export */ const messages = ({
    modalTitle: {
        en: "Sorry, this account has been flagged for fraudulent activity"
    },
    modalText: {
        en: "It looks like this account has been tampered with, please contact Customer Support for steps to unblock your account."
    },
    buttonTitle: {
        en: "Help me restore my account"
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/FraudModal/FraudModal.tsx






var FraudModal = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        title: messages.modalTitle,
        text: messages.modalText,
        withCloseButton: false,
        overlayClosable: false,
        closeModal: null,
        "data-testid": "fraudModal",
        primaryButton: {
            href: "".concat(links/* default */.ZP.profile.personalInfo, "?solvvyWF=a14e6f27-7e6b-4c2b-9e35-1b883ca5497e"),
            title: messages.buttonTitle
        }
    });
};
/* harmony default export */ const FraudModal_FraudModal = (FraudModal);


/***/ }),

/***/ 32624:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ErrorNotification_ErrorNotification)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/compositions/notifications/PlainNotification/PlainNotification.tsx
var PlainNotification = __webpack_require__(99611);
;// CONCATENATED MODULE: ./src/compositions/notifications/ErrorNotification/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Error"
    }
});

;// CONCATENATED MODULE: ./src/compositions/notifications/ErrorNotification/ErrorNotification.tsx




var ErrorNotification = function(param) {
    var message = param.message, closeNotification = param.closeNotification;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainNotification/* default */.Z, {
        title: messages.title,
        text: message,
        closeNotification: closeNotification
    });
};
/* harmony default export */ const ErrorNotification_ErrorNotification = (ErrorNotification);


/***/ }),

/***/ 41028:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ GiftWithSpendThresholdNotification_GiftWithSpendThresholdNotification)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./src/components/feedback/Notification/Notification.tsx + 1 modules
var Notification = __webpack_require__(90869);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/compositions/ProductImage/ProductImage.tsx
var ProductImage = __webpack_require__(63834);
;// CONCATENATED MODULE: ./src/compositions/notifications/GiftWithSpendThresholdNotification/messages.ts
/* harmony default export */ const messages = ({
    offer: {
        en: "Get a free {name} with purchases over {price}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/notifications/GiftWithSpendThresholdNotification/GiftWithSpendThresholdNotification.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const GiftWithSpendThresholdNotification_module = ({"notification":"stYp2x","image":"lzqD2M"});
;// CONCATENATED MODULE: ./src/compositions/notifications/GiftWithSpendThresholdNotification/GiftWithSpendThresholdNotification.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var GiftWithSpendThresholdNotification = function(props) {
    var closeNotification = props.closeNotification, image = props.image, name = props.name, onClose = props.onClose, staticMode = props.staticMode, threshold = props.threshold;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification/* default */.Z, {
        className: GiftWithSpendThresholdNotification_module.notification,
        closeNotification: closeNotification,
        timeout: staticMode ? null : undefined,
        withAnimation: !staticMode,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage/* default */.Z, {
                    className: (0,clsx/* default */.Z)("flex-none", GiftWithSpendThresholdNotification_module.image),
                    bgColor: "light-beige",
                    src: image
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        message: _object_spread_props(_object_spread({}, messages.offer), {
                            values: {
                                name: name,
                                price: (0,formatPrice/* default */.Z)(threshold, {
                                    removeZeroCents: true
                                })
                            }
                        }),
                        style: "sh6",
                        html: true
                    })
                })
            ]
        })
    });
};
/* harmony default export */ const GiftWithSpendThresholdNotification_GiftWithSpendThresholdNotification = (/*#__PURE__*/react.memo(GiftWithSpendThresholdNotification));


/***/ }),

/***/ 61156:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ NetworkErrorNotification_NetworkErrorNotification)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/compositions/notifications/PlainNotification/PlainNotification.tsx
var PlainNotification = __webpack_require__(99611);
;// CONCATENATED MODULE: ./src/compositions/notifications/NetworkErrorNotification/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Network error"
    },
    text: {
        en: '\n      Something is temporarily wrong with your network connection.<br /><br />Please make sure your are connected to the Internet\n      and then reload your browser or contact our customer support at\n      <a href="mailto:support@scentbird.com">support@scentbird.com</a>\n    '
    }
});

;// CONCATENATED MODULE: ./src/compositions/notifications/NetworkErrorNotification/NetworkErrorNotification.tsx




var NetworkErrorNotification = function(param) {
    var closeNotification = param.closeNotification;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainNotification/* default */.Z, {
        title: messages.title,
        text: messages.text,
        closeNotification: closeNotification
    });
};
/* harmony default export */ const NetworkErrorNotification_NetworkErrorNotification = (NetworkErrorNotification);


/***/ }),

/***/ 99611:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31627);
/* harmony import */ var components_feedback__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90869);




var PlainNotification = function(props) {
    var title = props.title, text = props.text, _props_titleColor = props.titleColor, titleColor = _props_titleColor === void 0 ? "gold-50" : _props_titleColor, textColor = props.textColor, onClick = props.onClick, closeNotification = props.closeNotification, onClose = props.onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_feedback__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        closeNotification: closeNotification,
        onClick: onClick,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                style: "h8",
                message: title,
                color: titleColor,
                "data-testid": "title"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                className: "mt-8",
                style: "p4",
                message: text,
                color: textColor,
                html: true,
                "data-testid": "text"
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PlainNotification);


/***/ }),

/***/ 27262:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ProductAddedNotification_ProductAddedNotification)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(54939);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(14939);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(51827);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./src/modules/cart/index.ts + 4 modules
var cart = __webpack_require__(65337);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(24959);
// EXTERNAL MODULE: ./src/components/feedback/Notification/Notification.tsx + 1 modules
var Notification = __webpack_require__(90869);
// EXTERNAL MODULE: ./src/compositions/ProductImage/ProductImage.tsx
var ProductImage = __webpack_require__(63834);
// EXTERNAL MODULE: ./src/compositions/notifications/SuccessNotification/SuccessNotification.tsx + 1 modules
var SuccessNotification = __webpack_require__(96159);
;// CONCATENATED MODULE: ./src/compositions/notifications/ProductAddedNotification/messages.ts
/* harmony default export */ const messages = ({
    addedToYourCart: {
        en: "Added to your cart"
    },
    addedToYourCartAb: {
        en: "Added, go to your cart"
    },
    addedToYourQueue: {
        en: "Added to your queue"
    },
    addedToYourQueueAb: {
        en: "Added, go to your queue"
    },
    addedToCart: {
        en: "Added to cart"
    },
    addedToQueue: {
        en: "Added to queue"
    },
    multipleAdded: {
        en: "{count, plural, one {Product was} other {# products were}} added"
    },
    productName: {
        variety: {
            en: "{name} with {variety} Scent"
        },
        drift: {
            en: "{name} in {variety}"
        }
    }
});

;// CONCATENATED MODULE: ./src/compositions/notifications/ProductAddedNotification/ProductAddedNotification.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


















var ProductAddedNotification = function(props) {
    var closeNotification = props.closeNotification, to = props.to, _props_count = props.count, count = _props_count === void 0 ? 1 : _props_count, brand = props.brand, name = props.name, image = props.image, rebrandImage = props.rebrandImage, drift = props.drift, variety = props.variety;
    var _ref = drift || {}, driftDescription = _ref.description, driftImage = _ref.image, driftName = _ref.name;
    var _ref1 = variety || {}, varietyName = _ref1.name;
    var history = (0,contexts/* useHistory */.k6)();
    var isDesignUpdateEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.cartNotificationDesignUpdate) === "b";
    var isQueueRedirectEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.queueNotificationLandToQueuePage) === "b";
    var hasDrift = Boolean(drift);
    var hasVariety = Boolean(varietyName);
    var productImage = driftImage || rebrandImage || image;
    var brandLine = driftName || brand;
    var driftNameLine = hasDrift && hasVariety && _object_spread_props(_object_spread({}, messages.productName.drift), {
        values: {
            name: driftDescription,
            variety: varietyName
        }
    });
    var varietyNameLine = hasVariety && _object_spread_props(_object_spread({}, messages.productName.variety), {
        values: {
            name: name,
            variety: varietyName
        }
    });
    var nameLine = driftNameLine || varietyNameLine || name;
    var isAddedToCart = to === "cart";
    var handleClick = (0,react.useCallback)(function() {
        if (isAddedToCart) {
            (0,cart/* openCartModal */.kZ)({
                flow: "Product added notification"
            });
        } else if (isQueueRedirectEnabled) {
            history.push(links/* default */.ZP.queue);
        }
    }, [
        isAddedToCart,
        isQueueRedirectEnabled
    ]);
    if (count > 1 || !name) {
        var title = isAddedToCart ? messages.addedToCart : messages.addedToQueue;
        var text = _object_spread_props(_object_spread({}, messages.multipleAdded), {
            values: {
                count: count
            }
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessNotification/* default */.Z, {
            title: title,
            text: text,
            onClick: handleClick,
            closeNotification: closeNotification
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification/* default */.Z, {
        closeNotification: closeNotification,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex",
            children: [
                Boolean(productImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage/* default */.Z, {
                    className: (0,clsx/* default */.Z)("-my-8 -ml-16 flex-none", isDesignUpdateEnabled && isAddedToCart ? "mr-12 h-[60rem] w-[60rem]" : "mr-16 h-[80rem] w-80"),
                    src: productImage,
                    alt: "".concat(brand, " ").concat(name)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-1",
                    children: [
                        Boolean(brandLine) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    style: "h8",
                                    message: brandLine,
                                    color: "gold-50",
                                    "data-testid": "brand"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    className: "mt-8",
                                    style: "p4",
                                    message: nameLine,
                                    "data-testid": "name"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            style: "h8",
                            message: nameLine,
                            color: "gold-50",
                            "data-testid": "name"
                        }),
                        isDesignUpdateEnabled || isQueueRedirectEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-12 flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                    name: "24/checkmark-in-circle",
                                    color: "green"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    className: "ml-8 whitespace-nowrap",
                                    style: "p4",
                                    message: isAddedToCart ? messages.addedToYourCartAb : messages.addedToYourQueueAb,
                                    "data-testid": "text"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                    className: "ml-8",
                                    name: "other/long-arrow-right"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mt-8",
                            style: "p5",
                            message: isAddedToCart ? messages.addedToYourCart : messages.addedToYourQueue,
                            "data-testid": "text"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ const ProductAddedNotification_ProductAddedNotification = (ProductAddedNotification);


/***/ }),

/***/ 67803:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ServerErrorNotification_ServerErrorNotification)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/compositions/notifications/PlainNotification/PlainNotification.tsx
var PlainNotification = __webpack_require__(99611);
;// CONCATENATED MODULE: ./src/compositions/notifications/ServerErrorNotification/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Something went wrong"
    },
    text: {
        en: '\n      We\'re having technical issues at that moment.<br /><br />Please try again later or contact our customer support\n      at <a href="mailto:support@scentbird.com">support@scentbird.com</a>\n    '
    }
});

;// CONCATENATED MODULE: ./src/compositions/notifications/ServerErrorNotification/ServerErrorNotification.tsx




var ServerErrorNotification = function(param) {
    var closeNotification = param.closeNotification;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainNotification/* default */.Z, {
        title: messages.title,
        text: messages.text,
        closeNotification: closeNotification
    });
};
/* harmony default export */ const ServerErrorNotification_ServerErrorNotification = (ServerErrorNotification);


/***/ }),

/***/ 96159:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ SuccessNotification_SuccessNotification)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/compositions/notifications/PlainNotification/PlainNotification.tsx
var PlainNotification = __webpack_require__(99611);
;// CONCATENATED MODULE: ./src/compositions/notifications/SuccessNotification/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Success"
    }
});

;// CONCATENATED MODULE: ./src/compositions/notifications/SuccessNotification/SuccessNotification.tsx




var SuccessNotification = function(param) {
    var title = param.title, text = param.text, closeNotification = param.closeNotification;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainNotification/* default */.Z, {
        title: title || messages.title,
        text: text,
        closeNotification: closeNotification
    });
};
/* harmony default export */ const SuccessNotification_SuccessNotification = (SuccessNotification);


/***/ }),

/***/ 48145:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   a: () => (/* binding */ GlobalLoaderContext)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var compositions_GlobalLoader_GlobalLoader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40037);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}



var GlobalLoaderContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(null);
var GlobalLoaderProvider = function(param) {
    var children = param.children;
    var _useState = _sliced_to_array((0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), 2), isVisible = _useState[0], setVisibility = _useState[1];
    var value = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            showLoader: function() {
                return setVisibility(true);
            },
            hideLoader: function() {
                return setVisibility(false);
            }
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(GlobalLoaderContext.Provider, {
        value: value,
        children: [
            children,
            isVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_GlobalLoader_GlobalLoader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                withOverlay: true
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (GlobalLoaderProvider);


/***/ }),

/***/ 72829:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export templates */
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40963);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52983);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98716);
/* harmony import */ var notifications__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(93231);
/* harmony import */ var compositions_notifications_PlainNotification_PlainNotification__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99611);
/* harmony import */ var compositions_notifications_SuccessNotification_SuccessNotification__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96159);
/* harmony import */ var compositions_notifications_ErrorNotification_ErrorNotification__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32624);
/* harmony import */ var compositions_notifications_ServerErrorNotification_ServerErrorNotification__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67803);
/* harmony import */ var compositions_notifications_NetworkErrorNotification_NetworkErrorNotification__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61156);
/* harmony import */ var compositions_notifications_ProductAddedNotification_ProductAddedNotification__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27262);
/* harmony import */ var compositions_notifications_GiftWithSpendThresholdNotification_GiftWithSpendThresholdNotification__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(41028);
/* harmony import */ var _Notifications_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9175);














var templates = {
    plain: compositions_notifications_PlainNotification_PlainNotification__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
    success: compositions_notifications_SuccessNotification_SuccessNotification__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
    error: compositions_notifications_ErrorNotification_ErrorNotification__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z,
    serverError: compositions_notifications_ServerErrorNotification_ServerErrorNotification__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z,
    networkError: compositions_notifications_NetworkErrorNotification_NetworkErrorNotification__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z,
    productAdded: compositions_notifications_ProductAddedNotification_ProductAddedNotification__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z,
    giftWithSpendThreshold: compositions_notifications_GiftWithSpendThresholdNotification_GiftWithSpendThresholdNotification__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z,
    limitedDropNotification: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-notifications-LimitedDropNotification-LimitedDropNotification";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-notifications-LimitedDropNotification-LimitedDropNotification */[__webpack_require__.e(6471), __webpack_require__.e(9860)]).then(__webpack_require__.bind(__webpack_require__, 61905));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(61905);
            }
            return eval("require.resolve")("compositions/notifications/LimitedDropNotification/LimitedDropNotification");
        }
    })
};
var Notifications = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(notifications__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        className: _Notifications_module_css__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.notifications,
        templates: templates
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Notifications);


/***/ }),

/***/ 4213:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   i: () => (/* binding */ useAuthPage)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33273);
/* harmony import */ var core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52983);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69541);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84584);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68964);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12404);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83901);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17382);
/* harmony import */ var modules_recommendations_quiz__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31822);
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}









var AuthPageContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.createContext)(null);
var useAuthPage = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(AuthPageContext);
};
var getFlowByRedirectUrl = function(url) {
    if (!url) {
        return "Default";
    }
    if (url.startsWith(links__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.subscribe)) {
        return "Subscription";
    }
    if (url.startsWith(links__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.giftSubscriptionPayment)) {
        return "Gift";
    }
    if (url.startsWith(links__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.giftCardPayment)) {
        return "Gift card";
    }
    if (url.startsWith(links__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.checkout)) {
        return "Payment";
    }
    if (url.startsWith(links__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.scentProfile)) {
        return "Quiz";
    }
    return "Default";
};
var AuthPageProvider = function(props) {
    var children = props.children, _props_withRedirect = props.withRedirect, withRedirect = _props_withRedirect === void 0 ? true : _props_withRedirect;
    var _useSearchParams = _sliced_to_array((0,router__WEBPACK_IMPORTED_MODULE_5__/* .useSearchParams */ .lr)(), 1), _useSearchParams_ = _useSearchParams[0], customRedirectUrl = _useSearchParams_.redirect, isExpired = _useSearchParams_.expired;
    var history = (0,router__WEBPACK_IMPORTED_MODULE_5__/* .useHistory */ .k6)();
    var isRenderedRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(false);
    var _useUser = (0,modules_user__WEBPACK_IMPORTED_MODULE_6__/* .useUser */ .a)(), isLoggedIn = _useUser.isLoggedIn, isFetching = _useUser.isFetching;
    var _useQuizResult = (0,modules_recommendations_quiz__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(), hasValidQuizParams = _useQuizResult.isValid, sendQuizResult = _useQuizResult.sendResult;
    var redirectUrl = (0,helpers__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(customRedirectUrl) || links__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.subscription.main;
    var onRedirectRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    // ATTN it is required because component will be re-rendered after cache update with old onRedirect callback
    onRedirectRef.current = /*#__PURE__*/ _async_to_generator(function() {
        var error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!hasValidQuizParams) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        sendQuizResult()
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    (0,helpers__WEBPACK_IMPORTED_MODULE_9__/* .processError */ .wY)(error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    history.push(redirectUrl, {
                        searchParams: {
                            redirect: null
                        }
                    });
                    return [
                        2
                    ];
            }
        });
    });
    var value = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        // if redirect param is set to 'Quiz' we treat it as flow
        var flow = getFlowByRedirectUrl(customRedirectUrl);
        var isFlow = flow === "Quiz";
        return {
            isFlow: isFlow,
            flow: flow,
            redirectUrl: redirectUrl,
            isExpired: Boolean(isExpired),
            onRedirect: function() {
                onRedirectRef.current();
            }
        };
    }, [
        customRedirectUrl,
        redirectUrl,
        isExpired
    ]);
    // don't hide page if it was rendered before during loading
    if (!isRenderedRef.current) {
        if (isFetching) {
            return null;
        }
        if (isLoggedIn && withRedirect) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(router__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                to: redirectUrl,
                withSearch: true,
                searchParams: {
                    redirect: null,
                    magicToken: null
                }
            });
        }
    }
    isRenderedRef.current = true;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(AuthPageContext.Provider, {
        value: value,
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AuthPageProvider);


/***/ }),

/***/ 94455:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35570);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69541);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84584);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68964);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17382);






var HasAuth = function(param) {
    var children = param.children, _param_isRegisterFlow = param.isRegisterFlow, isRegisterFlow = _param_isRegisterFlow === void 0 ? false : _param_isRegisterFlow;
    var currentUrl = (0,router__WEBPACK_IMPORTED_MODULE_3__/* .useLocationState */ .KJ)().currentUrl;
    var _useUser = (0,modules_user__WEBPACK_IMPORTED_MODULE_4__/* .useUser */ .a)(), isLoggedIn = _useUser.isLoggedIn, isFetching = _useUser.isFetching;
    if (isFetching) {
        return null;
    }
    if (!isLoggedIn) {
        var link = isRegisterFlow ? links__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP.register : links__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP.login;
        var to = "".concat(link, "?redirect=").concat(encodeURIComponent(currentUrl));
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(router__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            to: to,
            withSearch: true
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HasAuth);


/***/ }),

/***/ 96973:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69541);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68964);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91339);
/* harmony import */ var compositions_PageSkeleton_PageSkeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69886);






var HasNeverSubscribed = function(param) {
    var children = param.children;
    var _useSubscription = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_2__/* .useSubscription */ .m)(), subscription = _useSubscription.subscription, isFetching = _useSubscription.isFetching;
    if (isFetching) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_PageSkeleton_PageSkeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {});
    }
    if (!subscription.hasNeverSubscribed) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(router__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            to: links__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP.subscription.main
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HasNeverSubscribed);


/***/ }),

/***/ 64340:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40963);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52983);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98716);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31978);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98119);
/* harmony import */ var compositions_modals_CommonModal_CommonModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46675);
/* harmony import */ var compositions_modals_CommonDrawerModal_CommonDrawerModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88170);
/* harmony import */ var compositions_GlobalLoader_GlobalLoader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40037);









var fallback = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(compositions_GlobalLoader_GlobalLoader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    withOverlay: true
});
var registry = {
    commonModal: compositions_modals_CommonModal_CommonModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
    commonDrawerModal: compositions_modals_CommonDrawerModal_CommonDrawerModal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
    fraudModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-FraudModal-FraudModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 58999));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(58999);
            }
            return eval("require.resolve")("compositions/modals/FraudModal/FraudModal");
        }
    }, {
        fallback: fallback
    }),
    searchModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-SearchModal-SearchModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-SearchModal-SearchModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(7936), __webpack_require__.e(3169), __webpack_require__.e(6418), __webpack_require__.e(1862), __webpack_require__.e(60), __webpack_require__.e(9410)]).then(__webpack_require__.bind(__webpack_require__, 89525));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(89525);
            }
            return eval("require.resolve")("compositions/modals/SearchModal/SearchModal");
        }
    }, {
        fallback: fallback
    }),
    chatAssistanceModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-ChatAssistanceModal-ChatAssistanceModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-ChatAssistanceModal-ChatAssistanceModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(1862), __webpack_require__.e(60), __webpack_require__.e(3706)]).then(__webpack_require__.bind(__webpack_require__, 8657));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(8657);
            }
            return eval("require.resolve")("compositions/modals/ChatAssistanceModal/ChatAssistanceModal");
        }
    }, {
        fallback: fallback
    }),
    cartModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-CartModal-CartModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-CartModal-CartModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6471), __webpack_require__.e(5529), __webpack_require__.e(3256), __webpack_require__.e(6818), __webpack_require__.e(4624), __webpack_require__.e(60), __webpack_require__.e(207)]).then(__webpack_require__.bind(__webpack_require__, 29492));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(29492);
            }
            return eval("require.resolve")("compositions/modals/CartModal/CartModal");
        }
    }, {
        fallback: fallback
    }),
    faqModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-faq-FaqModal-FaqModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-faq-FaqModal-FaqModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(610), __webpack_require__.e(5173)]).then(__webpack_require__.bind(__webpack_require__, 62172));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(62172);
            }
            return eval("require.resolve")("compositions/faq/FaqModal/FaqModal");
        }
    }, {
        fallback: fallback
    }),
    firstProductModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-FirstProductModal-FirstProductModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-FirstProductModal-FirstProductModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(4624), __webpack_require__.e(60), __webpack_require__.e(6321)]).then(__webpack_require__.bind(__webpack_require__, 74451));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(74451);
            }
            return eval("require.resolve")("compositions/modals/FirstProductModal/FirstProductModal");
        }
    }, {
        fallback: fallback
    }),
    addressVerificationModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-AddressVerificationModal-AddressVerificationModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-AddressVerificationModal-AddressVerificationModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(7064)]).then(__webpack_require__.bind(__webpack_require__, 13059));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(13059);
            }
            return eval("require.resolve")("compositions/modals/AddressVerificationModal/AddressVerificationModal");
        }
    }, {
        fallback: fallback
    }),
    shippingAddressModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-ShippingAddressModal-ShippingAddressModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-ShippingAddressModal-ShippingAddressModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(8371), __webpack_require__.e(7936), __webpack_require__.e(874), __webpack_require__.e(1969), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(2829)]).then(__webpack_require__.bind(__webpack_require__, 57727));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(57727);
            }
            return eval("require.resolve")("compositions/modals/ShippingAddressModal/ShippingAddressModal");
        }
    }, {
        fallback: fallback
    }),
    newPaymentMethodModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-NewPaymentMethodModal-NewPaymentMethodModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-NewPaymentMethodModal-NewPaymentMethodModal */[__webpack_require__.e(532), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(6471), __webpack_require__.e(8371), __webpack_require__.e(3256), __webpack_require__.e(1582), __webpack_require__.e(1862), __webpack_require__.e(5047), __webpack_require__.e(5617)]).then(__webpack_require__.bind(__webpack_require__, 38023));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(38023);
            }
            return eval("require.resolve")("compositions/modals/NewPaymentMethodModal/NewPaymentMethodModal");
        }
    }, {
        fallback: fallback
    }),
    candleSubscriptionConfirmationModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-CandleSubscriptionConfirmationModal-CandleSubscriptionConfirmationModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-CandleSubscriptionConfirmationModal-CandleSubscriptionConfirmationModal */[__webpack_require__.e(1262), __webpack_require__.e(3292)]).then(__webpack_require__.bind(__webpack_require__, 34650));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(34650);
            }
            return eval("require.resolve")("compositions/modals/CandleSubscriptionConfirmationModal/CandleSubscriptionConfirmationModal");
        }
    }, {
        fallback: fallback
    }),
    caseSubscriptionConfirmationModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-CaseSubscriptionConfirmationModal-CaseSubscriptionConfirmationModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-CaseSubscriptionConfirmationModal-CaseSubscriptionConfirmationModal */[__webpack_require__.e(1262), __webpack_require__.e(1916)]).then(__webpack_require__.bind(__webpack_require__, 5603));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(5603);
            }
            return eval("require.resolve")("compositions/modals/CaseSubscriptionConfirmationModal/CaseSubscriptionConfirmationModal");
        }
    }, {
        fallback: fallback
    }),
    cardUpdateModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-CardUpdateModal-CardUpdateModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-CardUpdateModal-CardUpdateModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(7369), __webpack_require__.e(8371), __webpack_require__.e(7936), __webpack_require__.e(8101), __webpack_require__.e(3166), __webpack_require__.e(4975)]).then(__webpack_require__.bind(__webpack_require__, 49402));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(49402);
            }
            return eval("require.resolve")("compositions/modals/CardUpdateModal/CardUpdateModal");
        }
    }, {
        fallback: fallback
    }),
    productReviewModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-productReview-ProductReviewModal-ProductReviewModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-productReview-ProductReviewModal-ProductReviewModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(7369), __webpack_require__.e(547), __webpack_require__.e(1862), __webpack_require__.e(60), __webpack_require__.e(4590)]).then(__webpack_require__.bind(__webpack_require__, 7810));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(7810);
            }
            return eval("require.resolve")("compositions/modals/productReview/ProductReviewModal/ProductReviewModal");
        }
    }, {
        fallback: fallback
    }),
    productReviewTagsModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-productReview-ProductReviewTagsModal-ProductReviewTagsModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-productReview-ProductReviewTagsModal-ProductReviewTagsModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(547), __webpack_require__.e(60), __webpack_require__.e(760)]).then(__webpack_require__.bind(__webpack_require__, 23391));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(23391);
            }
            return eval("require.resolve")("compositions/modals/productReview/ProductReviewTagsModal/ProductReviewTagsModal");
        }
    }, {
        fallback: fallback
    }),
    afterProductReviewModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-productReview-AfterProductReviewModal-AfterProductReviewModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return __webpack_require__.e(/* import() | compositions-modals-productReview-AfterProductReviewModal-AfterProductReviewModal */ 3174).then(__webpack_require__.bind(__webpack_require__, 71387));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(71387);
            }
            return eval("require.resolve")("compositions/modals/productReview/AfterProductReviewModal/AfterProductReviewModal");
        }
    }, {
        fallback: fallback
    }),
    lastShipmentReviewModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-productReview-LastShipmentReviewModal-LastShipmentReviewModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-productReview-LastShipmentReviewModal-LastShipmentReviewModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(60), __webpack_require__.e(7714)]).then(__webpack_require__.bind(__webpack_require__, 58348));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(58348);
            }
            return eval("require.resolve")("compositions/modals/productReview/LastShipmentReviewModal/LastShipmentReviewModal");
        }
    }, {
        fallback: fallback
    }),
    verifyShippingAddressModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-VerifyShippingAddressModal-VerifyShippingAddressModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-VerifyShippingAddressModal-VerifyShippingAddressModal */[__webpack_require__.e(8383), __webpack_require__.e(60), __webpack_require__.e(43)]).then(__webpack_require__.bind(__webpack_require__, 43493));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(43493);
            }
            return eval("require.resolve")("compositions/modals/VerifyShippingAddressModal/VerifyShippingAddressModal");
        }
    }, {
        fallback: fallback
    }),
    resubscribeModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-ResubscribeModal-ResubscribeModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-ResubscribeModal-ResubscribeModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7369), __webpack_require__.e(6471), __webpack_require__.e(5529), __webpack_require__.e(255), __webpack_require__.e(7936), __webpack_require__.e(8101), __webpack_require__.e(1398), __webpack_require__.e(5771)]).then(__webpack_require__.bind(__webpack_require__, 59711));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(59711);
            }
            return eval("require.resolve")("compositions/modals/ResubscribeModal/ResubscribeModal");
        }
    }, {
        fallback: fallback
    }),
    resubscribePromoModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-ResubscribePromoModal-ResubscribePromoModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-ResubscribePromoModal-ResubscribePromoModal */[__webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(5529), __webpack_require__.e(255), __webpack_require__.e(7936), __webpack_require__.e(8101), __webpack_require__.e(1398), __webpack_require__.e(60), __webpack_require__.e(3953)]).then(__webpack_require__.bind(__webpack_require__, 28463));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(28463);
            }
            return eval("require.resolve")("compositions/modals/ResubscribePromoModal/ResubscribePromoModal");
        }
    }, {
        fallback: fallback
    }),
    addToQueueUpgradeModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-AddToQueueUpgradeModal-AddToQueueUpgradeModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-AddToQueueUpgradeModal-AddToQueueUpgradeModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(255), __webpack_require__.e(1862), __webpack_require__.e(60), __webpack_require__.e(1022)]).then(__webpack_require__.bind(__webpack_require__, 31138));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(31138);
            }
            return eval("require.resolve")("compositions/modals/AddToQueueUpgradeModal/AddToQueueUpgradeModal");
        }
    }, {
        fallback: fallback
    }),
    putFirstToQueueModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-PutFirstToQueueModal-PutFirstToQueueModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return __webpack_require__.e(/* import() | compositions-modals-PutFirstToQueueModal-PutFirstToQueueModal */ 3433).then(__webpack_require__.bind(__webpack_require__, 42522));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(42522);
            }
            return eval("require.resolve")("compositions/modals/PutFirstToQueueModal/PutFirstToQueueModal");
        }
    }, {
        fallback: fallback
    }),
    addPremiumModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-AddPremiumModal-AddPremiumModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-AddPremiumModal-AddPremiumModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(6689)]).then(__webpack_require__.bind(__webpack_require__, 87352));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(87352);
            }
            return eval("require.resolve")("compositions/modals/AddPremiumModal/AddPremiumModal");
        }
    }, {
        fallback: fallback
    }),
    outOfStockModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-OutOfStockModal-OutOfStockModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-OutOfStockModal-OutOfStockModal */[__webpack_require__.e(5529), __webpack_require__.e(8307)]).then(__webpack_require__.bind(__webpack_require__, 73859));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(73859);
            }
            return eval("require.resolve")("compositions/modals/OutOfStockModal/OutOfStockModal");
        }
    }, {
        fallback: fallback
    }),
    needPaymentDataModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-NeedPaymentDataModal-NeedPaymentDataModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-NeedPaymentDataModal-NeedPaymentDataModal */[__webpack_require__.e(5529), __webpack_require__.e(6341)]).then(__webpack_require__.bind(__webpack_require__, 72688));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(72688);
            }
            return eval("require.resolve")("compositions/modals/NeedPaymentDataModal/NeedPaymentDataModal");
        }
    }, {
        fallback: fallback
    }),
    activateAccountModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-ActivateAccountModal-ActivateAccountModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return __webpack_require__.e(/* import() | compositions-modals-ActivateAccountModal-ActivateAccountModal */ 9654).then(__webpack_require__.bind(__webpack_require__, 86602));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(86602);
            }
            return eval("require.resolve")("compositions/modals/ActivateAccountModal/ActivateAccountModal");
        }
    }, {
        fallback: fallback
    }),
    brandOptInModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-BrandOptInModal-BrandOptInModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-BrandOptInModal-BrandOptInModal */[__webpack_require__.e(1262), __webpack_require__.e(6113), __webpack_require__.e(7369), __webpack_require__.e(1862), __webpack_require__.e(60), __webpack_require__.e(7171)]).then(__webpack_require__.bind(__webpack_require__, 10715));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(10715);
            }
            return eval("require.resolve")("compositions/modals/BrandOptInModal/BrandOptInModal");
        }
    }, {
        fallback: fallback
    }),
    sameProductModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-SameProductModal-SameProductModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return __webpack_require__.e(/* import() | compositions-modals-SameProductModal-SameProductModal */ 4065).then(__webpack_require__.bind(__webpack_require__, 33424));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(33424);
            }
            return eval("require.resolve")("compositions/modals/SameProductModal/SameProductModal");
        }
    }, {
        fallback: fallback
    }),
    cancelSkipModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-CancelSkipModal-CancelSkipModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-CancelSkipModal-CancelSkipModal */[__webpack_require__.e(9313), __webpack_require__.e(9374)]).then(__webpack_require__.bind(__webpack_require__, 84573));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(84573);
            }
            return eval("require.resolve")("compositions/modals/CancelSkipModal/CancelSkipModal");
        }
    }, {
        fallback: fallback
    }),
    upgradeSubscriptionModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-UpgradeSubscriptionModal-UpgradeSubscriptionModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-UpgradeSubscriptionModal-UpgradeSubscriptionModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7369), __webpack_require__.e(255), __webpack_require__.e(1862), __webpack_require__.e(60), __webpack_require__.e(4478)]).then(__webpack_require__.bind(__webpack_require__, 64712));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(64712);
            }
            return eval("require.resolve")("compositions/modals/UpgradeSubscriptionModal/UpgradeSubscriptionModal");
        }
    }, {
        fallback: fallback
    }),
    upgradeSubscriptionSummaryModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-UpgradeSubscriptionSummaryModal-UpgradeSubscriptionSummaryModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-UpgradeSubscriptionSummaryModal-UpgradeSubscriptionSummaryModal */[__webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(255), __webpack_require__.e(2066)]).then(__webpack_require__.bind(__webpack_require__, 9389));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(9389);
            }
            return eval("require.resolve")("compositions/modals/UpgradeSubscriptionSummaryModal/UpgradeSubscriptionSummaryModal");
        }
    }, {
        fallback: fallback
    }),
    firstTimeVisitModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-FirstTimeVisitModal-FirstTimeVisitModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-FirstTimeVisitModal-FirstTimeVisitModal */[__webpack_require__.e(7369), __webpack_require__.e(3778)]).then(__webpack_require__.bind(__webpack_require__, 59293));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(59293);
            }
            return eval("require.resolve")("compositions/modals/FirstTimeVisitModal/FirstTimeVisitModal");
        }
    }, {
        fallback: fallback
    }),
    candleSubscriptionPromoModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-CandleSubscriptionPromoModal-CandleSubscriptionPromoModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-CandleSubscriptionPromoModal-CandleSubscriptionPromoModal */[__webpack_require__.e(7369), __webpack_require__.e(6450)]).then(__webpack_require__.bind(__webpack_require__, 54011));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(54011);
            }
            return eval("require.resolve")("compositions/modals/CandleSubscriptionPromoModal/CandleSubscriptionPromoModal");
        }
    }, {
        fallback: fallback
    }),
    privateSaleModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-PrivateSaleModal-PrivateSaleModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-PrivateSaleModal-PrivateSaleModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(7865), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(6471), __webpack_require__.e(60), __webpack_require__.e(986)]).then(__webpack_require__.bind(__webpack_require__, 7754));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(7754);
            }
            return eval("require.resolve")("compositions/modals/PrivateSaleModal/PrivateSaleModal");
        }
    }, {
        fallback: fallback
    }),
    tossInModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-TossInModal-TossInModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-TossInModal-TossInModal */[__webpack_require__.e(7369), __webpack_require__.e(3885)]).then(__webpack_require__.bind(__webpack_require__, 83624));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(83624);
            }
            return eval("require.resolve")("compositions/modals/TossInModal/TossInModal");
        }
    }, {
        fallback: fallback
    }),
    tryTwoThreeFragrancesModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-TryTwoThreeFragrancesModal-TryTwoThreeFragrancesModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-TryTwoThreeFragrancesModal-TryTwoThreeFragrancesModal */[__webpack_require__.e(7369), __webpack_require__.e(4115)]).then(__webpack_require__.bind(__webpack_require__, 40048));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(40048);
            }
            return eval("require.resolve")("compositions/modals/TryTwoThreeFragrancesModal/TryTwoThreeFragrancesModal");
        }
    }, {
        fallback: fallback
    }),
    mobileAppModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-MobileAppModal-MobileAppModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-MobileAppModal-MobileAppModal */[__webpack_require__.e(7369), __webpack_require__.e(4844)]).then(__webpack_require__.bind(__webpack_require__, 36774));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(36774);
            }
            return eval("require.resolve")("compositions/modals/MobileAppModal/MobileAppModal");
        }
    }, {
        fallback: fallback
    }),
    featuredBrandModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-StrapiWSTOModalWithProducts-StrapiWSTOModalWithProducts";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-StrapiWSTOModalWithProducts-StrapiWSTOModalWithProducts */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(3169), __webpack_require__.e(60), __webpack_require__.e(2259)]).then(__webpack_require__.bind(__webpack_require__, 36369));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(36369);
            }
            return eval("require.resolve")("compositions/modals/StrapiWSTOModalWithProducts/StrapiWSTOModalWithProducts");
        }
    }, {
        fallback: fallback
    }),
    scentbirdSelectModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-ScentbirdSelectModal-ScentbirdSelectModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-ScentbirdSelectModal-ScentbirdSelectModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(7865), __webpack_require__.e(7369), __webpack_require__.e(6982)]).then(__webpack_require__.bind(__webpack_require__, 23641));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(23641);
            }
            return eval("require.resolve")("compositions/modals/ScentbirdSelectModal/ScentbirdSelectModal");
        }
    }, {
        fallback: fallback
    }),
    caseSubscriptionPromoModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-CaseSubscriptionPromoModal-CaseSubscriptionPromoModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-CaseSubscriptionPromoModal-CaseSubscriptionPromoModal */[__webpack_require__.e(7369), __webpack_require__.e(7534)]).then(__webpack_require__.bind(__webpack_require__, 99688));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(99688);
            }
            return eval("require.resolve")("compositions/modals/CaseSubscriptionPromoModal/CaseSubscriptionPromoModal");
        }
    }, {
        fallback: fallback
    }),
    cotyModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-CotyModal-CotyModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-CotyModal-CotyModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(6556), __webpack_require__.e(60), __webpack_require__.e(2893)]).then(__webpack_require__.bind(__webpack_require__, 75004));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(75004);
            }
            return eval("require.resolve")("compositions/modals/CotyModal/CotyModal");
        }
    }, {
        fallback: fallback
    }),
    inviteModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-InviteModal-InviteModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return __webpack_require__.e(/* import() | compositions-modals-InviteModal-InviteModal */ 6040).then(__webpack_require__.bind(__webpack_require__, 5344));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(5344);
            }
            return eval("require.resolve")("compositions/modals/InviteModal/InviteModal");
        }
    }, {
        fallback: fallback
    }),
    continueMobileAppModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-ContinueMobileAppModal-ContinueMobileAppModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return __webpack_require__.e(/* import() | compositions-modals-ContinueMobileAppModal-ContinueMobileAppModal */ 4582).then(__webpack_require__.bind(__webpack_require__, 76562));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(76562);
            }
            return eval("require.resolve")("compositions/modals/ContinueMobileAppModal/ContinueMobileAppModal");
        }
    }, {
        fallback: fallback
    }),
    candleSubscriptionCancelSuccessModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-CandleSubscriptionCancelSuccessModal-CandleSubscriptionCancelSuccessModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return __webpack_require__.e(/* import() | compositions-modals-CandleSubscriptionCancelSuccessModal-CandleSubscriptionCancelSuccessModal */ 7892).then(__webpack_require__.bind(__webpack_require__, 95888));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(95888);
            }
            return eval("require.resolve")("compositions/modals/CandleSubscriptionCancelSuccessModal/CandleSubscriptionCancelSuccessModal");
        }
    }, {
        fallback: fallback
    }),
    caseSubscriptionCancelSuccessModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-CaseSubscriptionCancelSuccessModal-CaseSubscriptionCancelSuccessModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return __webpack_require__.e(/* import() | compositions-modals-CaseSubscriptionCancelSuccessModal-CaseSubscriptionCancelSuccessModal */ 3430).then(__webpack_require__.bind(__webpack_require__, 71879));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(71879);
            }
            return eval("require.resolve")("compositions/modals/CaseSubscriptionCancelSuccessModal/CaseSubscriptionCancelSuccessModal");
        }
    }, {
        fallback: fallback
    }),
    limitedDropModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-LimitedDropModal-LimitedDropModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-LimitedDropModal-LimitedDropModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6471), __webpack_require__.e(60), __webpack_require__.e(1433)]).then(__webpack_require__.bind(__webpack_require__, 31358));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(31358);
            }
            return eval("require.resolve")("compositions/modals/LimitedDropModal/LimitedDropModal");
        }
    }, {
        fallback: fallback
    }),
    driftPromoModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-DriftPromoModal-DriftPromoModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-DriftPromoModal-DriftPromoModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(7369), __webpack_require__.e(3198)]).then(__webpack_require__.bind(__webpack_require__, 25843));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(25843);
            }
            return eval("require.resolve")("compositions/modals/DriftPromoModal/DriftPromoModal");
        }
    }, {
        fallback: fallback
    }),
    videoModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-VideoModal-VideoModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-VideoModal-VideoModal */[__webpack_require__.e(1262), __webpack_require__.e(586)]).then(__webpack_require__.bind(__webpack_require__, 72522));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(72522);
            }
            return eval("require.resolve")("compositions/modals/VideoModal/VideoModal");
        }
    }, {
        fallback: fallback
    }),
    caseUpsellModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-CaseUpsellModal-CaseUpsellModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-CaseUpsellModal-CaseUpsellModal */[__webpack_require__.e(532), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(6029)]).then(__webpack_require__.bind(__webpack_require__, 42227));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(42227);
            }
            return eval("require.resolve")("compositions/modals/CaseUpsellModal/CaseUpsellModal");
        }
    }, {
        fallback: fallback
    }),
    caseSubscriptionUpsellModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-CaseSubscriptionUpsellModal-CaseSubscriptionUpsellModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-CaseSubscriptionUpsellModal-CaseSubscriptionUpsellModal */[__webpack_require__.e(7369), __webpack_require__.e(1565)]).then(__webpack_require__.bind(__webpack_require__, 47986));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(47986);
            }
            return eval("require.resolve")("compositions/modals/CaseSubscriptionUpsellModal/CaseSubscriptionUpsellModal");
        }
    }, {
        fallback: fallback
    }),
    hereticCaseUpsellModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-HereticCaseUpsellModal-HereticCaseUpsellModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-HereticCaseUpsellModal-HereticCaseUpsellModal */[__webpack_require__.e(8383), __webpack_require__.e(9660), __webpack_require__.e(4724)]).then(__webpack_require__.bind(__webpack_require__, 82606));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(82606);
            }
            return eval("require.resolve")("compositions/modals/HereticCaseUpsellModal/HereticCaseUpsellModal");
        }
    }, {
        fallback: fallback
    }),
    bloggersVideoCarouselModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-BloggersVideoCarouselModal-BloggersVideoCarouselModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-BloggersVideoCarouselModal-BloggersVideoCarouselModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(60), __webpack_require__.e(8604)]).then(__webpack_require__.bind(__webpack_require__, 9147));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(9147);
            }
            return eval("require.resolve")("compositions/modals/BloggersVideoCarouselModal/BloggersVideoCarouselModal");
        }
    }, {
        fallback: fallback
    }),
    driftRefillClipDisclaimerModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-DriftRefillClipDisclaimerModal-DriftRefillClipDisclaimerModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-DriftRefillClipDisclaimerModal-DriftRefillClipDisclaimerModal */[__webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(9660), __webpack_require__.e(1862), __webpack_require__.e(6444)]).then(__webpack_require__.bind(__webpack_require__, 11114));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(11114);
            }
            return eval("require.resolve")("compositions/modals/DriftRefillClipDisclaimerModal/DriftRefillClipDisclaimerModal");
        }
    }, {
        fallback: fallback
    }),
    driftSubscriptionConfirmationModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-DriftSubscriptionConfirmationModal-DriftSubscriptionConfirmationModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-DriftSubscriptionConfirmationModal-DriftSubscriptionConfirmationModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(7865), __webpack_require__.e(255), __webpack_require__.e(5416)]).then(__webpack_require__.bind(__webpack_require__, 48899));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(48899);
            }
            return eval("require.resolve")("compositions/modals/DriftSubscriptionConfirmationModal/DriftSubscriptionConfirmationModal");
        }
    }, {
        fallback: fallback
    }),
    driftSubscriptionPromoModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-DriftSubscriptionPromoModal-DriftSubscriptionPromoModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-DriftSubscriptionPromoModal-DriftSubscriptionPromoModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(7865), __webpack_require__.e(7369), __webpack_require__.e(5994)]).then(__webpack_require__.bind(__webpack_require__, 11165));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(11165);
            }
            return eval("require.resolve")("compositions/modals/DriftSubscriptionPromoModal/DriftSubscriptionPromoModal");
        }
    }, {
        fallback: fallback
    }),
    scentbirdAcademyModal: (0,_loadable_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        resolved: {},
        chunkName: function() {
            return "compositions-modals-ScentbirdAcademyModal-ScentbirdAcademyModal";
        },
        isReady: function(props) {
            var key = this.resolve(props);
            if (this.resolved[key] !== true) {
                return false;
            }
            if (true) {
                return !!__webpack_require__.m[key];
            }
            return false;
        },
        importAsync: function() {
            return Promise.all(/* import() | compositions-modals-ScentbirdAcademyModal-ScentbirdAcademyModal */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(60), __webpack_require__.e(4966)]).then(__webpack_require__.bind(__webpack_require__, 78008));
        },
        requireAsync: function(props) {
            var _this = this;
            var key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(function(resolved) {
                _this.resolved[key] = true;
                return resolved;
            });
        },
        requireSync: function(props) {
            var id = this.resolve(props);
            if (true) {
                return __webpack_require__(id);
            }
            return eval("module.require")(id);
        },
        resolve: function() {
            if (true) {
                return /*require.resolve*/(78008);
            }
            return eval("require.resolve")("compositions/modals/ScentbirdAcademyModal/ScentbirdAcademyModal");
        }
    }, {
        fallback: fallback
    })
};
// register all common modals
(0,modals__WEBPACK_IMPORTED_MODULE_8__/* .registerModals */ .h)(registry);
var ModalsRegistry = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(modals__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {});
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalsRegistry);


/***/ }),

/***/ 1026:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58738);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17382);
/* harmony import */ var modules_queue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11982);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91339);
/* harmony import */ var modules_user_optIn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64217);







var ResolvePostponed = function(param) {
    var children = param.children, withoutPremiumModal = param.withoutPremiumModal, withNotification = param.withNotification;
    var _useUser = (0,modules_user__WEBPACK_IMPORTED_MODULE_2__/* .useUser */ .a)(), isLoggedIn = _useUser.isLoggedIn, isUserFetching = _useUser.isFetching;
    var _useSubscription = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_3__/* .useSubscription */ .m)(), subscription = _useSubscription.subscription, isSubscriptionFetching = _useSubscription.isFetching;
    var isFetching = isUserFetching || isSubscriptionFetching;
    var _subscription_isActive;
    // ATTN we can't add LEP if user doesn't have an active subscription
    var isSubscriptionActive = (_subscription_isActive = subscription === null || subscription === void 0 ? void 0 : subscription.isActive) !== null && _subscription_isActive !== void 0 ? _subscription_isActive : false;
    var postponedItemsHandler = (0,modules_queue__WEBPACK_IMPORTED_MODULE_4__/* .useQueueResolvePostponedItems */ .oB)();
    var postponedOptInEmailHandler = (0,modules_user_optIn__WEBPACK_IMPORTED_MODULE_5__/* .useOptInEmailResolvePostponedProjects */ .TJ)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isFetching) {
            return;
        }
        if (isLoggedIn) {
            postponedItemsHandler({
                withNotification: withNotification,
                withUpgradeFlow: false,
                withErrorModals: false,
                withLEP: isSubscriptionActive,
                withPriorityProducts: isSubscriptionActive,
                withoutPremiumModal: withoutPremiumModal
            })["catch"](function(error) {
                logger__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.warn(error);
            });
            // Send user email to postponed iterable projects
            postponedOptInEmailHandler();
        }
    }, [
        postponedItemsHandler,
        postponedOptInEmailHandler,
        isFetching,
        isLoggedIn,
        isSubscriptionActive,
        withNotification,
        withoutPremiumModal
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ResolvePostponed);


/***/ }),

/***/ 18882:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40963);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73598);
/* harmony import */ var core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_timers_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72463);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52983);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98716);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68426);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(51827);
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1655);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68964);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(33675);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(33996);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69541);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5649);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50556);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17382);
/* harmony import */ var containers_HasAuth_HasAuth__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(94455);
/* harmony import */ var containers_HasNeverSubscribed_HasNeverSubscribed__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(96973);
/* harmony import */ var containers_AuthPageProvider_AuthPageProvider__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(4213);
/* harmony import */ var containers_SubscriptionLayout_SubscriptionLayout__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(38396);
/* harmony import */ var containers_ResolvePostponed_ResolvePostponed__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(1026);
/* harmony import */ var compositions_PageSkeleton_PageSkeleton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69886);
/* harmony import */ var _redirects__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(48444);














// too small for extraction







var fallback = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(compositions_PageSkeleton_PageSkeleton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {});
// Layouts are in loadable for better code splitting
var MainLayout = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "layouts-MainLayout-MainLayout";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | layouts-MainLayout-MainLayout */[__webpack_require__.e(6556), __webpack_require__.e(3169), __webpack_require__.e(5800), __webpack_require__.e(6418), __webpack_require__.e(7797), __webpack_require__.e(9211)]).then(__webpack_require__.bind(__webpack_require__, 96078));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(96078);
        }
        return eval("require.resolve")("layouts/MainLayout/MainLayout");
    }
}, {
    fallback: fallback
});
var LandingLayout = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "layouts-LandingLayout-LandingLayout";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | layouts-LandingLayout-LandingLayout */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6556), __webpack_require__.e(6471), __webpack_require__.e(3169), __webpack_require__.e(5800), __webpack_require__.e(6418), __webpack_require__.e(7797), __webpack_require__.e(60), __webpack_require__.e(8403)]).then(__webpack_require__.bind(__webpack_require__, 43686));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(43686);
        }
        return eval("require.resolve")("layouts/LandingLayout/LandingLayout");
    }
}, {
    fallback: fallback
});
var MinimalLayout = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "layouts-MinimalLayout-MinimalLayout";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | layouts-MinimalLayout-MinimalLayout */[__webpack_require__.e(6556), __webpack_require__.e(3169), __webpack_require__.e(5800), __webpack_require__.e(7797), __webpack_require__.e(7233)]).then(__webpack_require__.bind(__webpack_require__, 25551));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(25551);
        }
        return eval("require.resolve")("layouts/MinimalLayout/MinimalLayout");
    }
}, {
    fallback: fallback
});
var MinimalFAQLayout = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "layouts-MinimalFAQLayout-MinimalFAQLayout";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | layouts-MinimalFAQLayout-MinimalFAQLayout */[__webpack_require__.e(532), __webpack_require__.e(6556), __webpack_require__.e(3169), __webpack_require__.e(5800), __webpack_require__.e(6418), __webpack_require__.e(7797), __webpack_require__.e(8678)]).then(__webpack_require__.bind(__webpack_require__, 38441));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(38441);
        }
        return eval("require.resolve")("layouts/MinimalFAQLayout/MinimalFAQLayout");
    }
}, {
    fallback: fallback
});
// Pages
var LandingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-landing-LandingPage-LandingPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-landing-LandingPage-LandingPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6471), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(2293), __webpack_require__.e(4483), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(4335)]).then(__webpack_require__.bind(__webpack_require__, 34554));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(34554);
        }
        return eval("require.resolve")("pages/landing/LandingPage/LandingPage");
    }
}, {
    fallback: fallback
});
var ReferralLandingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-landing-ReferralPage-ReferralPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-landing-ReferralPage-ReferralPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6471), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(2293), __webpack_require__.e(4483), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(5075)]).then(__webpack_require__.bind(__webpack_require__, 4864));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(4864);
        }
        return eval("require.resolve")("pages/landing/ReferralPage/ReferralPage");
    }
}, {
    fallback: fallback
});
var TwelveDays = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-landing-TwelveDays-TwelveDays";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-landing-TwelveDays-TwelveDays */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6471), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(2293), __webpack_require__.e(4483), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(8887)]).then(__webpack_require__.bind(__webpack_require__, 91289));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(91289);
        }
        return eval("require.resolve")("pages/landing/TwelveDays/TwelveDays");
    }
}, {
    fallback: fallback
});
var LoginPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-auth-LoginPage-LoginPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-auth-LoginPage-LoginPage */[__webpack_require__.e(532), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(6471), __webpack_require__.e(8371), __webpack_require__.e(874), __webpack_require__.e(1973), __webpack_require__.e(2148), __webpack_require__.e(6609), __webpack_require__.e(4584), __webpack_require__.e(1240), __webpack_require__.e(1862), __webpack_require__.e(5589)]).then(__webpack_require__.bind(__webpack_require__, 958));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(958);
        }
        return eval("require.resolve")("pages/auth/LoginPage/LoginPage");
    }
}, {
    fallback: fallback
});
var RegisterPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-auth-RegisterPage-RegisterPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-auth-RegisterPage-RegisterPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(6471), __webpack_require__.e(8371), __webpack_require__.e(874), __webpack_require__.e(1973), __webpack_require__.e(2148), __webpack_require__.e(6609), __webpack_require__.e(4584), __webpack_require__.e(1240), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(3783)]).then(__webpack_require__.bind(__webpack_require__, 75458));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(75458);
        }
        return eval("require.resolve")("pages/auth/RegisterPage/RegisterPage");
    }
}, {
    fallback: fallback
});
var MagicLinkContinuePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-auth-MagicLinkContinuePage-MagicLinkContinuePage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | pages-auth-MagicLinkContinuePage-MagicLinkContinuePage */ 7111).then(__webpack_require__.bind(__webpack_require__, 72639));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(72639);
        }
        return eval("require.resolve")("pages/auth/MagicLinkContinuePage/MagicLinkContinuePage");
    }
}, {
    fallback: fallback
});
var ForgotPasswordPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-auth-ForgotPasswordPage-ForgotPasswordPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-auth-ForgotPasswordPage-ForgotPasswordPage */[__webpack_require__.e(532), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(6471), __webpack_require__.e(8371), __webpack_require__.e(874), __webpack_require__.e(2148), __webpack_require__.e(6609), __webpack_require__.e(4584), __webpack_require__.e(1240), __webpack_require__.e(1862), __webpack_require__.e(2008)]).then(__webpack_require__.bind(__webpack_require__, 24541));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(24541);
        }
        return eval("require.resolve")("pages/auth/ForgotPasswordPage/ForgotPasswordPage");
    }
}, {
    fallback: fallback
});
var ResetPasswordPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-auth-ResetPasswordPage-ResetPasswordPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-auth-ResetPasswordPage-ResetPasswordPage */[__webpack_require__.e(532), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(8371), __webpack_require__.e(874), __webpack_require__.e(2148), __webpack_require__.e(1862), __webpack_require__.e(60), __webpack_require__.e(8964)]).then(__webpack_require__.bind(__webpack_require__, 61265));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(61265);
        }
        return eval("require.resolve")("pages/auth/ResetPasswordPage/ResetPasswordPage");
    }
}, {
    fallback: fallback
});
var RecoverPasswordPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-auth-RecoverPasswordPage-RecoverPasswordPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-auth-RecoverPasswordPage-RecoverPasswordPage */[__webpack_require__.e(532), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(874), __webpack_require__.e(2148), __webpack_require__.e(1862), __webpack_require__.e(4071)]).then(__webpack_require__.bind(__webpack_require__, 64146));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(64146);
        }
        return eval("require.resolve")("pages/auth/RecoverPasswordPage/RecoverPasswordPage");
    }
}, {
    fallback: fallback
});
var FacebookEmailPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-auth-FacebookEmailPage-FacebookEmailPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-auth-FacebookEmailPage-FacebookEmailPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(6471), __webpack_require__.e(8371), __webpack_require__.e(2148), __webpack_require__.e(6609), __webpack_require__.e(1862), __webpack_require__.e(5047), __webpack_require__.e(5826)]).then(__webpack_require__.bind(__webpack_require__, 95229));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(95229);
        }
        return eval("require.resolve")("pages/auth/FacebookEmailPage/FacebookEmailPage");
    }
}, {
    fallback: fallback
});
var QueuePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-QueuePage-QueuePage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-QueuePage-QueuePage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6471), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(255), __webpack_require__.e(8371), __webpack_require__.e(7936), __webpack_require__.e(2293), __webpack_require__.e(8101), __webpack_require__.e(5800), __webpack_require__.e(1398), __webpack_require__.e(547), __webpack_require__.e(3166), __webpack_require__.e(2499), __webpack_require__.e(1635), __webpack_require__.e(426), __webpack_require__.e(218), __webpack_require__.e(7932), __webpack_require__.e(4454), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(3588)]).then(__webpack_require__.bind(__webpack_require__, 97657));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(97657);
        }
        return eval("require.resolve")("pages/QueuePage/QueuePage");
    }
}, {
    fallback: fallback
});
var SubscriptionStatusPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-profile-SubscriptionStatusPage-SubscriptionStatusPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-profile-SubscriptionStatusPage-SubscriptionStatusPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(6471), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(255), __webpack_require__.e(7936), __webpack_require__.e(8101), __webpack_require__.e(1973), __webpack_require__.e(1398), __webpack_require__.e(4691), __webpack_require__.e(9313), __webpack_require__.e(2499), __webpack_require__.e(1635), __webpack_require__.e(218), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(8789)]).then(__webpack_require__.bind(__webpack_require__, 48460));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(48460);
        }
        return eval("require.resolve")("pages/profile/SubscriptionStatusPage/SubscriptionStatusPage");
    }
}, {
    fallback: fallback
});
var OrderHistoryPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-profile-OrderHistoryPage-OrderHistoryPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-profile-OrderHistoryPage-OrderHistoryPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(6924), __webpack_require__.e(6102), __webpack_require__.e(547), __webpack_require__.e(4691), __webpack_require__.e(60), __webpack_require__.e(9042)]).then(__webpack_require__.bind(__webpack_require__, 52324));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(52324);
        }
        return eval("require.resolve")("pages/profile/OrderHistoryPage/OrderHistoryPage");
    }
}, {
    fallback: fallback
});
var PersonalInformationPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-profile-PersonalInformationPage-PersonalInformationPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-profile-PersonalInformationPage-PersonalInformationPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(6471), __webpack_require__.e(874), __webpack_require__.e(4691), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(728)]).then(__webpack_require__.bind(__webpack_require__, 2716));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(2716);
        }
        return eval("require.resolve")("pages/profile/PersonalInformationPage/PersonalInformationPage");
    }
}, {
    fallback: fallback
});
var BillingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-profile-BillingPage-BillingPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-profile-BillingPage-BillingPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(6102), __webpack_require__.e(8371), __webpack_require__.e(4691), __webpack_require__.e(610), __webpack_require__.e(3610)]).then(__webpack_require__.bind(__webpack_require__, 52380));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(52380);
        }
        return eval("require.resolve")("pages/profile/BillingPage/BillingPage");
    }
}, {
    fallback: fallback
});
var ShippingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-profile-ShippingPage-ShippingPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-profile-ShippingPage-ShippingPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(6102), __webpack_require__.e(8371), __webpack_require__.e(3256), __webpack_require__.e(4691), __webpack_require__.e(1969), __webpack_require__.e(610), __webpack_require__.e(755)]).then(__webpack_require__.bind(__webpack_require__, 97168));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(97168);
        }
        return eval("require.resolve")("pages/profile/ShippingPage/ShippingPage");
    }
}, {
    fallback: fallback
});
var ReviewsPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-profile-ReviewsPage-ReviewsPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-profile-ReviewsPage-ReviewsPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6556), __webpack_require__.e(547), __webpack_require__.e(4691), __webpack_require__.e(60), __webpack_require__.e(1698)]).then(__webpack_require__.bind(__webpack_require__, 22125));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(22125);
        }
        return eval("require.resolve")("pages/profile/ReviewsPage/ReviewsPage");
    }
}, {
    fallback: fallback
});
var RemoveAccountConfirmationPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-profile-RemoveAccountConfirmationPage-RemoveAccountConfirmationPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | pages-profile-RemoveAccountConfirmationPage-RemoveAccountConfirmationPage */ 5907).then(__webpack_require__.bind(__webpack_require__, 82703));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(82703);
        }
        return eval("require.resolve")("pages/profile/RemoveAccountConfirmationPage/RemoveAccountConfirmationPage");
    }
}, {
    fallback: fallback
});
var MainPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-MainPage-MainPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-MainPage-MainPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6471), __webpack_require__.e(5529), __webpack_require__.e(255), __webpack_require__.e(8371), __webpack_require__.e(7936), __webpack_require__.e(2293), __webpack_require__.e(3169), __webpack_require__.e(8101), __webpack_require__.e(2483), __webpack_require__.e(1973), __webpack_require__.e(1398), __webpack_require__.e(547), __webpack_require__.e(7618), __webpack_require__.e(3166), __webpack_require__.e(1347), __webpack_require__.e(5742), __webpack_require__.e(591), __webpack_require__.e(4876), __webpack_require__.e(426), __webpack_require__.e(2336), __webpack_require__.e(1862), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(6966)]).then(__webpack_require__.bind(__webpack_require__, 43064));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(43064);
        }
        return eval("require.resolve")("pages/MainPage/MainPage");
    }
}, {
    fallback: fallback
});
var BrandsPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-BrandsPage-BrandsPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-BrandsPage-BrandsPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(6102), __webpack_require__.e(3169), __webpack_require__.e(60), __webpack_require__.e(7533)]).then(__webpack_require__.bind(__webpack_require__, 16743));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(16743);
        }
        return eval("require.resolve")("pages/BrandsPage/BrandsPage");
    }
}, {
    fallback: fallback
});
var BrandPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-brand-BrandPage-BrandPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-brand-BrandPage-BrandPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6102), __webpack_require__.e(6206), __webpack_require__.e(1862), __webpack_require__.e(60), __webpack_require__.e(9957)]).then(__webpack_require__.bind(__webpack_require__, 9709));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(9709);
        }
        return eval("require.resolve")("pages/brand/BrandPage/BrandPage");
    }
}, {
    fallback: fallback
});
var COAREnhancedPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-brand-COAREnhancedPage-COAREnhancedPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-brand-COAREnhancedPage-COAREnhancedPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6556), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(2293), __webpack_require__.e(60), __webpack_require__.e(2145)]).then(__webpack_require__.bind(__webpack_require__, 35609));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(35609);
        }
        return eval("require.resolve")("pages/brand/COAREnhancedPage/COAREnhancedPage");
    }
}, {
    fallback: fallback
});
var SeoPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-SeoPage-SeoPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | pages-SeoPage-SeoPage */ 1496).then(__webpack_require__.bind(__webpack_require__, 83304));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(83304);
        }
        return eval("require.resolve")("pages/SeoPage/SeoPage");
    }
}, {
    fallback: fallback
});
var FeaturedBrandPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-FeaturedBrandPage-FeaturedBrandPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-FeaturedBrandPage-FeaturedBrandPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(60), __webpack_require__.e(2377)]).then(__webpack_require__.bind(__webpack_require__, 65771));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(65771);
        }
        return eval("require.resolve")("pages/FeaturedBrandPage/FeaturedBrandPage");
    }
}, {
    fallback: fallback
});
var TheEditPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-TheEditPage-TheEditPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-TheEditPage-TheEditPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(1150), __webpack_require__.e(287), __webpack_require__.e(5393), __webpack_require__.e(1380), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(4797)]).then(__webpack_require__.bind(__webpack_require__, 27134));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(27134);
        }
        return eval("require.resolve")("pages/TheEditPage/TheEditPage");
    }
}, {
    fallback: fallback
});
var CCPAPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-legal-CCPAPage-CCPAPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-legal-CCPAPage-CCPAPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(1862), __webpack_require__.e(7747)]).then(__webpack_require__.bind(__webpack_require__, 99921));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(99921);
        }
        return eval("require.resolve")("pages/legal/CCPAPage/CCPAPage");
    }
}, {
    fallback: fallback
});
var TermsPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-legal-TermsPage-TermsPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-legal-TermsPage-TermsPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(7865), __webpack_require__.e(3809)]).then(__webpack_require__.bind(__webpack_require__, 61575));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(61575);
        }
        return eval("require.resolve")("pages/legal/TermsPage/TermsPage");
    }
}, {
    fallback: fallback
});
var PrivacyPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-legal-PrivacyPage-PrivacyPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-legal-PrivacyPage-PrivacyPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(851)]).then(__webpack_require__.bind(__webpack_require__, 37662));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(37662);
        }
        return eval("require.resolve")("pages/legal/PrivacyPage/PrivacyPage");
    }
}, {
    fallback: fallback
});
var AboutPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-info-AboutPage-AboutPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-info-AboutPage-AboutPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(6113), __webpack_require__.e(138), __webpack_require__.e(60), __webpack_require__.e(573)]).then(__webpack_require__.bind(__webpack_require__, 58099));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(58099);
        }
        return eval("require.resolve")("pages/info/AboutPage/AboutPage");
    }
}, {
    fallback: fallback
});
var PressPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-info-PressPage-PressPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-info-PressPage-PressPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(874), __webpack_require__.e(138), __webpack_require__.e(1862), __webpack_require__.e(60), __webpack_require__.e(3338)]).then(__webpack_require__.bind(__webpack_require__, 6961));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(6961);
        }
        return eval("require.resolve")("pages/info/PressPage/PressPage");
    }
}, {
    fallback: fallback
});
var CollectionsPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-collections-CollectionsPage-CollectionsPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-collections-CollectionsPage-CollectionsPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(5529), __webpack_require__.e(60), __webpack_require__.e(5543)]).then(__webpack_require__.bind(__webpack_require__, 76605));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(76605);
        }
        return eval("require.resolve")("pages/collections/CollectionsPage/CollectionsPage");
    }
}, {
    fallback: fallback
});
var CollectionPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-collections-CollectionPage-CollectionPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-collections-CollectionPage-CollectionPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(60), __webpack_require__.e(5376)]).then(__webpack_require__.bind(__webpack_require__, 98795));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(98795);
        }
        return eval("require.resolve")("pages/collections/CollectionPage/CollectionPage");
    }
}, {
    fallback: fallback
});
var FOMListPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-fom-FOMListPage-FOMListPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-fom-FOMListPage-FOMListPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(7865), __webpack_require__.e(7369), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(3645)]).then(__webpack_require__.bind(__webpack_require__, 15768));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(15768);
        }
        return eval("require.resolve")("pages/fom/FOMListPage/FOMListPage");
    }
}, {
    fallback: fallback
});
var FOMPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-fom-FOMPage-FOMPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-fom-FOMPage-FOMPage */[__webpack_require__.e(5529), __webpack_require__.e(6602)]).then(__webpack_require__.bind(__webpack_require__, 38891));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(38891);
        }
        return eval("require.resolve")("pages/fom/FOMPage/FOMPage");
    }
}, {
    fallback: fallback
});
var ProductPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-product-ProductPage-ProductPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-product-ProductPage-ProductPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6471), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(255), __webpack_require__.e(1150), __webpack_require__.e(7936), __webpack_require__.e(2293), __webpack_require__.e(3169), __webpack_require__.e(8101), __webpack_require__.e(5800), __webpack_require__.e(2483), __webpack_require__.e(1398), __webpack_require__.e(547), __webpack_require__.e(7618), __webpack_require__.e(5377), __webpack_require__.e(9955), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(7460)]).then(__webpack_require__.bind(__webpack_require__, 38252));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(38252);
        }
        return eval("require.resolve")("pages/product/ProductPage/ProductPage");
    }
}, {
    fallback: fallback
});
var GiftSetPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-product-GiftSetPage-GiftSetPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-product-GiftSetPage-GiftSetPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6556), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6102), __webpack_require__.e(5800), __webpack_require__.e(5377), __webpack_require__.e(60), __webpack_require__.e(911)]).then(__webpack_require__.bind(__webpack_require__, 1911));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(1911);
        }
        return eval("require.resolve")("pages/product/GiftSetPage/GiftSetPage");
    }
}, {
    fallback: fallback
});
var GiftsPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-GiftsPage-GiftsPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-GiftsPage-GiftsPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(5529), __webpack_require__.e(610), __webpack_require__.e(344)]).then(__webpack_require__.bind(__webpack_require__, 48481));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(48481);
        }
        return eval("require.resolve")("pages/GiftsPage/GiftsPage");
    }
}, {
    fallback: fallback
});
var GiftHubPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-GiftHubPage-GiftHubPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-GiftHubPage-GiftHubPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(7865), __webpack_require__.e(6102), __webpack_require__.e(5393), __webpack_require__.e(1380), __webpack_require__.e(60), __webpack_require__.e(3183)]).then(__webpack_require__.bind(__webpack_require__, 95706));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(95706);
        }
        return eval("require.resolve")("pages/GiftHubPage/GiftHubPage");
    }
}, {
    fallback: fallback
});
var GiftCardPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-GiftCardPage-GiftCardPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-GiftCardPage-GiftCardPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(6102), __webpack_require__.e(874), __webpack_require__.e(5393), __webpack_require__.e(1380), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(1388)]).then(__webpack_require__.bind(__webpack_require__, 11235));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(11235);
        }
        return eval("require.resolve")("pages/GiftCardPage/GiftCardPage");
    }
}, {
    fallback: fallback
});
var GiftSubscriptionPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-GiftSubscriptionPage-GiftSubscriptionPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-GiftSubscriptionPage-GiftSubscriptionPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(6102), __webpack_require__.e(874), __webpack_require__.e(5393), __webpack_require__.e(1380), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5697)]).then(__webpack_require__.bind(__webpack_require__, 955));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(955);
        }
        return eval("require.resolve")("pages/GiftSubscriptionPage/GiftSubscriptionPage");
    }
}, {
    fallback: fallback
});
var GiftCardClaimPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-GiftCardClaimPage-GiftCardClaimPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-GiftCardClaimPage-GiftCardClaimPage */[__webpack_require__.e(532), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(1973), __webpack_require__.e(1862), __webpack_require__.e(1382)]).then(__webpack_require__.bind(__webpack_require__, 4413));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(4413);
        }
        return eval("require.resolve")("pages/GiftCardClaimPage/GiftCardClaimPage");
    }
}, {
    fallback: fallback
});
var GiftSetsPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-GiftSetsPage-GiftSetsPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-GiftSetsPage-GiftSetsPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(1150), __webpack_require__.e(287), __webpack_require__.e(5393), __webpack_require__.e(1380), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(8129)]).then(__webpack_require__.bind(__webpack_require__, 15467));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(15467);
        }
        return eval("require.resolve")("pages/catalog/GiftSetsPage/GiftSetsPage");
    }
}, {
    fallback: fallback
});
var ReferralPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-NewReferralPage-NewReferralPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-NewReferralPage-NewReferralPage */[__webpack_require__.e(532), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(6471), __webpack_require__.e(1862), __webpack_require__.e(60), __webpack_require__.e(1186)]).then(__webpack_require__.bind(__webpack_require__, 61407));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(61407);
        }
        return eval("require.resolve")("pages/NewReferralPage/NewReferralPage");
    }
}, {
    fallback: fallback
});
var FragranceCatalogPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-FragranceCatalogPage-FragranceCatalogPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-FragranceCatalogPage-FragranceCatalogPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6471), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(255), __webpack_require__.e(1150), __webpack_require__.e(7936), __webpack_require__.e(2293), __webpack_require__.e(287), __webpack_require__.e(8101), __webpack_require__.e(2483), __webpack_require__.e(1398), __webpack_require__.e(7618), __webpack_require__.e(1347), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(9198)]).then(__webpack_require__.bind(__webpack_require__, 3985));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(3985);
        }
        return eval("require.resolve")("pages/catalog/FragranceCatalogPage/FragranceCatalogPage");
    }
}, {
    fallback: fallback
});
var BeautyCatalogPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-BeautyCatalogPage-BeautyCatalogPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-BeautyCatalogPage-BeautyCatalogPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(255), __webpack_require__.e(1150), __webpack_require__.e(287), __webpack_require__.e(2483), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(7289)]).then(__webpack_require__.bind(__webpack_require__, 73479));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(73479);
        }
        return eval("require.resolve")("pages/catalog/BeautyCatalogPage/BeautyCatalogPage");
    }
}, {
    fallback: fallback
});
var NewArrivalsPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-NewArrivalsPage-NewArrivalsPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-NewArrivalsPage-NewArrivalsPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(255), __webpack_require__.e(1150), __webpack_require__.e(287), __webpack_require__.e(2483), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(1103)]).then(__webpack_require__.bind(__webpack_require__, 57696));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(57696);
        }
        return eval("require.resolve")("pages/catalog/NewArrivalsPage/NewArrivalsPage");
    }
}, {
    fallback: fallback
});
var BestsellersPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-BestsellersPage-BestsellersPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-BestsellersPage-BestsellersPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(255), __webpack_require__.e(1150), __webpack_require__.e(287), __webpack_require__.e(2483), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(1415)]).then(__webpack_require__.bind(__webpack_require__, 92787));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(92787);
        }
        return eval("require.resolve")("pages/catalog/BestsellersPage/BestsellersPage");
    }
}, {
    fallback: fallback
});
var CleanFragrancesPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-CleanFragrancesPage-CleanFragrancesPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-CleanFragrancesPage-CleanFragrancesPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(255), __webpack_require__.e(1150), __webpack_require__.e(287), __webpack_require__.e(2483), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(8040)]).then(__webpack_require__.bind(__webpack_require__, 10528));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(10528);
        }
        return eval("require.resolve")("pages/catalog/CleanFragrancesPage/CleanFragrancesPage");
    }
}, {
    fallback: fallback
});
var CandlesPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-CandlesPage-CandlesPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-CandlesPage-CandlesPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(1150), __webpack_require__.e(287), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(1808)]).then(__webpack_require__.bind(__webpack_require__, 10691));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(10691);
        }
        return eval("require.resolve")("pages/catalog/CandlesPage/CandlesPage");
    }
}, {
    fallback: fallback
});
var CasesPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-CasesPage-CasesPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-CasesPage-CasesPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(1150), __webpack_require__.e(287), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(2269)]).then(__webpack_require__.bind(__webpack_require__, 13425));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(13425);
        }
        return eval("require.resolve")("pages/catalog/CasesPage/CasesPage");
    }
}, {
    fallback: fallback
});
var AccessoriesPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-AccessoriesPage-AccessoriesPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-AccessoriesPage-AccessoriesPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(1150), __webpack_require__.e(287), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(3283)]).then(__webpack_require__.bind(__webpack_require__, 77341));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(77341);
        }
        return eval("require.resolve")("pages/catalog/AccessoriesPage/AccessoriesPage");
    }
}, {
    fallback: fallback
});
var BathAndBodyPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-BathAndBodyPage-BathAndBodyPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-BathAndBodyPage-BathAndBodyPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(1150), __webpack_require__.e(287), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(1928)]).then(__webpack_require__.bind(__webpack_require__, 37229));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(37229);
        }
        return eval("require.resolve")("pages/catalog/BathAndBodyPage/BathAndBodyPage");
    }
}, {
    fallback: fallback
});
var FullSizeFragrancesPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-FullSizeFragrancesPage-FullSizeFragrancesPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-FullSizeFragrancesPage-FullSizeFragrancesPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(1150), __webpack_require__.e(287), __webpack_require__.e(5393), __webpack_require__.e(1380), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(1125)]).then(__webpack_require__.bind(__webpack_require__, 54957));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(54957);
        }
        return eval("require.resolve")("pages/catalog/FullSizeFragrancesPage/FullSizeFragrancesPage");
    }
}, {
    fallback: fallback
});
var ShopSamplesPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-ShopSamplesPage-ShopSamplesPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-ShopSamplesPage-ShopSamplesPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(1150), __webpack_require__.e(287), __webpack_require__.e(5393), __webpack_require__.e(1380), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(8056)]).then(__webpack_require__.bind(__webpack_require__, 64445));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(64445);
        }
        return eval("require.resolve")("pages/catalog/ShopSamplesPage/ShopSamplesPage");
    }
}, {
    fallback: fallback
});
var TravelSizePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-TavelSizePage-TravelSizePage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-TavelSizePage-TravelSizePage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(1150), __webpack_require__.e(287), __webpack_require__.e(5393), __webpack_require__.e(1380), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(2073)]).then(__webpack_require__.bind(__webpack_require__, 52273));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(52273);
        }
        return eval("require.resolve")("pages/catalog/TavelSizePage/TravelSizePage");
    }
}, {
    fallback: fallback
});
var HolidayPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-HolidayPage-HolidayPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-HolidayPage-HolidayPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(1150), __webpack_require__.e(287), __webpack_require__.e(5393), __webpack_require__.e(1380), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(8350)]).then(__webpack_require__.bind(__webpack_require__, 27294));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(27294);
        }
        return eval("require.resolve")("pages/catalog/HolidayPage/HolidayPage");
    }
}, {
    fallback: fallback
});
var GiftsUnder50Page = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-GiftsUnder50-GiftsUnder50";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-GiftsUnder50-GiftsUnder50 */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(1150), __webpack_require__.e(287), __webpack_require__.e(5393), __webpack_require__.e(1380), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(4558)]).then(__webpack_require__.bind(__webpack_require__, 64979));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(64979);
        }
        return eval("require.resolve")("pages/catalog/GiftsUnder50/GiftsUnder50");
    }
}, {
    fallback: fallback
});
var CardUpdatePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-CardUpdatePage-CardUpdatePage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-CardUpdatePage-CardUpdatePage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(7369), __webpack_require__.e(6471), __webpack_require__.e(255), __webpack_require__.e(8371), __webpack_require__.e(7936), __webpack_require__.e(3256), __webpack_require__.e(8101), __webpack_require__.e(1969), __webpack_require__.e(1582), __webpack_require__.e(3166), __webpack_require__.e(4876), __webpack_require__.e(1862), __webpack_require__.e(5047), __webpack_require__.e(3560)]).then(__webpack_require__.bind(__webpack_require__, 95946));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(95946);
        }
        return eval("require.resolve")("pages/CardUpdatePage/CardUpdatePage");
    }
}, {
    fallback: fallback,
    ssr: false
});
var InAppMessagesCenterPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-InAppMessagesCenterPage-InAppMessagesCenterPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-InAppMessagesCenterPage-InAppMessagesCenterPage */[__webpack_require__.e(6113), __webpack_require__.e(6471), __webpack_require__.e(8982), __webpack_require__.e(764)]).then(__webpack_require__.bind(__webpack_require__, 21660));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(21660);
        }
        return eval("require.resolve")("pages/InAppMessagesCenterPage/InAppMessagesCenterPage");
    }
}, {
    fallback: fallback,
    ssr: false
});
var ResubscribePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-ResubscribePage-ResubscribePage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-ResubscribePage-ResubscribePage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(255), __webpack_require__.e(7936), __webpack_require__.e(2293), __webpack_require__.e(8101), __webpack_require__.e(1398), __webpack_require__.e(7618), __webpack_require__.e(60), __webpack_require__.e(2265)]).then(__webpack_require__.bind(__webpack_require__, 39065));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(39065);
        }
        return eval("require.resolve")("pages/ResubscribePage/ResubscribePage");
    }
}, {
    fallback: fallback,
    ssr: false
});
var UpgradeProductPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-UpgradeProductPage-UpgradeProductPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-UpgradeProductPage-UpgradeProductPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(255), __webpack_require__.e(2483), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(564)]).then(__webpack_require__.bind(__webpack_require__, 70831));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(70831);
        }
        return eval("require.resolve")("pages/UpgradeProductPage/UpgradeProductPage");
    }
}, {
    fallback: fallback
});
var DowngradePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-DowngradePage-DowngradePage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-DowngradePage-DowngradePage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(255), __webpack_require__.e(60), __webpack_require__.e(214)]).then(__webpack_require__.bind(__webpack_require__, 59970));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(59970);
        }
        return eval("require.resolve")("pages/DowngradePage/DowngradePage");
    }
}, {
    fallback: fallback
});
var ScentProfilePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-ScentProfilePage-ScentProfilePage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-ScentProfilePage-ScentProfilePage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6471), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(2293), __webpack_require__.e(3169), __webpack_require__.e(5800), __webpack_require__.e(6418), __webpack_require__.e(4483), __webpack_require__.e(7797), __webpack_require__.e(591), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(9423)]).then(__webpack_require__.bind(__webpack_require__, 582));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(582);
        }
        return eval("require.resolve")("pages/ScentProfilePage/ScentProfilePage");
    }
}, {
    fallback: fallback,
    ssr: false
});
var SmartRecommendationsPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-SmartRecommendationsPage-SmartRecommendationsPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-SmartRecommendationsPage-SmartRecommendationsPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(60), __webpack_require__.e(6337)]).then(__webpack_require__.bind(__webpack_require__, 32840));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(32840);
        }
        return eval("require.resolve")("pages/SmartRecommendationsPage/SmartRecommendationsPage");
    }
}, {
    fallback: fallback
});
var RequestPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-RequestPage-RequestPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-RequestPage-RequestPage */[__webpack_require__.e(532), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(8227)]).then(__webpack_require__.bind(__webpack_require__, 23230));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(23230);
        }
        return eval("require.resolve")("pages/RequestPage/RequestPage");
    }
}, {
    fallback: fallback
});
var Page404 = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-Page404-Page404";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | pages-Page404-Page404 */ 9175).then(__webpack_require__.bind(__webpack_require__, 41175));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(41175);
        }
        return eval("require.resolve")("pages/Page404/Page404");
    }
}, {
    fallback: fallback
});
var TestPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-TestPage-TestPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-TestPage-TestPage */[__webpack_require__.e(6556), __webpack_require__.e(6471), __webpack_require__.e(3169), __webpack_require__.e(5800), __webpack_require__.e(6418), __webpack_require__.e(7797), __webpack_require__.e(3677)]).then(__webpack_require__.bind(__webpack_require__, 20928));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(20928);
        }
        return eval("require.resolve")("pages/TestPage/TestPage");
    }
}, {
    fallback: fallback
});
// payment
var PaymentPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-payment-PaymentPage-PaymentPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-payment-PaymentPage-PaymentPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(6471), __webpack_require__.e(255), __webpack_require__.e(8371), __webpack_require__.e(7936), __webpack_require__.e(3256), __webpack_require__.e(8101), __webpack_require__.e(874), __webpack_require__.e(6818), __webpack_require__.e(2148), __webpack_require__.e(1969), __webpack_require__.e(6609), __webpack_require__.e(1582), __webpack_require__.e(4584), __webpack_require__.e(1240), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(2518)]).then(__webpack_require__.bind(__webpack_require__, 4211));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(4211);
        }
        return eval("require.resolve")("pages/payment/PaymentPage/PaymentPage");
    }
}, {
    fallback: fallback,
    ssr: false
});
var GiftSubscriptionRedeemPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-payment-GiftSubscriptionRedeemPage-GiftSubscriptionRedeemPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-payment-GiftSubscriptionRedeemPage-GiftSubscriptionRedeemPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(6471), __webpack_require__.e(8371), __webpack_require__.e(7936), __webpack_require__.e(3256), __webpack_require__.e(874), __webpack_require__.e(6818), __webpack_require__.e(1973), __webpack_require__.e(1969), __webpack_require__.e(1582), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(9111)]).then(__webpack_require__.bind(__webpack_require__, 7892));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(7892);
        }
        return eval("require.resolve")("pages/payment/GiftSubscriptionRedeemPage/GiftSubscriptionRedeemPage");
    }
}, {
    fallback: fallback,
    ssr: false
});
// thank you pages
var ThankYouPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-thankYou-ThankYouPage-ThankYouPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-thankYou-ThankYouPage-ThankYouPage */[__webpack_require__.e(255), __webpack_require__.e(8371), __webpack_require__.e(3256), __webpack_require__.e(60), __webpack_require__.e(1863)]).then(__webpack_require__.bind(__webpack_require__, 58571));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(58571);
        }
        return eval("require.resolve")("pages/thankYou/ThankYouPage/ThankYouPage");
    }
}, {
    fallback: fallback,
    ssr: false
});
var GiftSubscriptionRedeemThankYouPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-thankYou-GiftSubscriptionRedeemThankYouPage-GiftSubscriptionRedeemThankYouPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-thankYou-GiftSubscriptionRedeemThankYouPage-GiftSubscriptionRedeemThankYouPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(6471), __webpack_require__.e(3256), __webpack_require__.e(6818), __webpack_require__.e(1973), __webpack_require__.e(2869), __webpack_require__.e(60), __webpack_require__.e(2486)]).then(__webpack_require__.bind(__webpack_require__, 73665));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(73665);
        }
        return eval("require.resolve")("pages/thankYou/GiftSubscriptionRedeemThankYouPage/GiftSubscriptionRedeemThankYouPage");
    }
}, {
    fallback: fallback,
    ssr: false
});
var GiftCardClaimThankYouPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-thankYou-GiftCardClaimThankYouPage-GiftCardClaimThankYouPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-thankYou-GiftCardClaimThankYouPage-GiftCardClaimThankYouPage */[__webpack_require__.e(6471), __webpack_require__.e(2869), __webpack_require__.e(3498)]).then(__webpack_require__.bind(__webpack_require__, 86284));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(86284);
        }
        return eval("require.resolve")("pages/thankYou/GiftCardClaimThankYouPage/GiftCardClaimThankYouPage");
    }
}, {
    fallback: fallback,
    ssr: false
});
var CaseSubscriptionThankYouPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-thankYou-CaseSubscriptionThankYouPage-CaseSubscriptionThankYouPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-thankYou-CaseSubscriptionThankYouPage-CaseSubscriptionThankYouPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(6471), __webpack_require__.e(3256), __webpack_require__.e(6818), __webpack_require__.e(2869), __webpack_require__.e(60), __webpack_require__.e(2523)]).then(__webpack_require__.bind(__webpack_require__, 97664));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(97664);
        }
        return eval("require.resolve")("pages/thankYou/CaseSubscriptionThankYouPage/CaseSubscriptionThankYouPage");
    }
}, {
    fallback: fallback,
    ssr: false
});
var CandleSubscriptionThankYouPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-thankYou-CandleSubscriptionThankYouPage-CandleSubscriptionThankYouPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-thankYou-CandleSubscriptionThankYouPage-CandleSubscriptionThankYouPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(6471), __webpack_require__.e(3256), __webpack_require__.e(6818), __webpack_require__.e(2869), __webpack_require__.e(60), __webpack_require__.e(1949)]).then(__webpack_require__.bind(__webpack_require__, 23039));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(23039);
        }
        return eval("require.resolve")("pages/thankYou/CandleSubscriptionThankYouPage/CandleSubscriptionThankYouPage");
    }
}, {
    fallback: fallback,
    ssr: false
});
var DriftSubscriptionThankYouPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-thankYou-DriftSubscriptionThankYouPage-DriftSubscriptionThankYouPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-thankYou-DriftSubscriptionThankYouPage-DriftSubscriptionThankYouPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(6471), __webpack_require__.e(3256), __webpack_require__.e(6818), __webpack_require__.e(2869), __webpack_require__.e(60), __webpack_require__.e(2484)]).then(__webpack_require__.bind(__webpack_require__, 61058));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(61058);
        }
        return eval("require.resolve")("pages/thankYou/DriftSubscriptionThankYouPage/DriftSubscriptionThankYouPage");
    }
}, {
    fallback: fallback,
    ssr: false
});
var DemoUserPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-DemoUserPage-DemoUserPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-DemoUserPage-DemoUserPage */[__webpack_require__.e(1262), __webpack_require__.e(6113), __webpack_require__.e(8371), __webpack_require__.e(1973), __webpack_require__.e(1862), __webpack_require__.e(1611)]).then(__webpack_require__.bind(__webpack_require__, 29657));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(29657);
        }
        return eval("require.resolve")("pages/DemoUserPage/DemoUserPage");
    }
}, {
    fallback: fallback
});
var CaseSubscriptionPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-CaseSubscriptionPage-CaseSubscriptionPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-CaseSubscriptionPage-CaseSubscriptionPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(7865), __webpack_require__.e(6471), __webpack_require__.e(5934)]).then(__webpack_require__.bind(__webpack_require__, 96210));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(96210);
        }
        return eval("require.resolve")("pages/CaseSubscriptionPage/CaseSubscriptionPage");
    }
}, {
    fallback: fallback
});
var CandleSubscriptionPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-CandleSubscriptionPage-CandleSubscriptionPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-CandleSubscriptionPage-CandleSubscriptionPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(7865), __webpack_require__.e(6556), __webpack_require__.e(3874), __webpack_require__.e(6471), __webpack_require__.e(4483), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(7134)]).then(__webpack_require__.bind(__webpack_require__, 33532));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(33532);
        }
        return eval("require.resolve")("pages/CandleSubscriptionPage/CandleSubscriptionPage");
    }
}, {
    fallback: fallback
});
var DriftSubscriptionPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-DriftSubscriptionPage-DriftSubscriptionPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-DriftSubscriptionPage-DriftSubscriptionPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6556), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(4190)]).then(__webpack_require__.bind(__webpack_require__, 30697));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(30697);
        }
        return eval("require.resolve")("pages/DriftSubscriptionPage/DriftSubscriptionPage");
    }
}, {
    fallback: fallback
});
var DriftSubscriptionProductPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-DriftSubscriptionProductPage-DriftSubscriptionProductPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-DriftSubscriptionProductPage-DriftSubscriptionProductPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6102), __webpack_require__.e(3169), __webpack_require__.e(5800), __webpack_require__.e(5377), __webpack_require__.e(9955), __webpack_require__.e(1862), __webpack_require__.e(60), __webpack_require__.e(576)]).then(__webpack_require__.bind(__webpack_require__, 18631));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(18631);
        }
        return eval("require.resolve")("pages/DriftSubscriptionProductPage/DriftSubscriptionProductPage");
    }
}, {
    fallback: fallback
});
var FeaturedCandlePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-product-FeaturedCandlePage-FeaturedCandlePage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-product-FeaturedCandlePage-FeaturedCandlePage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(6471), __webpack_require__.e(5529), __webpack_require__.e(4483), __webpack_require__.e(5377), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5965)]).then(__webpack_require__.bind(__webpack_require__, 9980));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(9980);
        }
        return eval("require.resolve")("pages/product/FeaturedCandlePage/FeaturedCandlePage");
    }
}, {
    fallback: fallback
});
var TossInPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-TossInPage-TossInPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-TossInPage-TossInPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(8371), __webpack_require__.e(3256), __webpack_require__.e(7364), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(3971)]).then(__webpack_require__.bind(__webpack_require__, 52691));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(52691);
        }
        return eval("require.resolve")("pages/TossInPage/TossInPage");
    }
}, {
    fallback: fallback
});
var BuyQueuePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-BuyQueuePage-BuyQueuePage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-BuyQueuePage-BuyQueuePage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(8371), __webpack_require__.e(3256), __webpack_require__.e(7364), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(3709)]).then(__webpack_require__.bind(__webpack_require__, 31568));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(31568);
        }
        return eval("require.resolve")("pages/BuyQueuePage/BuyQueuePage");
    }
}, {
    fallback: fallback
});
var PrivateSalePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-PrivateSalePage-PrivateSalePage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-PrivateSalePage-PrivateSalePage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6471), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(3145)]).then(__webpack_require__.bind(__webpack_require__, 84772));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(84772);
        }
        return eval("require.resolve")("pages/PrivateSalePage/PrivateSalePage");
    }
}, {
    fallback: fallback
});
var NotesLibraryPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-NotesLibraryPage-NotesLibraryPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-NotesLibraryPage-NotesLibraryPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6556), __webpack_require__.e(60), __webpack_require__.e(4613)]).then(__webpack_require__.bind(__webpack_require__, 54464));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(54464);
        }
        return eval("require.resolve")("pages/NotesLibraryPage/NotesLibraryPage");
    }
}, {
    fallback: fallback
});
var NoteDetailsPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-NoteDetailsPage-NoteDetailsPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-NoteDetailsPage-NoteDetailsPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(2293), __webpack_require__.e(5800), __webpack_require__.e(60), __webpack_require__.e(3918)]).then(__webpack_require__.bind(__webpack_require__, 76893));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(76893);
        }
        return eval("require.resolve")("pages/NoteDetailsPage/NoteDetailsPage");
    }
}, {
    fallback: fallback
});
var FragranceFamiliesPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-FragranceFamiliesPage-FragranceFamiliesPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-FragranceFamiliesPage-FragranceFamiliesPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(2293), __webpack_require__.e(60), __webpack_require__.e(4802)]).then(__webpack_require__.bind(__webpack_require__, 29862));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(29862);
        }
        return eval("require.resolve")("pages/FragranceFamiliesPage/FragranceFamiliesPage");
    }
}, {
    fallback: fallback
});
var FragranceFamilyDetailsPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-FragranceFamilyDetailsPage-FragranceFamilyDetailsPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-FragranceFamilyDetailsPage-FragranceFamilyDetailsPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(2293), __webpack_require__.e(60), __webpack_require__.e(249)]).then(__webpack_require__.bind(__webpack_require__, 20058));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(20058);
        }
        return eval("require.resolve")("pages/FragranceFamilyDetailsPage/FragranceFamilyDetailsPage");
    }
}, {
    fallback: fallback
});
var ScentbirdSelectPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-catalog-ScentbirdSelectPage-ScentbirdSelectPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-catalog-ScentbirdSelectPage-ScentbirdSelectPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6471), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(1150), __webpack_require__.e(1862), __webpack_require__.e(610), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(5878)]).then(__webpack_require__.bind(__webpack_require__, 72677));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(72677);
        }
        return eval("require.resolve")("pages/catalog/ScentbirdSelectPage/ScentbirdSelectPage");
    }
}, {
    fallback: fallback
});
var ScentHoroscopePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-horoscope-ScentHoroscopePage-ScentHoroscopePage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | pages-horoscope-ScentHoroscopePage-ScentHoroscopePage */ 3211).then(__webpack_require__.bind(__webpack_require__, 5693));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(5693);
        }
        return eval("require.resolve")("pages/horoscope/ScentHoroscopePage/ScentHoroscopePage");
    }
}, {
    fallback: fallback
});
var ScentHoroscopeSignPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-horoscope-ScentHoroscopeSignPage-ScentHoroscopeSignPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-horoscope-ScentHoroscopeSignPage-ScentHoroscopeSignPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6556), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6471), __webpack_require__.e(5529), __webpack_require__.e(6102), __webpack_require__.e(2293), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(9251)]).then(__webpack_require__.bind(__webpack_require__, 50959));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(50959);
        }
        return eval("require.resolve")("pages/horoscope/ScentHoroscopeSignPage/ScentHoroscopeSignPage");
    }
}, {
    fallback: fallback
});
var LimitedDropLandingPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-LimitedDropPage-LimitedDropPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-LimitedDropPage-LimitedDropPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6471), __webpack_require__.e(1347), __webpack_require__.e(1862), __webpack_require__.e(60), __webpack_require__.e(6861)]).then(__webpack_require__.bind(__webpack_require__, 77335));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(77335);
        }
        return eval("require.resolve")("pages/LimitedDropPage/LimitedDropPage");
    }
}, {
    fallback: fallback
});
var AcademyPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-academy-AcademyPage-AcademyPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | pages-academy-AcademyPage-AcademyPage */ 1162).then(__webpack_require__.bind(__webpack_require__, 37515));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(37515);
        }
        return eval("require.resolve")("pages/academy/AcademyPage/AcademyPage");
    }
}, {
    fallback: fallback
});
var AcademyCoursePage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-academy-CoursePage-CoursePage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-academy-CoursePage-CoursePage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(8383), __webpack_require__.e(7865), __webpack_require__.e(6113), __webpack_require__.e(6556), __webpack_require__.e(7369), __webpack_require__.e(9660), __webpack_require__.e(3874), __webpack_require__.e(6924), __webpack_require__.e(6471), __webpack_require__.e(6102), __webpack_require__.e(2293), __webpack_require__.e(60), __webpack_require__.e(5047), __webpack_require__.e(7493)]).then(__webpack_require__.bind(__webpack_require__, 51600));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(51600);
        }
        return eval("require.resolve")("pages/academy/CoursePage/CoursePage");
    }
}, {
    fallback: fallback
});
var CareersPage = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function() {
        return "pages-CareersPage-CareersPage";
    },
    isReady: function(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return Promise.all(/* import() | pages-CareersPage-CareersPage */[__webpack_require__.e(532), __webpack_require__.e(1262), __webpack_require__.e(7865), __webpack_require__.e(9846), __webpack_require__.e(8650)]).then(__webpack_require__.bind(__webpack_require__, 89013));
    },
    requireAsync: function(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function() {
        if (true) {
            return /*require.resolve*/(89013);
        }
        return eval("require.resolve")("pages/CareersPage/CareersPage");
    }
}, {
    fallback: fallback
});
// redirects to different pages, depending on the user gender
var GenderRedirect = function(param) {
    var path = param.path, female = param.female, male = param.male;
    var gender = (0,modules_user__WEBPACK_IMPORTED_MODULE_8__/* .useUser */ .a)().gender;
    var to = gender === "FEMALE" ? female : male;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        path: path,
        to: to
    });
};
// Update analytics context on each route change or reset it to default value
var handleRouteChange = function(match) {
    var pageContext = links__WEBPACK_IMPORTED_MODULE_10__/* .routeAnalytics */ .rB[match === null || match === void 0 ? void 0 : match.path];
    (0,analytics__WEBPACK_IMPORTED_MODULE_11__/* .updateAnalyticsContext */ .yT)(pageContext || {});
};
var Routes = function() {
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        setTimeout(function() {
            // preload after rendering to provide better UX
            MainLayout.preload();
            MinimalLayout.preload();
        }, 1000);
    }, []);
    var isCandleSubscriptionEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.candleSubscription);
    var isDriftSubscriptionEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.driftSubscription);
    var isTheEditPageEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.theEdit);
    var isGiftHubEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.giftHub);
    var isHolidayShopEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.holidayCatalogue);
    var isHoliday22CardUpdate60Enabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.holiday22CardUpdate60);
    var isHoliday22Resubscribe60Enabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.holiday22Resubscribe60);
    var isGiftSetProductPageEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.giftSetProductPage);
    var isScentHoroscopeEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.scentHoroscope);
    var isShopSamplesEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.shopSamples);
    var isLimitedDropsEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.limitedDrops);
    var isTravelSizeFragrancesEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.travelSizeFragrances);
    var isCOARShopPageEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.coarShopPage);
    var isScentbirdAcademyEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.scentbirdAcademy);
    var isGiftsUnder50PageEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.giftsUnder50Page);
    var isTwelveDaysPageEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.twelveDaysPage);
    var isStrapiCareersPageEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.features.strapiCareersPage);
    var isUpchargeInfoPaymentEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.abTests.upchargeInfoPayment) === "b";
    var isInAppMessagesCenterEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.abTests.inAppMessagesCenter) === "b";
    var isRegisterInPaymentEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.abTests.paymentRegisterInPayment) === "b";
    var isNotProduction = config__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z.runEnv !== "prod";
    // ft, ab, cookies
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(router__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
        onChange:  true ? handleRouteChange : 0,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                children: _redirects__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z.map(function(param) {
                    var from = param.from, to = param.to;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        path: from,
                        to: to,
                        code: 301
                    }, from);
                })
            }),
            isNotProduction && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                path: "/test-page",
                component: TestPage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.scentProfile,
                component: ScentProfilePage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.smartRecommendations,
                component: SmartRecommendationsPage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MinimalLayout, {
                withoutHeader: isRegisterInPaymentEnabled,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(containers_HasAuth_HasAuth__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    isRegisterFlow: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(containers_ResolvePostponed_ResolvePostponed__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        withNotification: false,
                        children: [
                            !isRegisterInPaymentEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.subscribe,
                                        component: PaymentPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.checkout,
                                        component: PaymentPage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.queueRedeem,
                                component: PaymentPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.tossInRedeem,
                                component: PaymentPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftCardPayment,
                                component: PaymentPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftSubscriptionPayment,
                                component: PaymentPage
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MinimalLayout, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(containers_HasAuth_HasAuth__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    isRegisterFlow: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(containers_ResolvePostponed_ResolvePostponed__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        withNotification: false,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftSubscriptionRedeem,
                            component: GiftSubscriptionRedeemPage
                        })
                    })
                })
            }),
            isRegisterInPaymentEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MinimalLayout, {
                withoutHeader: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(containers_AuthPageProvider_AuthPageProvider__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                    withRedirect: false,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(containers_ResolvePostponed_ResolvePostponed__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        withNotification: false,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.subscribe,
                                component: PaymentPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.checkout,
                                component: PaymentPage
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(MinimalLayout, {
                withFooter: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.request,
                        component: RequestPage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(containers_HasAuth_HasAuth__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.profile.removeAccountConfirmation,
                            component: RemoveAccountConfirmationPage
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(containers_AuthPageProvider_AuthPageProvider__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.register,
                        component: RegisterPage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.magicLinkContinue,
                        component: MagicLinkContinuePage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(MinimalLayout, {
                        logoLink: null,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.login,
                                component: LoginPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.forgotPassword,
                                component: ForgotPasswordPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.resetPassword,
                                component: ResetPasswordPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.recoverPassword,
                                component: RecoverPasswordPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.facebookEmail,
                                component: FacebookEmailPage
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(LandingLayout, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(containers_HasNeverSubscribed_HasNeverSubscribed__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.home,
                            component: LandingPage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.homeMen,
                            component: LandingPage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.freeTrial,
                            component: LandingPage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.freeTrialMen,
                            component: LandingPage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.freeTrialCa,
                            component: LandingPage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.freeTrialMenCa,
                            component: LandingPage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.freePerfume,
                            component: LandingPage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.freePerfumeMen,
                            component: LandingPage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.secondMonthFree,
                            component: LandingPage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.secondMonthFreeMen,
                            component: LandingPage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.nift,
                            component: LandingPage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.bouqs,
                            component: LandingPage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.andreDrummond,
                            component: LandingPage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.referral,
                            component: ReferralLandingPage
                        }),
                        isTwelveDaysPageEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.twelveDays,
                            component: TwelveDays
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MinimalFAQLayout, {
                withCart: true,
                withLogin: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                    path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productPerfumeLanding,
                    component: ProductPage
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(MainLayout, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.terms,
                        component: TermsPage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.privacy,
                        component: PrivacyPage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.team,
                        component: AboutPage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.press,
                        component: PressPage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ccpa,
                        component: CCPAPage
                    }),
                    isTheEditPageEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.theEdit,
                        component: TheEditPage
                    }),
                    isScentbirdAcademyEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.academy.root,
                                component: AcademyPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.academy.course,
                                component: AcademyCoursePage
                            })
                        ]
                    }),
                    isStrapiCareersPageEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.careers,
                        component: CareersPage
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        to: helpers__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z.externalLinks.ripplingJobs
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(containers_ResolvePostponed_ResolvePostponed__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                        withNotification: true,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.brands,
                                component: BrandsPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.brand,
                                component: BrandPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.seoPerfumes,
                                component: SeoPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.seoColognes,
                                component: SeoPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.collectionsWomen,
                                component: CollectionsPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.collectionsMen,
                                component: CollectionsPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.collectionWomen,
                                component: CollectionPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.collectionMen,
                                component: CollectionPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.subscription.perfumeOfTheMonthList,
                                component: FOMListPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.subscription.cologneOfTheMonthList,
                                component: FOMListPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.subscription.perfumeOfTheMonth,
                                component: FOMPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.subscription.cologneOfTheMonth,
                                component: FOMPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.subscription.currentPerfumeOfTheMonth,
                                component: FOMPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.subscription.currentCologneOfTheMonth,
                                component: FOMPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftSubscription,
                                component: GiftSubscriptionPage
                            }),
                            isGiftsUnder50PageEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftsUnder50,
                                component: GiftsUnder50Page
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftCard,
                                component: GiftCardPage
                            }),
                            isGiftHubEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.gifts,
                                component: GiftHubPage
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.gifts,
                                component: GiftsPage
                            }),
                            isGiftSetProductPageEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftSet,
                                component: ProductPage
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftSet,
                                component: GiftSetPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(GenderRedirect, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftSets.root,
                                female: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftSets.perfumes,
                                male: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftSets.colognes
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftSets.colognes,
                                component: GiftSetsPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftSets.unisex,
                                component: GiftSetsPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftSets.perfumes,
                                component: GiftSetsPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productGeneral,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productPerfume,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productWellness,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productSkincare,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productPersonalCare,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productLegacyBody,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productMakeup,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productExtra,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productCandle,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productExclusive,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productDiffuser,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productAccessory,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productHomeFragranceAccessory,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productCarFreshenerRefill,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productCarFreshenerClip,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.productRoomSpray,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ecommerce.productGeneral,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ecommerce.productPerfume,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ecommerce.productWellness,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ecommerce.productSkincare,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ecommerce.productPersonalCare,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ecommerce.productLegacyBody,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ecommerce.productMakeup,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ecommerce.productExtra,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ecommerce.productCandle,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ecommerce.productDiffuser,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ecommerce.productAccessory,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ecommerce.productHomeFragranceAccessory,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ecommerce.productCarFreshenerRefill,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ecommerce.productCarFreshenerClip,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.ecommerce.productRoomSpray,
                                component: ProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.notes,
                                component: NotesLibraryPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.note,
                                component: NoteDetailsPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.fragranceFamilies,
                                component: FragranceFamiliesPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.fragranceFamily,
                                component: FragranceFamilyDetailsPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.scentbirdSelect,
                                component: ScentbirdSelectPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.saks,
                                to: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.scentbirdSelect
                            }),
                            isScentHoroscopeEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.scentHoroscope,
                                        component: ScentHoroscopePage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.scentHoroscopeSign,
                                        component: ScentHoroscopeSignPage
                                    })
                                ]
                            }),
                            isLimitedDropsEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.limitedDrop,
                                component: LimitedDropLandingPage
                            }),
                            isCOARShopPageEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.coar,
                                component: COAREnhancedPage
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.coar,
                                to: "/brand/confessions-of-a-rebel?productInputSource=THE_EDIT&sourceProductGroup=Perfume"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(containers_SubscriptionLayout_SubscriptionLayout__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.subscription.main,
                                        component: MainPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.subscription.perfumes,
                                        component: FragranceCatalogPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.subscription.colognes,
                                        component: FragranceCatalogPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.subscription.beauty,
                                        component: BeautyCatalogPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(GenderRedirect, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.newArrivals.root,
                                        female: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.newArrivals.perfumes,
                                        male: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.newArrivals.colognes
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.newArrivals.perfumes,
                                        component: NewArrivalsPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.newArrivals.colognes,
                                        component: NewArrivalsPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(GenderRedirect, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.bestsellers.root,
                                        female: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.bestsellers.perfumes,
                                        male: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.bestsellers.colognes
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.bestsellers.perfumes,
                                        component: BestsellersPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.bestsellers.colognes,
                                        component: BestsellersPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(GenderRedirect, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.clean.root,
                                        female: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.clean.perfumes,
                                        male: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.clean.colognes
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.clean.perfumes,
                                        component: CleanFragrancesPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.clean.colognes,
                                        component: CleanFragrancesPage
                                    }),
                                    isTheEditPageEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.root,
                                        to: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.theEdit
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(GenderRedirect, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.root,
                                        female: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.perfumes,
                                        male: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.colognes
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.candles,
                                        to: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.candlesHomeScents
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.candlesHomeScents,
                                        component: CandlesPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.scentbirdCases,
                                        component: CasesPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.accessories,
                                        component: AccessoriesPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.bathBody,
                                        component: BathAndBodyPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.perfumes,
                                        component: FullSizeFragrancesPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.colognes,
                                        component: FullSizeFragrancesPage
                                    }),
                                    isShopSamplesEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(GenderRedirect, {
                                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.samples.root,
                                                female: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.samples.perfumes,
                                                male: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.samples.colognes
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.samples.perfumes,
                                                component: ShopSamplesPage
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.samples.colognes,
                                                component: ShopSamplesPage
                                            })
                                        ]
                                    }),
                                    isTravelSizeFragrancesEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(GenderRedirect, {
                                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.travelSize.root,
                                                female: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.travelSize.perfumes,
                                                male: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.travelSize.colognes
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.travelSize.perfumes,
                                                component: TravelSizePage
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.travelSize.colognes,
                                                component: TravelSizePage
                                            })
                                        ]
                                    }),
                                    isHolidayShopEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.holiday,
                                        component: HolidayPage
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.holiday,
                                        to: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.shop.perfumes
                                    })
                                ]
                            })
                        ]
                    }),
                    isNotProduction && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        path: "/demo-user",
                        component: DemoUserPage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(containers_HasAuth_HasAuth__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.resubscribe,
                                component: ResubscribePage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.resubscribeNoOffer,
                                component: ResubscribePage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.resubscribe50,
                                component: ResubscribePage
                            }),
                            isHoliday22Resubscribe60Enabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.resubscribe60,
                                component: ResubscribePage
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.resubscribe60,
                                to: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.resubscribe
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.resubscribeFree,
                                component: ResubscribePage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.resubscribeFreeProduct,
                                component: ResubscribePage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.resubscribeFreeCase,
                                component: ResubscribePage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.upgradeProduct,
                                component: UpgradeProductPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.downgrade,
                                component: DowngradePage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.invite,
                                component: ReferralPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.profile.subscriptionStatus,
                                component: SubscriptionStatusPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.profile.personalInfo,
                                component: PersonalInformationPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.profile.orderHistory,
                                component: OrderHistoryPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.profile.billing,
                                component: BillingPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.profile.shipping,
                                component: ShippingPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.profile.reviews,
                                component: ReviewsPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftCardClaim,
                                component: GiftCardClaimPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftSubscriptionRedeemThankYou,
                                component: GiftSubscriptionRedeemThankYouPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.giftCardClaimThankYou,
                                component: GiftCardClaimThankYouPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.caseSubscriptionThankYou,
                                component: CaseSubscriptionThankYouPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.caseSubscription,
                                component: CaseSubscriptionPage
                            }),
                            isCandleSubscriptionEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.candleSubscriptionThankYou,
                                        component: CandleSubscriptionThankYouPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.candleSubscription,
                                        component: CandleSubscriptionPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.featuredCandle,
                                        component: FeaturedCandlePage
                                    })
                                ]
                            }),
                            isDriftSubscriptionEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.driftSubscriptionThankYou,
                                        component: DriftSubscriptionThankYouPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.driftSubscription,
                                        component: DriftSubscriptionPage
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.driftSubscriptionPDP,
                                        component: DriftSubscriptionProductPage
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.tossIn,
                                component: TossInPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.buyQueue,
                                component: BuyQueuePage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.privateSale,
                                component: PrivateSalePage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.featuredBrand,
                                component: FeaturedBrandPage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(containers_ResolvePostponed_ResolvePostponed__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                withNotification: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.queue,
                                    component: QueuePage
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MainLayout, {
                withHeaderBanner: false,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(containers_HasAuth_HasAuth__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.cardUpdate,
                            component: CardUpdatePage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.cardUpdate50,
                            component: CardUpdatePage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.cardUpdate10,
                            component: CardUpdatePage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.cardUpdateFreeCase,
                            component: CardUpdatePage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.cardUpdateFreeProduct,
                            component: CardUpdatePage
                        }),
                        isHoliday22CardUpdate60Enabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.cardUpdate60,
                            component: CardUpdatePage
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.cardUpdate60,
                            to: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.cardUpdate
                        }),
                        isInAppMessagesCenterEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.inAppMessagesCenter,
                            component: InAppMessagesCenterPage
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.inAppMessagesCenter,
                            to: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.subscription.main
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(containers_HasAuth_HasAuth__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(containers_ResolvePostponed_ResolvePostponed__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                    withNotification: true,
                    withoutPremiumModal: isUpchargeInfoPaymentEnabled,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                        path: links__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP.thankYou,
                        component: ThankYouPage
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(MainLayout, {
                contentWrapperClassName: "flex",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(router__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                    path: "*",
                    component: Page404
                })
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Routes);


/***/ }),

/***/ 48444:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96837);
/* harmony import */ var core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51497);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69541);




// [ from1, from2, ..., to ]
var rawRedirects = [
    [
        "/subscription",
        "/subscription/main-(women|men)",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.main
    ],
    [
        "/profile/billing-and-shipping",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.profile.shipping
    ],
    [
        "/subscription/payment/coupon",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.checkout
    ],
    [
        "/upgrade",
        "/upgrade-3",
        "/upgrade-6",
        "/upgrade-12",
        "/upgrade-plans",
        "/upgrade-plan",
        "/prepaid-plans",
        "/profile/upgrade",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.upgradeProduct
    ],
    [
        "/card-update-4",
        "/card-update-lite",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.cardUpdate
    ],
    [
        "/subscription/extras",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.shop.scentbirdCases
    ],
    [
        "/onboarding-product",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.smartRecommendations
    ],
    [
        "/case",
        "/case-monthly",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.caseSubscription
    ],
    [
        "/tracking",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.profile.orderHistory
    ],
    [
        "/flash-sale",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.privateSale
    ],
    [
        "/makeup",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.beauty
    ],
    [
        "/skincare",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.beauty
    ],
    [
        "/personal-care",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.beauty
    ],
    [
        "/makeup/:product",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.beauty
    ],
    [
        "/skincare/:product",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.beauty
    ],
    [
        "/personal-care/:product",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.beauty
    ],
    [
        "/subscription/smartsearch",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.perfumes
    ],
    [
        "/subscription/collections-women",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.collectionsWomen
    ],
    [
        "/subscription/collections-men",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.collectionsMen
    ],
    [
        "/giftcard",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.giftCard
    ],
    [
        "/profile/orders-status",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.profile.orderHistory
    ],
    [
        "/profile/password",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.profile.personalInfo
    ],
    [
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.profile.root,
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.profile.subscriptionStatus
    ],
    [
        "/giftset",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.gifts
    ],
    [
        "/subscription/resubscribe",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.resubscribe
    ],
    // seo pages
    [
        "/new-arrivals-(perfume|fragrance)(s)?",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.newArrivals.perfumes
    ],
    [
        "/new-arrivals/(fragrance)(s)?",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.newArrivals.perfumes
    ],
    [
        "/new-arrivals-cologne(s)?",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.newArrivals.colognes
    ],
    [
        "/best-selling-(perfume|fragrance)(s)?",
        "/bestsellers-women",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.bestsellers.perfumes
    ],
    [
        "/best-selling-cologne(s)?",
        "/bestsellers-men",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.bestsellers.colognes
    ],
    [
        "/(perfume|fragrance|cologne)(s)?-for-women",
        "/perfumes",
        "/fragrance",
        "/popupshop",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.perfumes
    ],
    [
        "/(perfume|fragrance|cologne)(s)?-for-men",
        "/colognes",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.colognes
    ],
    [
        "/spring-giveaway",
        "/discover/show/:id",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.main
    ],
    [
        "/perfume/:slug/main",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.productPerfume
    ],
    [
        "/candles/:slug",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.productCandle
    ],
    [
        "/hand-cream/:slug",
        "/ecommerce/personal-care/hand-cream/:slug"
    ],
    [
        "/body",
        "/scrubs",
        "/lip-balms",
        "/hand-creams",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.shop.root
    ],
    [
        "/:slug-collection",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.collectionsWomen
    ],
    [
        "/collections-(women|men)/scent-horoscope",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.scentHoroscope
    ],
    // brand seo swarm PF-1050
    // ATTN param should be the same in from-to pair (e.g. :name as in links.brand)
    [
        "/:name-fragrance(s)?",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.brand
    ],
    [
        "/:name-(perfume|fragrance|cologne)(s)?-for-(women|her)",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.seoPerfumes
    ],
    [
        "/:name-(perfume|fragrance|cologne)(s)?-for-(men|him)",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.seoColognes
    ],
    // marketing links
    [
        "/email/:page",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.home
    ],
    [
        "/how-it-works",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.home
    ],
    [
        "/influencer",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.home
    ],
    [
        "/men/influencer",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.homeMen
    ],
    [
        "/new",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.home
    ],
    [
        "/scentbird-reviews",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.home
    ],
    // old lnks
    [
        "/spring-giveaway",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.main
    ],
    [
        "/giftset-women",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.giftSets.perfumes
    ],
    [
        "/giftset-men",
        links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.giftSets.colognes
    ]
];
// TODO add all redirects to nginx or to a middleware - added on 2022-01-26 by maddoger
var redirects = rawRedirects.reduce(function(result, item) {
    var to = item[item.length - 1];
    for(var i = 1; i < item.length; i++){
        result.push({
            from: item[i - 1],
            to: to
        });
    }
    return result;
}, []);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (redirects);


/***/ }),

/***/ 86488:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var react_helmet_async__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75479);



var StatusCode = function(param) {
    var value = param.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_helmet_async__WEBPACK_IMPORTED_MODULE_2__/* .Helmet */ .ql, {
        htmlAttributes: {
            statusCode: value
        }
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (StatusCode);


/***/ }),

/***/ 38396:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ SubscriptionLayout_SubscriptionLayout)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.date.to-string.js
var es_date_to_string = __webpack_require__(45942);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.date.now.js
var es_date_now = __webpack_require__(25503);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(62100);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(69453);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(83464);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__(73074);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/date/index.ts
var date = __webpack_require__(64895);
// EXTERNAL MODULE: ./local_modules/date/difference.ts
var difference = __webpack_require__(97993);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(68426);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(51827);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(31978);
// EXTERNAL MODULE: ./local_modules/cookie-storage/index.ts + 2 modules
var cookie_storage = __webpack_require__(83913);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/modules/brands/useStrapiWSTOBrandSlug.ts
var useStrapiWSTOBrandSlug = __webpack_require__(87342);
// EXTERNAL MODULE: ./src/modules/brands/useStrapiWSTOModalWithProductsOptions.ts
var useStrapiWSTOModalWithProductsOptions = __webpack_require__(26019);
// EXTERNAL MODULE: ./src/modules/products/usePrivateSale.ts + 1 modules
var usePrivateSale = __webpack_require__(28733);
// EXTERNAL MODULE: ./src/modules/limitedDrops/useLimitedDropSale.ts + 1 modules
var useLimitedDropSale = __webpack_require__(78721);
// EXTERNAL MODULE: ./src/modules/recommendations/index.ts + 2 modules
var recommendations = __webpack_require__(4252);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(91339);
// EXTERNAL MODULE: ./src/modules/subscription/subscriptionAddons/index.ts + 5 modules
var subscriptionAddons = __webpack_require__(4833);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user_user = __webpack_require__(17382);
// EXTERNAL MODULE: ./src/modules/user/shownPopups/index.tsx + 2 modules
var user_shownPopups = __webpack_require__(86506);
// EXTERNAL MODULE: ./src/modules/user/referralProgram/index.ts
var referralProgram = __webpack_require__(2487);
// EXTERNAL MODULE: ./src/modules/academy/index.ts + 2 modules
var academy = __webpack_require__(74317);
;// CONCATENATED MODULE: ./src/containers/SubscriptionLayout/components/SubscriptionModals/SubscriptionModals.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
























// ATTN all loading should be processed inside modals, because we should show only one modal at once
var SubscriptionModals = function() {
    // data for modals
    var pathname = (0,contexts/* usePathname */.jD)();
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var _useSearchParams = _sliced_to_array((0,contexts/* useSearchParams */.lr)(), 1), autoTestSkip = _useSearchParams[0].autoTestSkip;
    var modalWasOpenRef = (0,react.useRef)(Boolean(autoTestSkip));
    var isCandleSubscriptionEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.candleSubscription);
    var isDriftSubscriptionEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.driftSubscription);
    var isSaksCollaborationEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.collaborationSaks);
    var isMobileAppEntrypointModalEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.mobileAppEntryPoint);
    var isLimitedDropsEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.limitedDrops);
    var isDriftEcommercePromoEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.driftEcommercePromo);
    var isQueueUpgradePopupEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.upgradePopup) === "b";
    var strapiWSTOBrandSlug = (0,useStrapiWSTOBrandSlug/* default */.Z)();
    var strapiWSTOModalWithProductsOptions = (0,useStrapiWSTOModalWithProductsOptions/* default */.Z)();
    var isStrapiWSTOEnabled = Boolean(strapiWSTOBrandSlug);
    var _useUser = (0,user_user/* useUser */.a)(), user = _useUser.user, isLoggedIn = _useUser.isLoggedIn;
    var subscription = (0,subscription_subscription/* useSubscription */.m)().subscription;
    var candleSubscription = (0,subscriptionAddons/* useCandleSubscription */.pj)().candleSubscription;
    var caseSubscription = (0,subscriptionAddons/* useCaseSubscription */.PZ)().caseSubscription;
    var driftSubscription = (0,subscriptionAddons/* useDriftSubscription */.RD)().driftSubscription;
    var shownPopups = (0,user_shownPopups/* useShownPopups */.BP)().shownPopups;
    var setPopupShown = (0,user_shownPopups/* useSetPopupShown */.aw)();
    var _usePrivateSale = (0,usePrivateSale/* default */.Z)(), privateSale = _usePrivateSale.privateSale, isFetching = _usePrivateSale.isFetching;
    var _useUnratedProduct = (0,recommendations/* useUnratedProduct */.R)({
        skip: !isLoggedIn
    }), unratedProduct = _useUnratedProduct.product, isUnratedProductFetching = _useUnratedProduct.isFetching;
    var _useLimitedDropSale = (0,useLimitedDropSale/* default */.Z)(), limitedDrop = _useLimitedDropSale.data, isLimitedDropFetching = _useLimitedDropSale.isFetching;
    var _useReferralInvites = (0,referralProgram/* useReferralInvites */.n)(), _useReferralInvites_stats = _useReferralInvites.stats, availableReferralInvites = _useReferralInvites_stats.available;
    var _useAcademyCoursePromo = (0,academy/* useAcademyCoursePromo */.mF)(), scentbirdAcademyCourse = _useAcademyCoursePromo.data, isScentbirdAcademyCourseFetching = _useAcademyCoursePromo.isFetching;
    var isScentbirdAcademyPopupEnabled = (subscription === null || subscription === void 0 ? void 0 : subscription.isActive) && (scentbirdAcademyCourse === null || scentbirdAcademyCourse === void 0 ? void 0 : scentbirdAcademyCourse.status) === "AVAILABLE";
    (0,react.useEffect)(function() {
        var _shownPopups_candleSubscriptionPromoModal;
        if (modalWasOpenRef.current) {
            return;
        }
        // loading state
        if (!isLoggedIn || !user || !subscription || !shownPopups || isFetching || isUnratedProductFetching || isLimitedDropFetching || isScentbirdAcademyCourseFetching) {
            return;
        }
        // some modals should be opened only on main page
        var isMainPage = pathname === links/* default */.ZP.subscription.main;
        /**
     * ATTN if you already have a modal in Modals file, just import it`s module and open.
     *  Otherwise, import a module and use setActiveModal to load and open it.
     */ var lastShipmentReviewModal = function(priority) {
            /**
       If a customer closes the popup we will show it again 2 weeks after.
       If a customer closes the second popup we don’t show it again.
       New “Delivery” event will trigger a new popup.
       */ if (!unratedProduct) {
                return;
            }
            var popupId = "lastShipmentReview_".concat(unratedProduct.id);
            var _ref = shownPopups[popupId] || {}, _ref_count = _ref.count, count = _ref_count === void 0 ? 0 : _ref_count, _ref_lastUpdated = _ref.lastUpdated, lastUpdated = _ref_lastUpdated === void 0 ? 0 : _ref_lastUpdated;
            var lastUpdateTime = new Date(lastUpdated).getTime() + 14 * 24 * 60 * 60 * 1000 // 14 days between shows
            ;
            var isVisible = isMainPage && (count === 0 || count === 1 && Date.now() > lastUpdateTime);
            if (isVisible) {
                var onReviewModalClose = function() {
                    return setPopupShown(popupId);
                };
                if (isMobile) {
                    (0,manager/* openModal */.h7)("lastShipmentReviewModal", {
                        priority: priority,
                        product: unratedProduct,
                        onClose: onReviewModalClose
                    });
                } else {
                    (0,manager/* openModal */.h7)("productReviewModal", {
                        flow: "Review popup",
                        placement: "Page body",
                        productId: unratedProduct.id,
                        onClose: onReviewModalClose
                    });
                }
                return true;
            }
        };
        var inviteModal = function(priority) {
            var isPathnameAcceptable = pathname === links/* default */.ZP.subscription.perfumes || pathname === links/* default */.ZP.subscription.colognes || pathname === links/* default */.ZP.subscription.main;
            var isReferralItemVisible = isPathnameAcceptable && availableReferralInvites > 0;
            if (isReferralItemVisible) {
                var lastUpdated = (shownPopups.inviteModal || {}).lastUpdated;
                var lastUpdatedDate = (0,date/* default */.ZP)(lastUpdated || 0);
                var now = (0,date/* default */.ZP)();
                // open each month after 2nd, because we add credits after the 2nd every month
                if (!lastUpdated || now.isAfter(lastUpdatedDate, "month") && now.date() >= 2) {
                    (0,manager/* openModal */.h7)("inviteModal", {
                        priority: priority,
                        onClose: function() {
                            return setPopupShown("inviteModal");
                        }
                    });
                    return true;
                }
            }
        };
        var cardUpdateModal = function(priority) {
            var isShownInSession = cookie_storage/* default */.ZP.getItem(constants/* default */.Z.cookieNames.isCardUpdateModalShown);
            var isVisible = isMainPage && subscription.isUnpaid && !isShownInSession;
            if (isVisible) {
                (0,manager/* openModal */.h7)("cardUpdateModal", {
                    priority: priority,
                    flow: "Website visit"
                });
                return true;
            }
        };
        var firstTimeVisitModal = function(priority) {
            var _shownPopups_firstTimeVisitModal;
            // This modal should be only visible on mobile as a result of CRO-97 ab test
            var isVisible = isMobile && isMainPage && subscription.hasNeverSubscribed && !(shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_firstTimeVisitModal = shownPopups.firstTimeVisitModal) === null || _shownPopups_firstTimeVisitModal === void 0 ? void 0 : _shownPopups_firstTimeVisitModal.count);
            if (isVisible) {
                (0,manager/* openModal */.h7)("firstTimeVisitModal", {
                    priority: priority
                });
                return true;
            }
        };
        var candleSubscriptionPromoModalShownCount = (shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_candleSubscriptionPromoModal = shownPopups.candleSubscriptionPromoModal) === null || _shownPopups_candleSubscriptionPromoModal === void 0 ? void 0 : _shownPopups_candleSubscriptionPromoModal.count) || 0;
        var candleSubscriptionPromoModal = function(priority) {
            var _shownPopups_candleSubscriptionPromoModal;
            var lastUpdated = shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_candleSubscriptionPromoModal = shownPopups.candleSubscriptionPromoModal) === null || _shownPopups_candleSubscriptionPromoModal === void 0 ? void 0 : _shownPopups_candleSubscriptionPromoModal.lastUpdated;
            var isVisible = isMainPage && isCandleSubscriptionEnabled && (candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isEnabled) && !(candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isSelected) && candleSubscriptionPromoModalShownCount < 3 && (!lastUpdated || (0,difference/* getElapsedTime */.q)(lastUpdated, "hours") >= 24);
            if (isVisible) {
                (0,manager/* openModal */.h7)("candleSubscriptionPromoModal", {
                    priority: priority
                });
                return true;
            }
        };
        var privateSaleModal = function(priority) {
            if (!privateSale) {
                return;
            }
            var popupName = "privateSale".concat(new Date(privateSale.startDate).getTime());
            var wasNotShownBefore = !(shownPopups === null || shownPopups === void 0 ? void 0 : shownPopups[popupName]);
            var isVisible = isLoggedIn && privateSale.timeLeft > 5000 && wasNotShownBefore;
            if (isVisible) {
                (0,manager/* openModal */.h7)("privateSaleModal", {
                    priority: priority,
                    popupName: popupName
                });
                return true;
            }
        };
        var tossInModal = function(priority) {
            var _shownPopups_tossInModal;
            var month = new Date().getMonth();
            var year = new Date().getFullYear();
            var lastUpdated = shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_tossInModal = shownPopups.tossInModal) === null || _shownPopups_tossInModal === void 0 ? void 0 : _shownPopups_tossInModal.lastUpdated;
            var isVisible = subscription === null || subscription === void 0 ? void 0 : subscription.canApplyTossInOffer;
            if (lastUpdated) {
                var popupMonth = new Date(lastUpdated).getMonth();
                var popupYear = new Date(lastUpdated).getFullYear();
                // hide the popup if it was closed in the current month
                if (month === popupMonth && year === popupYear) {
                    isVisible = false;
                }
            }
            if (isVisible) {
                (0,manager/* openModal */.h7)("tossInModal", {
                    priority: priority
                });
                return true;
            }
        };
        var verifyShippingAddressModal = function(priority) {
            var isShippingAddressInvalid = subscription.isShippingAddressInvalid, isShippingAddressUndeliverable = subscription.isShippingAddressUndeliverable;
            if (isMainPage && isShippingAddressInvalid) {
                (0,manager/* openModal */.h7)("verifyShippingAddressModal", {
                    isUndeliverable: isShippingAddressUndeliverable,
                    priority: priority
                });
                return true;
            }
        };
        var tryTwoThreeFragrancesModal = function(priority) {
            var _shownPopups_tryTwoThreeFragrancesModal, _subscription_credits;
            var lastUpdated = shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_tryTwoThreeFragrancesModal = shownPopups.tryTwoThreeFragrancesModal) === null || _shownPopups_tryTwoThreeFragrancesModal === void 0 ? void 0 : _shownPopups_tryTwoThreeFragrancesModal.lastUpdated;
            var isVisible = (subscription === null || subscription === void 0 ? void 0 : subscription.isUpgradableFromMonthlyPlan) && (subscription === null || subscription === void 0 ? void 0 : (_subscription_credits = subscription.credits) === null || _subscription_credits === void 0 ? void 0 : _subscription_credits.free) === 0 && (0,difference/* getElapsedTime */.q)(subscription.subscriptionDate, "days") >= 1 // 1 day after subscription
             && (!lastUpdated || (0,difference/* getElapsedTime */.q)(lastUpdated, "days") >= 30);
            if (isVisible) {
                var onClose = function() {
                    // ATTN both popups use the same popupShown ids
                    void setPopupShown("tryTwoThreeFragrancesModal");
                };
                if (isQueueUpgradePopupEnabled) {
                    (0,manager/* openModal */.h7)("addToQueueUpgradeModal", {
                        priority: priority,
                        onClose: onClose
                    });
                } else {
                    (0,manager/* openModal */.h7)("tryTwoThreeFragrancesModal", {
                        priority: priority,
                        onClose: onClose
                    });
                }
                return true;
            }
        };
        var resubscribePromoModal = function(priority) {
            var isVisible = (isMainPage || pathname === links/* default */.ZP.subscription.perfumes || pathname === links/* default */.ZP.subscription.colognes) && subscription.isCancelled && !cookie_storage/* default */.ZP.getItem(constants/* default */.Z.cookieNames.isResubscribePromoModalShown);
            if (isVisible) {
                (0,manager/* openModal */.h7)("resubscribePromoModal", {
                    priority: priority
                });
                return true;
            }
        };
        var mobileAppModal = function(priority) {
            var _shownPopups_mobileAppModal;
            var isVisible = !(shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_mobileAppModal = shownPopups.mobileAppModal) === null || _shownPopups_mobileAppModal === void 0 ? void 0 : _shownPopups_mobileAppModal.lastUpdated) && isMobile;
            if (isVisible) {
                (0,manager/* openModal */.h7)("mobileAppModal", {
                    priority: priority
                });
                return true;
            }
        };
        var featuredBrandModal = function(priority) {
            var _shownPopups_;
            var gender = user === null || user === void 0 ? void 0 : user.gender;
            var isVisibleForGender = strapiWSTOModalWithProductsOptions && gender ? strapiWSTOModalWithProductsOptions.genders.includes(gender) : true;
            var isVisible = isStrapiWSTOEnabled && isVisibleForGender && !(shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_ = shownPopups["featuredBrandModal-".concat(strapiWSTOBrandSlug)]) === null || _shownPopups_ === void 0 ? void 0 : _shownPopups_.lastUpdated);
            if (isVisible) {
                (0,manager/* openModal */.h7)("featuredBrandModal", {
                    priority: priority
                });
                return true;
            }
        };
        var driftEcommercePromoModal = function(priority) {
            var _shownPopups_driftPromoModal;
            var isVisible = isDriftEcommercePromoEnabled && !isDriftSubscriptionEnabled && !(shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_driftPromoModal = shownPopups["driftPromoModal"]) === null || _shownPopups_driftPromoModal === void 0 ? void 0 : _shownPopups_driftPromoModal.lastUpdated);
            if (isVisible) {
                (0,manager/* openModal */.h7)("driftPromoModal", {
                    priority: priority
                });
                return true;
            }
        };
        var collaborationModal = function(priority) {
            var _shownPopups_scentbirdSelectModal;
            if (!isSaksCollaborationEnabled) {
                return;
            }
            if (!(shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_scentbirdSelectModal = shownPopups.scentbirdSelectModal) === null || _shownPopups_scentbirdSelectModal === void 0 ? void 0 : _shownPopups_scentbirdSelectModal.lastUpdated)) {
                (0,manager/* openModal */.h7)("scentbirdSelectModal", {
                    priority: priority
                });
                return true;
            }
        };
        var limitedDropModal = function(priority) {
            var _shownPopups_;
            var isVisible = isLimitedDropsEnabled && (limitedDrop === null || limitedDrop === void 0 ? void 0 : limitedDrop.status) === "LIVE" && !(limitedDrop === null || limitedDrop === void 0 ? void 0 : limitedDrop.hasReachedBurndown) && !(shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_ = shownPopups["limitedDropModal-".concat(limitedDrop === null || limitedDrop === void 0 ? void 0 : limitedDrop.uid)]) === null || _shownPopups_ === void 0 ? void 0 : _shownPopups_.lastUpdated);
            if (isVisible) {
                (0,manager/* openModal */.h7)("limitedDropModal", {
                    priority: priority
                });
                return true;
            }
        };
        var caseSubscriptionPromoModal = function(priority) {
            var _shownPopups_caseSubscriptionPromoModal;
            var lastUpdated = shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_caseSubscriptionPromoModal = shownPopups.caseSubscriptionPromoModal) === null || _shownPopups_caseSubscriptionPromoModal === void 0 ? void 0 : _shownPopups_caseSubscriptionPromoModal.lastUpdated;
            var isVisible = isMainPage && (caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.isEnabled) && !(caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.isSelected) && (!lastUpdated || (0,difference/* getElapsedTime */.q)(lastUpdated, "months") >= 1);
            if (isVisible) {
                (0,manager/* openModal */.h7)("caseSubscriptionPromoModal", {
                    priority: priority
                });
                return true;
            }
        };
        var driftSubscriptionPromoModal = function(priority) {
            var _shownPopups_driftSubscriptionPromoModal;
            var lastUpdated = shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_driftSubscriptionPromoModal = shownPopups.driftSubscriptionPromoModal) === null || _shownPopups_driftSubscriptionPromoModal === void 0 ? void 0 : _shownPopups_driftSubscriptionPromoModal.lastUpdated;
            var isVisible = isMainPage && isDriftSubscriptionEnabled && (driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isEnabled) && !(driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isSelected) && (!lastUpdated || (0,difference/* getElapsedTime */.q)(lastUpdated, "months") >= 1);
            if (isVisible) {
                (0,manager/* openModal */.h7)("driftSubscriptionPromoModal", {
                    priority: priority
                });
                return true;
            }
        };
        var continueMobileAppModal = function(priority) {
            var haveShown = Boolean(shownPopups === null || shownPopups === void 0 ? void 0 : shownPopups.continueMobileAppModal);
            var isVisible = isMobileAppEntrypointModalEnabled && (subscription === null || subscription === void 0 ? void 0 : subscription.isActive) && !haveShown && isMobile && (isMainPage || pathname === links/* default */.ZP.subscription.perfumes || pathname === links/* default */.ZP.subscription.colognes);
            if (isVisible) {
                (0,manager/* openModal */.h7)("continueMobileAppModal", {
                    priority: priority
                });
                return true;
            }
        };
        var scentbirdAcademyModal = function(priority) {
            var _shownPopups_scentbirdAcademyModal;
            var wasShown = (shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_scentbirdAcademyModal = shownPopups.scentbirdAcademyModal) === null || _shownPopups_scentbirdAcademyModal === void 0 ? void 0 : _shownPopups_scentbirdAcademyModal.count) > 0;
            var isVisible = isMainPage && isScentbirdAcademyPopupEnabled && !wasShown // once
            ;
            if (isVisible) {
                var popupId = "scentbirdAcademyModal";
                (0,manager/* openModal */.h7)(popupId, {
                    priority: priority,
                    onClose: function() {
                        return void setPopupShown(popupId);
                    }
                });
                return true;
            }
        };
        var modalsOrder = [
            resubscribePromoModal,
            verifyShippingAddressModal,
            firstTimeVisitModal,
            cardUpdateModal,
            scentbirdAcademyModal,
            driftSubscriptionPromoModal,
            driftEcommercePromoModal,
            caseSubscriptionPromoModal,
            lastShipmentReviewModal,
            candleSubscriptionPromoModalShownCount === 0 && candleSubscriptionPromoModal,
            tryTwoThreeFragrancesModal,
            privateSaleModal,
            tossInModal,
            mobileAppModal,
            candleSubscriptionPromoModalShownCount > 0 && candleSubscriptionPromoModal,
            limitedDropModal,
            collaborationModal,
            featuredBrandModal,
            inviteModal,
            continueMobileAppModal
        ].filter(Boolean);
        modalsOrder.some(function(checker, index) {
            return checker(index + 1);
        });
        modalWasOpenRef.current = true;
    }, [
        shownPopups,
        setPopupShown,
        subscription,
        user,
        isLoggedIn,
        pathname,
        privateSale,
        unratedProduct,
        limitedDrop,
        isMobile,
        isFetching,
        isDriftEcommercePromoEnabled,
        isUnratedProductFetching,
        isCandleSubscriptionEnabled,
        isDriftSubscriptionEnabled,
        isStrapiWSTOEnabled,
        isSaksCollaborationEnabled,
        isLimitedDropFetching,
        isLimitedDropsEnabled,
        candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isEnabled,
        candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isSelected,
        caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.isEnabled,
        caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.isSelected,
        driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isEnabled,
        driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isSelected,
        strapiWSTOBrandSlug,
        strapiWSTOModalWithProductsOptions,
        isMobileAppEntrypointModalEnabled,
        isQueueUpgradePopupEnabled,
        isScentbirdAcademyCourseFetching,
        isScentbirdAcademyPopupEnabled,
        availableReferralInvites
    ]);
    return null;
};
/* harmony default export */ const SubscriptionModals_SubscriptionModals = (SubscriptionModals);

;// CONCATENATED MODULE: ./src/containers/SubscriptionLayout/SubscriptionLayout.tsx



var SubscriptionLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionModals_SubscriptionModals, {})
        ]
    });
};
/* harmony default export */ const SubscriptionLayout_SubscriptionLayout = (SubscriptionLayout);


/***/ }),

/***/ 33349:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Uj: () => (/* binding */ buildTransport),
/* harmony export */   Yd: () => (/* binding */ Logger),
/* harmony export */   hs: () => (/* binding */ composeError)
/* harmony export */ });
/* unused harmony exports mapError, mapHttpRequest, mapHttpResponse */
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var mapError = function(err) {
    if (!_instanceof(err, Error)) {
        return err;
    }
    var res = {
        type: err.name,
        message: err.message,
        stack: err.stack
    };
    if (err.hasOwnProperty("cause")) {
        var cause = mapError(err.cause);
        if (cause) {
            res.cause = cause;
        }
    }
    return res;
};
var mapHttpRequest = function(req) {
    var connection = req.socket;
    return {
        method: req.method,
        url: req.url,
        // @ts-ignore
        path: req.path,
        // @ts-ignore
        query: req.query,
        // headers: req.headers,
        remoteAddress: connection.remoteAddress,
        remotePort: connection.remotePort
    };
};
var mapHttpResponse = function(res) {
    return {
        code: res.statusCode
    };
};
function tryStringify(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return '"[Circular]"';
    }
}
var format = function(message, args, options) {
    var sf = (options === null || options === void 0 ? void 0 : options.stringify) || tryStringify;
    if (!message) {
        return message;
    }
    if (typeof message !== "string") {
        return sf(message);
    }
    var argIndex = 0;
    var argLength = args.length;
    var length = message.length;
    var result = "";
    for(var i = 0; i < length; i++){
        var char = message.charAt(i);
        if (char !== "%" || i === length - 1) {
            result += char;
            continue;
        }
        var tCharCode = message.charCodeAt(i + 1);
        var replaced = false;
        i++;
        if (argIndex < argLength) {
            var arg = args[argIndex];
            switch(tCharCode){
                case 100:
                case 102:
                    if (arg) {
                        result += Number(arg);
                        replaced = true;
                    }
                    break;
                case 105:
                    if (arg) {
                        result += Math.floor(arg);
                        replaced = true;
                    }
                    break;
                case 79:
                case 111:
                case 106:
                    if (arg === void 0) {
                        break;
                    }
                    var type = typeof arg === "undefined" ? "undefined" : _type_of(arg);
                    if (type === "string") {
                        result += "'".concat(arg, "'");
                    } else if (type === "function") {
                        result += arg.name || "<anonymous>";
                    } else {
                        result += sf(arg);
                    }
                    replaced = true;
                    break;
                case 115:
                    result += String(arg);
                    replaced = true;
                    break;
            }
            if (tCharCode === 37) {
                result += char;
                replaced = true;
            } else {
                argIndex++;
            }
        }
        if (!replaced) {
            result += "".concat(char).concat(String.fromCharCode(tCharCode));
        }
    }
    return result;
};
var levels = {
    fatal: 0,
    error: 1,
    warn: 2,
    info: 3,
    debug: 4,
    trace: 5
};
var isLevelEnabled = function(entryLevel, baseLevel) {
    return levels[entryLevel] <= levels[baseLevel];
};
var asString = function(value) {
    try {
        return JSON.stringify(value);
    } catch (error) {
        return "[Circular]";
    }
};
var composeError = function(obj) {
    var error = new Error(obj.message);
    error.stack = obj.stack;
    error.name = obj.name || error.name;
    if (obj.cause) {
        error.cause = composeError(obj.cause);
    }
    return error;
};
var Logger = /*#__PURE__*/ function() {
    "use strict";
    function Logger() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, Logger);
        _define_property(this, "_level", void 0);
        _define_property(this, "_mixin", void 0);
        _define_property(this, "_serializers", void 0);
        _define_property(this, "_transports", []);
        _define_property(this, "_bindings", "");
        _define_property(this, "_messageKey", "message");
        _define_property(this, "_errorKey", "error");
        _define_property(this, "fatal", this.createLogFn("fatal"));
        _define_property(this, "error", this.createLogFn("error"));
        _define_property(this, "warn", this.createLogFn("warn"));
        _define_property(this, "info", this.createLogFn("info"));
        _define_property(this, "debug", this.createLogFn("debug"));
        _define_property(this, "trace", this.createLogFn("trace"));
        this._level = options.level || "trace";
        this._mixin = options.mixin;
        this._serializers = _object_spread(_define_property({}, this._errorKey, mapError), options.serializers);
        this._transports = options.transports || [];
    }
    _create_class(Logger, [
        {
            key: "close",
            value: function close() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this__transports;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(((_this__transports = _this._transports) === null || _this__transports === void 0 ? void 0 : _this__transports.length) > 0)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    Promise.allSettled(_this._transports.map(function(t) {
                                        return t.close();
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "child",
            value: function child(bindings) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var serializers = Object.assign({}, this._serializers, options.serializers);
                var composedOptions = {
                    level: options.level || this._level,
                    mixin: options.mixin || this._mixin || void 0,
                    serializers: serializers,
                    // we don't support transport changing for child logger
                    transports: this._transports
                };
                var child = new Logger(composedOptions);
                child._bindings = child.asJsonPart(bindings);
                return child;
            }
        },
        {
            key: "level",
            get: function get() {
                return this._level;
            },
            set: function set(value) {
                this._level = value || "trace";
            }
        },
        {
            key: "bindings",
            value: function bindings() {
                return JSON.parse("{".concat(this._bindings || ""));
            }
        },
        {
            key: "createLogFn",
            value: function createLogFn(level) {
                var _this = this;
                return function(o) {
                    for(var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        n[_key - 1] = arguments[_key];
                    }
                    if (typeof o === "object") {
                        var msg = o;
                        if (o !== null) {
                            if (o.method && o.headers && o.socket) {
                                o = mapHttpRequest(o);
                            } else if (typeof o.setHeader === "function") {
                                o = mapHttpResponse(o);
                            }
                        }
                        var formatParams;
                        if (msg === null && n.length === 0) {
                            formatParams = [
                                null
                            ];
                        } else {
                            msg = n.shift();
                            formatParams = n;
                        }
                        _this.write(o, format(msg, formatParams, _this.formatOptions), level);
                    } else {
                        var msg1 = o === void 0 ? n.shift() : o;
                        _this.write(null, format(msg1, n, _this.formatOptions), level);
                    }
                };
            }
        },
        {
            key: "formatOptions",
            get: function get() {
                return void 0;
            }
        },
        {
            key: "write",
            value: function write(_obj, msg, level) {
                if (!isLevelEnabled(level, this._level)) {
                    return;
                }
                var messageField = this._messageKey;
                var errorField = this._errorKey;
                var obj;
                if (_obj === void 0 || _obj === null) {
                    obj = {};
                } else if (_instanceof(_obj, Error)) {
                    obj = _define_property({}, errorField, _obj);
                    if (msg === void 0) {
                        msg = _obj.message;
                    }
                } else {
                    obj = _obj;
                    if (msg === void 0 && !obj[messageField] && obj[errorField]) {
                        msg = obj[errorField].message;
                    }
                }
                if (this._mixin) {
                    Object.assign(obj, this._mixin(obj, level, this));
                }
                var str = this.asJson(obj, msg, level, /* @__PURE__ */ new Date().toISOString());
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._transports[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        try {
                            if (isLevelEnabled(level, t.level)) {
                                t.write(str);
                            }
                        } finally{}
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "asJsonPart",
            value: function asJsonPart(obj) {
                var serializers = this._serializers;
                var value;
                var propString = "";
                for(var key in obj){
                    value = obj[key];
                    if (Object.prototype.hasOwnProperty.call(obj, key) && value !== void 0) {
                        if (serializers[key]) {
                            value = serializers[key](value);
                        }
                        var tValue = typeof value === "undefined" ? "undefined" : _type_of(value);
                        if (tValue === "function" || tValue === "undefined") {
                            continue;
                        }
                        if (tValue === "number" || tValue === "boolean") {
                            if (tValue === "number" && Number.isFinite(value) === false) {
                                value = null;
                            }
                        } else {
                            value = asString(value);
                        }
                        if (value === void 0) {
                            continue;
                        }
                        var strKey = asString(key);
                        propString += "," + strKey + ":" + value;
                    }
                }
                return propString;
            }
        },
        {
            /**
   * Generates JSON string from log event info, applying serializers, stringifiers to redact data
   */ key: "asJson",
            value: function asJson(obj, msg, level, time) {
                var start = '"level":'.concat(asString(level), ',"time":').concat(asString(time));
                var bindings = this._bindings;
                var propString = this.asJsonPart(obj);
                var msgString = this.asJsonPart(_define_property({}, this._messageKey, msg));
                return "{".concat(start).concat(bindings).concat(msgString).concat(propString, "}\n");
            }
        }
    ]);
    return Logger;
}();
var buildTransport = function(fn) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var parse = options.parse, close = options.close, _options_level = options.level, level = _options_level === void 0 ? "trace" : _options_level;
    return {
        level: level,
        write: function(json) {
            try {
                var source = parse ? JSON.parse(json) : json;
                fn(source);
            } catch (error) {
                console.error(error);
            }
        },
        close: /*#__PURE__*/ _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(typeof close === "function")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            close()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })
    };
};
 //# sourceMappingURL=index.js.map


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [532,1262,8383,6113,6556,7369,6471,5529,6102,255,8371,7936,3169,8101,442,1132,2229,1223,8118,1008,397,2857,5855,6012,9025,5047,60], () => (__webpack_exec__(22406)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);